/* Portuguese (pt-BR) dictionary for the builder.
 *
 * Same keys as EN and ES in ./index.ts; the parity test
 * (src/__tests__/i18n-keys.test.ts) fails if one is missing.
 * First version machine-translated from EN/ES (2026-10-16); pending
 * review by a native speaker.
 */

export const PT: Record<string, string> = {
  // Component gallery (Fase D, look v3, 2026-10-24).
  "gallery.count": "{entries} exemplos · {components} componentes",
  "gallery.search": "Buscar componente, tabela, filtro…",
  "gallery.clearSearch": "Limpar busca",
  "gallery.animations": "Animações",
  "gallery.replay": "Reiniciar exemplos",
  "gallery.examples": "{count} exemplos",
  "gallery.sampleData": "Dados de exemplo · interação opcional",
  "gallery.searchResults": "Resultados da busca",
  "gallery.backToFamily": "← Ver toda a família",
  "gallery.empty.title": "Não encontramos esse componente",
  "gallery.empty.hint": "Tente «KPI», «Tabela», «Data» ou «Botão».",
  "gallery.component": "Componente",
  "gallery.composition": "Composição",
  "gallery.composedOf": "Formada por {parts}",
  "gallery.preview": "Pré-visualização",
  "gallery.interactive.on": "Interação ativa",
  "gallery.interactive.off": "Interação desativada",
  "gallery.interactive.aria": "Interação de {title}",
  "gallery.expand": "Expandir {label}",
  "gallery.categoriesNav": "Categorias de componentes",
  "gallery.copyImport": "Copiar import",
  "gallery.copied": "Copiado",
  "gallery.source.ui": "UI kit",
  "gallery.source.bi": "Componentes de BI",
  "gallery.source.render": "Render de relatórios",
  "gallery.source.admin": "UI de operador",
  "gallery.demoError": "Não foi possível mostrar este componente: {message}",
  "gallery.missing": "Exports do kit sem exemplo: {names}",
  "gallery.unknownCategory": "Não existe a categoria «{category}».",
  "gallery.exploreData": "Explorar dados",
  "gallery.noData": "Sem dado",
  "gallery.group.system": "Sistema",
  "gallery.group.data": "Dados e relatórios",
  "gallery.group.composition": "Composição",
  "gallery.category.foundation": "Fundamentos",
  "gallery.category.navigation": "Navegação",
  "gallery.category.controls": "Controles",
  "gallery.category.surfaces": "Cartões e estados",
  "gallery.category.feedback": "Mensagens e painéis",
  "gallery.category.layout": "Estrutura do app",
  "gallery.category.drag": "Arrastar e carregar",
  "gallery.category.kpis": "Indicadores KPI",
  "gallery.category.charts": "Gráficos",
  "gallery.category.tables": "Tabelas",
  "gallery.category.filters": "Filtros e seleção",
  "gallery.category.dates": "Datas e períodos",
  "gallery.category.measures": "Medidores e contexto",
  "gallery.category.maps": "Mapas",
  "gallery.category.compositions": "Composições de relatório",
  "gallery.category.motion-page": "Movimento · página",
  "gallery.category.transitions": "Movimento · elementos",
  "gallery.category.brand": "Tokens do motor",
  "gallery.foundation.palette.title": "A linguagem visual",
  "gallery.foundation.palette.text": "Navy para orientar, rosa para agir, a cor do módulo para ler os dados.",
  "gallery.foundation.usage.ink": "Navegação e títulos",
  "gallery.foundation.usage.pink": "Ação e marca",
  "gallery.foundation.usage.violet": "Controles e séries",
  "gallery.foundation.usage.module": "Cor do módulo",
  "gallery.foundation.usage.canvas": "Fundo do app",
  "gallery.foundation.usage.border": "Divisores e cartões",
  "gallery.foundation.type.title": "Tipografia",
  "gallery.foundation.type.sample": "Os dados, mais claros.",
  "gallery.foundation.type.text": "Inter para controles e leitura. Nunito Sans para títulos e indicadores. Texto secundário com contraste suficiente para lê-lo.",
  "gallery.foundation.surfaces.title": "Superfícies e espaço",
  "gallery.foundation.radius.field": "Campo",
  "gallery.foundation.radius.control": "Controle",
  "gallery.foundation.radius.card": "Cartão",
  "gallery.foundation.radius.panel": "Painel",
  "gallery.foundation.inContext": "Componentes em contexto",
  "common.cancel": "Cancelar",
  "common.save": "Salvar",
  "common.delete": "Excluir",
  "common.create": "Criar",
  "common.edit": "Editar",
  "common.loading": "Carregando…",
  "drill.title": "Análise",
  "drill.noData": "Sem dados para esta análise.",
  "drill.closeAnalysis": "Fechar análise",
  "drill.close": "Fechar",
  "drill.fromKpi": "↑ do KPI",
  "table.rowDrill.label": "↳ Detalhe da linha",
  "table.close": "Fechar",
  "common.error": "Algo deu errado",
  "common.retry": "Tentar novamente",
  "common.missingLabel": "Este valor ainda não tem rótulo. Mostrando o que o backend enviou.",
  "common.confirm": "Confirmar",
  "login.title": "Digital Shelf Analytics",
  "login.subtitle": "Entre para gerenciar as definições dos relatórios",
  "login.email": "E-mail",
  "login.password": "Senha",
  "login.submit": "Entrar",
  "login.invalid": "E-mail ou senha inválidos",
  "list.title": "Relatórios e projetos",
  "list.subtitle": "Todo relatório pertence a um projeto. Crie projetos e depois adicione relatórios a eles.",
  "list.new": "Novo relatório",
  "list.newProject": "Novo projeto",
  "list.addReport": "Relatório",
  "list.noReportsInProject": "Ainda não há relatórios neste projeto. Use \"+ relatório\" para adicionar um.",
  "list.reorderHint": "Arraste as linhas para definir a ordem da barra lateral do portal. As mudanças entram no ar em cerca de um minuto.",
  "list.reorderSaved": "Ordem salva.",
  "list.reorderError": "Não foi possível salvar a ordem. A ordem anterior foi restaurada.",
  "list.dragHandle": "Arraste para reordenar",
  "list.empty": "Ainda não há projetos. Clique em \"+ Novo projeto\" para criar o primeiro.",
  "home.title": "Projetos",
  "home.subtitle": "Um cartão por projeto. Os relatórios ficam dentro de cada projeto.",
  "home.search": "Buscar projetos…",
  "home.reports": "relatórios",
  "home.published": "publicados",
  "home.unassigned": "Sem classificação",
  "home.unassigned.desc": "Rascunhos que ainda não pertencem a nenhum projeto.",
  "hub.back": "Projetos",
  "hub.tab.reports": "Relatórios",
  "hub.tab.config": "Configurações",
  "common.saved": "Salvo",
  "iconPicker.search": "Buscar ícones…",
  "iconPicker.count": "{total} ícones",
  "iconPicker.countFiltered": "{shown} de {total} ícones",
  "iconPicker.noResults": "Nenhum ícone corresponde.",
  "list.create.icon": "Ícone (opcional)",
  "editor.report.iconLabel": "Ícone",
  "hub.scope.title": "O que se configura onde",
  "hub.scope.projectLabel": "Projeto",
  "hub.scope.projectItems": "Dados (OBT), auto-refresh, arquivos mestre, arquivos, acessos, ícone/cor.",
  "hub.scope.reportLabel": "Relatório",
  "hub.scope.reportItems": "Dashboard, views SQL, conhecimento de IA, chat, insights, snapshots.",
  "editor.ai.panes.overview": "Visão geral",
  "editor.ai.panes.knowledge": "Conhecimento",
  "editor.ai.panes.chat": "Chat",
  "editor.ai.panes.insights": "Insights",
  "editor.ai.overview.enabledTitle": "IA ativa neste relatório",
  "editor.ai.overview.enabledHint": "O portal mostra Chat + Análise de IA aos usuários inscritos (conforme suas permissões).",
  "editor.ai.overview.knowledgeDesc": "O que a IA sabe sobre este relatório. Alimenta o chat E os insights. Configure uma única vez.",
  "editor.ai.overview.chatDesc": "A superfície conversacional na barra lateral do portal.",
  "editor.ai.overview.insightsDesc": "A narrativa da Análise de IA, regenerada a cada novo período.",
  "editor.ai.overview.knowledgeCounts": "{docs} docs · {examples} exemplos",
  "editor.ai.overview.focusCount": "{count} áreas de foco",
  "editor.ai.overview.promptOverrideOn": "Prompt personalizado: ativo",
  "editor.ai.overview.promptOverrideOff": "Prompt personalizado: usa o global",
  "editor.ai.overview.modelDefault": "Modelo: padrão global",
  "editor.ai.overview.modelOverride": "Modelo: {model}",
  "editor.ai.overview.chatCounts": "{questions} perguntas iniciais · {ctas} CTAs",
  "editor.ai.overview.specCount": "{count} specs de insights",
  "editor.ai.overview.temporalMode": "Janela temporal por relatório",
  "editor.ai.overview.weeklyMode": "Modo semanal legado",
  "editor.ai.overview.maxInsights": "máx. {count} insights por snapshot",
  "editor.ai.overview.contextNotesHint": "As notas de contexto (eventos de negócio) ficam no nível do PROJETO e valem para todos os seus relatórios.",
  "editor.ai.overview.open": "Abrir",
  "editor.ai.aiHomeTime.title": "Home com IA: tempo",
  "editor.ai.aiHomeRef.title": "Home com IA: KPIs e gráficos de referência",
  "editor.ai.aiHomeRef.description": "As medidas oficiais deste relatório. Quando alguém pede uma delas, o Home com IA usa este SQL como está em vez de escrever outro, e a revisão de IA nunca o reescreve.",
  "editor.ai.aiHomeRef.placeholders": "Tempo: {asOf} (o último período) e {since} (o início do intervalo), nunca uma data escrita. Filtros do dashboard: marque cada coluna com {filter} em um WHERE; uma marca que nenhum filtro usa vale TRUE.",
  "editor.ai.aiHomeRef.add": "Adicionar",
  "editor.ai.aiHomeRef.fromExample": "De um exemplo Q&A",
  "editor.ai.aiHomeRef.fromExampleHint": "Substitua qualquer data escrita pelos placeholders de tempo.",
  "editor.ai.aiHomeRef.noExamples": "Este relatório ainda não tem exemplos SQL.",
  "editor.ai.aiHomeRef.empty": "Sem referências: o Home com IA desenha cada elemento.",
  "editor.ai.aiHomeRef.untitled": "Sem título",
  "editor.ai.aiHomeRef.titleLabel": "Título",
  "editor.ai.aiHomeRef.kindLabel": "Tipo",
  "editor.ai.aiHomeRef.formatLabel": "Formato",
  "editor.ai.aiHomeRef.format.number": "Número",
  "editor.ai.aiHomeRef.format.percent": "Percentual (0..1)",
  "editor.ai.aiHomeRef.format.currency": "Moeda",
  "editor.ai.aiHomeRef.scopeSafe": "Válido com escopos restritos",
  "editor.ai.aiHomeRef.test": "Testar com o último período",
  "editor.ai.aiHomeRef.testing": "Executando…",
  "editor.ai.aiHomeRef.runs": "Executa · {value}",
  "editor.ai.aiHomeRef.rows_one": "{count} linha",
  "editor.ai.aiHomeRef.rows_other": "{count} linhas",
  "editor.ai.aiHomeRef.fails": "Não executa",
  "editor.ai.aiHomeRef.filters": "filtros que aceita: {columns}",
  "editor.ai.aiHomeRef.noFilters": "não aceita filtros do dashboard",
  "editor.ai.aiHomeRef.remove": "Remover",
  "editor.ai.aiHomeRef.publishNote": "Publicar executa cada referência: uma que não executa bloqueia.",
  "editor.ai.aiHomeTime.baseTitle": "Home com IA: tempo da tabela base",
  "editor.ai.aiHomeTime.baseDescription": "Com uma regra, o Home com IA pode usar todos os dados do projeto (também a tabela base). Sem regra, usa só os relatórios.",
  "editor.ai.aiHomeTime.description": "Como o Home com IA lê as datas deste relatório. Sempre relativo aos dados mais recentes: um dashboard salvo aberto amanhã mostra os dados de amanhã.",
  "editor.ai.aiHomeTime.missing": "Obrigatório: sem isto o relatório não é publicado e não aparece no Home com IA.",
  "editor.ai.aiHomeTime.modeLabel": "Como lê o tempo",
  "editor.ai.aiHomeTime.modeHint": "Último período para relatórios de foto do dia (estoque, disponibilidade); intervalo para relatórios lidos ao longo do tempo.",
  "editor.ai.aiHomeTime.modeUnset": "Escolha…",
  "editor.ai.aiHomeTime.mode.day": "Último período",
  "editor.ai.aiHomeTime.mode.range": "Intervalo de períodos recentes",
  "editor.ai.aiHomeTime.mode.none": "Sem dimensão de tempo",
  "editor.ai.aiHomeTime.dateColumnLabel": "Coluna de data",
  "editor.ai.aiHomeTime.dateColumnHint": "Uma data, ou uma semana ou mês ISO como texto (week_iso, month_iso).",
  "editor.ai.aiHomeTime.anchorLabel": "Tabela âncora",
  "editor.ai.aiHomeTime.anchorHint": "Seu último valor da coluna de data é o último período.",
  "editor.ai.aiHomeTime.periodsLabel": "Períodos",
  "editor.ai.aiHomeTime.periodsHint": "Quantos períodos uma tendência (último período) ou cada elemento (intervalo) lê.",
  "editor.ai.aiHomeTime.completenessToggle": "Perguntar antes de montar se o último período estiver incompleto",
  "editor.ai.aiHomeTime.completenessHint": "Incompleto = menos linhas que a porcentagem abaixo em relação à mediana dos períodos anteriores.",
  "editor.ai.aiHomeTime.completenessOff": "Desligado: o último período é sempre mostrado como está.",
  "editor.ai.aiHomeTime.minRatioLabel": "Mínimo em relação a um período normal (%)",
  "editor.ai.aiHomeTime.baselineLabel": "Períodos anteriores comparados",
  "editor.ai.advanced": "Avançado",
  "editor.ai.blocks.what": "O que analisa",
  "editor.ai.blocks.when": "Como e quando",
  "editor.ai.blocks.results": "Resultados",
  "nav.admin.users": "Usuários e permissões",
  "nav.admin.access": "Acessos",
  "adminUsers.title": "Usuários e permissões",
  "adminUsers.subtitle": "Contas do portal, inscrições em relatórios e a matriz de permissões.",
  "adminUsers.tab.users": "Usuários",
  "adminUsers.tab.defaults": "Padrões por perfil",
  "adminUsers.create": "Novo usuário",
  "adminUsers.allRoles": "Todos os perfis",
  "adminUsers.usersCount": "{count} usuários",
  "adminUsers.table.name": "Nome",
  "adminUsers.table.email": "E-mail",
  "adminUsers.table.role": "Perfil",
  "adminUsers.table.subscriptions": "Inscrições",
  "adminUsers.table.overrides": "Exceções",
  "adminUsers.table.builder": "Builder",
  "adminUsers.table.status": "Status",
  "adminUsers.table.actions": "Ações",
  "adminUsers.builderFull": "completo",
  "adminUsers.builderPartial": "parcial",
  "adminUsers.builderFlag.can_enter": "Entrar no builder",
  "adminUsers.builderFlag.edit_projects": "Editar projetos e relatórios",
  "adminUsers.builderFlag.publish": "Publicar",
  "adminUsers.builderFlag.manage_ai": "IA (Panorama, prompts, issues)",
  "adminUsers.builderFlag.operations": "Operações (loader)",
  "adminUsers.builderFlag.manage_users": "Usuários e permissões",
  "adminUsers.noUsers": "Nenhum usuário corresponde.",
  "adminUsers.allProjects": "todos os relatórios",
  "adminUsers.subsCount": "{count} relatórios",
  "adminUsers.overridesCount": "{count} personalizadas",
  "adminUsers.active": "Ativo",
  "adminUsers.inactive": "Inativo",
  "adminUsers.permissions": "Permissões",
  "adminUsers.resetPassword": "Redefinir senha",
  "adminUsers.confirmDelete": "Excluir o usuário \"{name}\"? A conta é desativada (exclusão lógica).",
  "adminUsers.deleted": "Usuário excluído",
  "adminUsers.created": "Usuário criado",
  "adminUsers.updated": "Usuário atualizado",
  "adminUsers.passwordResetDone": "Senha redefinida",
  "adminUsers.prev": "Anterior",
  "adminUsers.next": "Próximo",
  "adminUsers.createTitle": "Novo usuário",
  "adminUsers.stepOf": "passo {current} de {total}",
  "adminUsers.fillRequired": "Preencha nome, e-mail e uma senha de pelo menos 8 caracteres.",
  "adminUsers.password": "Senha",
  "adminUsers.passwordMin": "Mínimo de 8 caracteres.",
  "adminUsers.generate": "Gerar",
  "adminUsers.back": "Voltar",
  "adminUsers.skip": "Pular",
  "adminUsers.initialAccessHelp": "Escolha os relatórios publicados em que este usuário começa inscrito.",
  "adminUsers.initialAccessNote": "Você pode ajustar as inscrições depois, em Permissões.",
  "adminUsers.noReports": "Não há relatórios publicados.",
  "adminUsers.editTitle": "Editar usuário",
  "adminUsers.cloneFromAnother": "Clonar permissões de outro usuário…",
  "adminUsers.cloneSource": "Copiar inscrições + exceções de",
  "adminUsers.cloneSelectUser": "Selecionar usuário…",
  "adminUsers.applyClone": "Aplicar",
  "adminUsers.cloneConfirm": "Substituir as inscrições e exceções de {name} pelas do usuário de origem?",
  "adminUsers.resetPrompt": "Gerar uma nova senha para {name}? A atual deixa de funcionar imediatamente.",
  "adminUsers.newPassword": "Nova senha",
  "adminUsers.passwordWarning": "Exibida uma única vez. Não há envio por e-mail (sem SMTP). Copie agora e compartilhe por um canal seguro.",
  "adminUsers.done": "Concluir",
  "adminUsers.saveCount": "Salvar ({count})",
  "adminUsers.defaults.subtitle": "Matriz base à qual cada perfil recorre quando um usuário não tem exceção explícita.",
  "adminUsers.defaults.adminNote": "O perfil admin ignora todas as verificações de permissão. Este cartão é apenas informativo.",
  "adminUsers.defaults.readonly": "somente leitura",
  "adminUsers.perms.title": "Permissões: {name}",
  "adminUsers.perms.action.view": "Ver",
  "adminUsers.perms.action.view_data": "Ver os dados",
  "adminUsers.perms.action.run_chat": "Usar o chat",
  "adminUsers.perms.action.run_ai_analysis": "Executar a análise de IA",
  "adminUsers.perms.action.send_report": "Enviar por e-mail",
  "adminUsers.perms.action.schedule_send": "Programar envios automáticos",
  "adminUsers.perms.action.upload": "Carregar",
  "adminUsers.perms.action.download": "Baixar",
  "adminUsers.perms.action.delete": "Excluir",
  "adminUsers.perms.subscribedOn": "Inscrito. Clique para remover",
  "adminUsers.perms.subscribedOff": "Não inscrito. Clique para adicionar",
  "adminUsers.perms.subscriptions": "Inscrições",
  "adminUsers.perms.subscriptionsHint": "As pílulas ativas são os relatórios que este usuário vê. Clique para alternar, salva na hora.",
  "adminUsers.perms.overridesTitle": "Exceções por relatório",
  "adminUsers.perms.noSubscriptions": "Sem inscrições. Ative primeiro uma pílula de relatório acima.",
  "adminUsers.perms.quickActions": "Ações rápidas",
  "adminUsers.perms.applyDefaults": "Aplicar padrões do perfil",
  "adminUsers.perms.clearAll": "Limpar todas as exceções",
  "adminUsers.perms.copyFrom": "Copiar de outro usuário…",
  "adminUsers.perms.confirmClearAll": "Remover todas as exceções explícitas? O usuário volta aos padrões puros do perfil.",
  "adminUsers.perms.noOverridesToClear": "Não há exceções para limpar.",
  "adminUsers.perms.adminNote": "Admins ignoram todas as verificações. A matriz só vale para o perfil de usuário.",
  "adminUsers.perms.legend": "Cada clique alterna a célula: padrão (·) → concedido (✓) → negado (✕).",
  "adminUsers.perms.builderAccessTitle": "Acesso ao builder",
  "adminUsers.perms.builderAccessHint": "O que este usuário pode fazer dentro DESTE console. Salva a cada alternância.",
  "adminUsers.perms.builderAdminNote": "Admins sempre têm acesso total ao builder.",
  "adminUsers.perms.projectLevel": "Arquivos mestre e arquivos",
  "adminUsers.perms.projectLevelBadge": "nível de projeto",
  "adminUsers.perms.projectSectionsHint": "Estas células valem para todos os relatórios do projeto.",
  "adminUsers.perms.noProject": "Sem projeto",
  "adminUsers.perms.subscribed": "(inscrito)",
  "adminUsers.perms.defaultTitle": "padrão = {value}",
  "adminUsers.perms.granted": "concedido",
  "adminUsers.perms.denied": "negado",
  "hub.tab.access": "Acessos",
  "hub.access.title": "Quem pode ver este projeto",
  "hub.access.user": "Usuário",
  "hub.access.role": "Perfil",
  "hub.access.role.admin": "Admin",
  "hub.access.role.user": "Usuário",
  "hub.access.reports": "Relatórios",
  "hub.access.reportsOf": "{count} de {total} relatórios",
  "hub.access.overrides": "Exceções",
  "hub.access.edit": "Editar →",
  "hub.access.empty": "Nenhum usuário está inscrito nos relatórios deste projeto ainda.",
  "hub.access.adminNote": "Admins ignoram todas as verificações e não aparecem aqui.",
  "common.close": "Fechar",
  "nav.admin.panorama": "Panorama de IA",
  "hub.tab.ia": "IA do projeto",
  "editor.ai.panes.issues": "Issues",
  "panorama.title": "Panorama de IA",
  "panorama.subtitle": "Visão entre projetos de issues do chat, snapshots de IA e prompts globais.",
  "panorama.tab.overview": "Visão geral",
  "panorama.tab.issues": "Fila de issues",
  "panorama.tab.prompts": "Prompts globais",
  "panorama.kpi.open": "Issues abertas",
  "panorama.kpi.week": "Esta semana",
  "panorama.kpi.topReport": "Relatório principal",
  "panorama.kpi.topHeuristic": "Heurística principal",
  "panorama.chart.title": "Issues por semana",
  "panorama.chart.subtitle": "Últimos 60 dias",
  "panorama.map.title": "Onde cada coisa é gerenciada",
  "panorama.map.report": "Relatório",
  "panorama.map.reportItems": "Issues, snapshots e conhecimento de IA ficam no editor de cada relatório (aba IA).",
  "panorama.map.project": "Projeto",
  "panorama.map.projectItems": "As notas de contexto e o conhecimento do projeto ficam no hub do projeto (aba IA do projeto).",
  "panorama.map.global": "Global",
  "panorama.map.globalItems": "Os prompts globais e a fila de issues entre projetos ficam aqui.",
  "issues.filter.report": "Relatório",
  "issues.filter.allReports": "Todos os relatórios",
  "issues.filter.status": "Status",
  "issues.filter.allStatuses": "Todos os status",
  "issues.filter.heuristic": "Heurística",
  "issues.filter.allHeuristics": "Todas as heurísticas",
  "issues.total": "{count} issues",
  "issues.countAll": "{count} no total · {open} abertas",
  "issues.countFiltered": "{count} correspondem ao filtro",
  "issues.table.id": "ID",
  "issues.table.created": "Criada",
  "issues.table.report": "Relatório",
  "issues.table.heuristic": "Heurística",
  "issues.table.question": "Pergunta",
  "issues.table.status": "Status",
  "issues.empty": "Nenhuma issue corresponde aos filtros atuais.",
  "issues.pageOf": "Página {page} de {total}",
  "issues.prev": "Anterior",
  "issues.next": "Próxima",
  "issues.status.new": "Nova",
  "issues.status.in_review": "Em revisão",
  "issues.status.resolved": "Resolvida",
  "issues.status.dismissed": "Descartada",
  "issues.heuristic.tool_execution_error": "Erro de tool",
  "issues.heuristic.empty_result": "Resultado vazio",
  "issues.heuristic.max_iterations": "Máx. de iterações",
  "issues.heuristic.empty_response": "Resposta vazia",
  "issues.heuristic.llm_cannot_answer": "O LLM não consegue responder",
  "issues.heuristic.user_reformulation": "Reformulação do usuário",
  "issues.heuristic.user_thumbs_down": "Polegar para baixo do usuário",
  "issues.drawer.title": "Issue #{id}",
  "issues.drawer.question": "Pergunta",
  "issues.drawer.response": "Resposta do assistente",
  "issues.drawer.heuristicDetail": "Detalhe da heurística",
  "issues.drawer.toolCalls": "Chamadas de tools ({count})",
  "issues.drawer.resolutionNotes": "Notas de resolução",
  "issues.action.promote": "Promover a exemplo de treinamento",
  "issues.action.resolve": "Marcar como resolvida",
  "issues.action.dismiss": "Descartar",
  "issues.action.reopen": "Reabrir",
  "issues.promote.question": "Pergunta (como será armazenada)",
  "issues.promote.sql": "SQL (validado no servidor)",
  "issues.promote.save": "Salvar exemplo de treinamento",
  "issues.promote.required": "A pergunta e o SQL são obrigatórios.",
  "issues.notes": "Notas (opcional)",
  "issues.resolve.known_limitation": "Limitação conhecida",
  "issues.resolve.added_doc": "Documentação adicionada",
  "issues.resolve.wont_fix": "Não será corrigida",
  "issues.dismiss.wont_fix": "Não será corrigida",
  "issues.dismiss.duplicate": "Duplicada",
  "issues.dismiss.known_limitation": "Limitação conhecida",
  "snapshots.title": "Snapshots",
  "snapshots.description": "Snapshots persistidos da Análise de IA deste relatório. Regenerar, backfill e o watcher rodam no runtime do portal.",
  "snapshots.upToDate": "atualizado: {week}",
  "snapshots.trigger": "Executar watcher",
  "snapshots.triggerDone": "Watcher executado: {count} snapshots criados",
  "snapshots.backfill": "Backfill…",
  "snapshots.empty": "Ainda não há snapshots para este relatório.",
  "snapshots.col.week": "Semana",
  "snapshots.col.summary": "Resumo",
  "snapshots.col.insights": "Insights",
  "snapshots.col.feedback": "Feedback",
  "snapshots.col.regen": "Regenerar",
  "snapshots.col.actions": "Ações",
  "snapshots.view": "Ver",
  "snapshots.regenerate": "Regenerar",
  "snapshots.regenConfirm": "Regenerar este snapshot? Isso repete a chamada completa ao LLM no portal e sobrescreve o conteúdo.",
  "snapshots.detail.regenerated": "regenerado × {count}",
  "snapshots.detail.filters": "Filtros aplicados",
  "snapshots.detail.feedback": "Resumo do feedback",
  "snapshots.detail.comments": "comentários",
  "snapshots.detail.execSummary": "Resumo executivo",
  "snapshots.detail.insights": "Insights ({count})",
  "snapshots.backfill.title": "Backfill de snapshots",
  "snapshots.backfill.help": "Gera os snapshots que faltam para {key}. Deixe as duas datas em branco para usar os padrões do portal.",
  "snapshots.backfill.start": "Início",
  "snapshots.backfill.end": "Fim",
  "snapshots.backfill.run": "Iniciar",
  "snapshots.backfill.running": "Executando…",
  "snapshots.backfill.done": "Concluído: {created} novos snapshots",
  "snapshots.backfill.failed": "Falhou: {error}",
  "snapshots.backfill.progress": "{processed} / {total}",
  "projectIA.title": "IA do projeto",
  "projectIA.subtitle": "Notas de contexto e conhecimento no nível do projeto, compartilhados por todos os relatórios deste projeto.",
  "projectIA.back": "IA do projeto",
  "projectIA.row.notes": "Notas de contexto",
  "projectIA.row.notesDesc": "Eventos de negócio que a IA lê ao gerar cada snapshot.",
  "projectIA.row.column_docs": "Docs de colunas",
  "projectIA.row.column_docsDesc": "Documentação no nível de coluna que o chat de cada relatório vê como contexto.",
  "projectIA.row.synonyms": "Sinônimos",
  "projectIA.row.synonymsDesc": "Termos de negócio mapeados para valores de colunas, para o chat entender o jargão.",
  "projectIA.row.example": "Exemplos do projeto",
  "projectIA.row.exampleDesc": "Exemplos de perguntas e respostas válidos para todo o projeto, somados ao treinamento próprio de cada relatório.",
  "projectIA.activeCount": "{count} ativas",
  "projectIA.activeCountAtLeast": "{count}+ ativas",
  "projectIA.truncatedHint": "O endpoint de notas retorna no máximo 500 linhas, e esta tela as filtra por relatório depois. A lista está cortada e a contagem é um piso, não um total.",
  "projectIA.rowCount": "{count} linhas",
  "projectIA.manage": "Gerenciar",
  "notes.new": "Nova nota",
  "notes.filter.active": "Ativas",
  "notes.filter.archived": "Arquivadas",
  "notes.filter.all": "Todas",
  "notes.filter.report": "Relatório",
  "notes.filter.allReports": "Todos os relatórios",
  "notes.search": "Buscar por título ou conteúdo…",
  "notes.col.title": "Título",
  "notes.col.reports": "Relatórios",
  "notes.col.slice": "Recorte",
  "notes.col.window": "Janela",
  "notes.col.visibility": "Visibilidade",
  "notes.col.actions": "Ações",
  "notes.visibility.internal": "interna",
  "notes.visibility.mentionable": "mencionável",
  "notes.archived": "arquivada",
  "notes.empty": "Este projeto ainda não tem notas de contexto.",
  "notes.archive": "Arquivar",
  "notes.archiveConfirm": "Arquivar esta nota? Os snapshots históricos mantêm sua trilha de auditoria.",
  "notes.regen": "Regenerar afetados",
  "notes.modal.createTitle": "Nova nota",
  "notes.modal.editTitle": "Editar nota",
  "notes.field.title": "Título",
  "notes.field.body": "Detalhe do evento",
  "notes.field.reports": "Relatórios afetados",
  "notes.field.dateStart": "De (opcional)",
  "notes.field.dateEnd": "Até (opcional)",
  "notes.field.filters": "Filtros descritivos (opcional)",
  "notes.addFilter": "Adicionar filtro",
  "notes.filtersHint": "Descrevem ONDE o evento ocorreu. O LLM os lê como contexto, não como critério de correspondência.",
  "notes.field.referenceAllowed": "Permitir que o LLM mencione esta nota ao cliente",
  "notes.referenceAllowedHint": "Desmarcada, o LLM usa a nota como contexto interno, mas NÃO a menciona em sua narrativa. Útil para temas sensíveis (jurídicos, financeiros).",
  "notes.errors.titleRequired": "O título é obrigatório.",
  "notes.errors.bodyRequired": "O conteúdo é obrigatório.",
  "notes.errors.reportRequired": "Escolha pelo menos um relatório.",
  "notes.errors.dateOrder": "A data de início deve ser anterior à data de fim.",
  "notes.regen.title": "Regenerar snapshots afetados",
  "notes.regen.prompt": "{count} snapshots existentes se sobrepõem à janela de datas desta nota. Regenerá-los agora para que o LLM os refaça com o novo contexto?",
  "notes.regen.costHint": "Cada snapshot dispara uma chamada ao LLM. Reexecutar é seguro: os snapshots só são sobrescritos.",
  "notes.regen.start": "Regenerar",
  "notes.regen.none": "Não há snapshots para regenerar",
  "notes.regen.later": "Depois",
  "notes.regen.done": "Concluído: {count} regenerados",
  "notes.regen.failed": "Falhou: {error}",
  "knowledge.add": "Adicionar linha",
  "knowledge.empty": "Ainda não há linhas.",
  "knowledge.modal.addTitle": "Nova linha",
  "knowledge.modal.editTitle": "Editar linha",
  "knowledge.field.name": "Nome",
  "knowledge.field.content": "Conteúdo",
  "knowledge.contentRequired": "O conteúdo é obrigatório.",
  "knowledge.deleteConfirm": "Excluir esta linha?",
  "nav.admin.integrations": "Integrações",
  "nav.admin.sendPolicy": "Envio de relatórios",
  "sendPolicy.title": "Envio de relatórios por usuários do portal",
  "sendPolicy.subtitle": "O beta \"Enviar por e-mail\" do portal: quem pode receber, quanto e por meio de qual credencial. Desativado por padrão; uma lista de domínios vazia o mantém desativado em qualquer caso. Cada tentativa de envio é auditada abaixo.",
  "sendPolicy.enabled": "Ativar o envio de relatórios (beta)",
  "sendPolicy.neverConfigured": "Nunca configurado",
  "sendPolicy.needDomain": "Para ativar é preciso ao menos um domínio permitido. Adicione um abaixo antes de salvar.",
  "sendPolicy.needCredential": "Para ativar é preciso uma credencial de envio. Escolha uma abaixo (registre-a antes em Integrações).",
  "sendPolicy.loadFailed": "Não foi possível carregar a política de envio, por isso o formulário fica oculto: salvar agora sobrescreveria a política armazenada com valores vazios.",
  "sendPolicy.domains": "Domínios de destinatários permitidos",
  "sendPolicy.domainsHint": "Destinatários fora destes domínios são recusados, indicando o endereço. Lista vazia = recurso desativado.",
  "sendPolicy.removeDomain": "Remover {domain}",
  "sendPolicy.maxRecipients": "Máx. de destinatários por envio",
  "sendPolicy.quota": "Envios diários por usuário",
  "sendPolicy.quotaNone": "sem cota",
  "sendPolicy.quotaHint": "Vazio = sem cota (uma escolha explícita, não um padrão).",
  "sendPolicy.credential": "Credencial de envio (e-mail)",
  "sendPolicy.credentialNone": "Nenhuma escolhida",
  "sendPolicy.audit.title": "Auditoria de envios",
  "sendPolicy.audit.total": "{n} tentativas registradas",
  "sendPolicy.audit.empty": "Ainda não há tentativas de envio.",
  "sendPolicy.audit.pageOf": "Página {page} de {pages}",
  "sendPolicy.audit.prev": "Anterior",
  "sendPolicy.audit.next": "Próxima",
  "sendPolicy.outcome.queued": "Na fila",
  "sendPolicy.outcome.collapsed": "Unido a outro envio",
  "sendPolicy.outcome.schedule_queued": "Enfileirado por um agendamento",
  "sendPolicy.outcome.capture_token": "Token de captura de tela emitido",
  "sendPolicy.outcome.prompt_blocked": "Bloqueado pela proteção",
  "sendPolicy.outcome.sent": "Enviado",
  "sendPolicy.outcome.failed": "Falhou",
  "sendPolicy.outcome.dead": "Falhou (tentativas esgotadas)",
  "sendPolicy.outcome.reaped": "Desconhecido (interrompido)",
  "sendPolicy.outcome.schedule_skipped": "Não enviado (ignorado)",
  "sendPolicy.outcome.schedule_failed": "Não enviado (falhou antes de enviar)",
  "sendPolicy.outcome.unknown": "Este resultado ainda não tem rótulo. Mostrando o que o backend registrou.",
  "sendPolicy.audit.when": "Quando",
  "sendPolicy.audit.who": "Quem",
  "sendPolicy.audit.report": "Relatório",
  "sendPolicy.audit.recipients": "Destinatários",
  "sendPolicy.audit.extras": "Incluiu",
  "sendPolicy.audit.image": "imagem",
  "sendPolicy.audit.outcome": "Resultado",
  "delivery.field.credential": "Credencial do canal",
  "delivery.credential.pick": "Escolha uma credencial…",
  "delivery.credential.legacy": "Credencial configurada pelo operador (legada)",
  "delivery.credential.notNeeded": "Não necessária",
  "delivery.credential.noneAvailable": "Ainda não há credenciais de {channel} registradas. Registre uma em Integrações: o valor é armazenado uma vez e reutilizado por todos os agendamentos que a escolherem.",
  "delivery.credential.goToIntegrations": "Abrir Integrações",
  "delivery.error.credential": "Escolha uma credencial para este canal.",
  "integrations.title": "Integrações",
  "integrations.introShort": "Canais de comunicação e fontes de dados em um só lugar. Uma credencial é registrada uma vez aqui e reutilizada por toda inscrição ou projeto que apontar para ela.",
  "operations.jobStatus.pending": "Pendente",
  "operations.jobStatus.queued": "Na fila",
  "operations.jobStatus.running": "Em execução",
  "operations.jobStatus.completed": "Concluído",
  "operations.jobStatus.failed": "Falhou",
  "operations.jobStatus.skipped": "Ignorado",
  "integrations.intro": "Canais de comunicação e fontes de dados em um só lugar. Uma credencial é registrada uma vez aqui e reutilizada por toda inscrição ou projeto que apontar para ela, então girá-la é uma única ação, não uma por consumidor. Os valores são armazenados criptografados e nunca são exibidos novamente.",
  "integrations.tabs.channels": "Canais",
  "integrations.tabs.sources": "Fontes de dados",
  "integrations.comingSoon": "Em breve",
  "integrations.cancelBtn": "Cancelar",
  "integrations.deleteBtn": "Excluir",
  "integrations.testBtn": "Testar",
  "integrations.testing": "Testando...",
  "integrations.testOk": "OK",
  "integrations.testFailed": "O upstream recusou",
  "integrations.usedBy": "Usada por {count}:",
  "integrations.guide.title": "O que você faz no seu próprio sistema",
  "integrations.guide.warnings": "Vale saber antes de começar",
  "integrations.guide.docsLink": "Documentação oficial",
  "integrations.secret.configured": "Configurado",
  "integrations.secret.notConfigured": "Nenhum valor armazenado",
  "integrations.secret.notNeeded": "Nenhuma credencial necessária",
  "integrations.secret.fromEnv": "Valor em uma variável de ambiente",
  "integrations.secret.setBtn": "Definir valor",
  "integrations.secret.replaceBtn": "Substituir",
  "integrations.secret.saveBtn": "Salvar valor",
  "integrations.secret.saving": "Armazenando...",
  "integrations.secret.stored": "Valor armazenado para {name}. Não é exibido novamente.",
  "integrations.secret.firstNotice": "O valor é armazenado criptografado e nunca volta para esta tela: nem neste formulário, nem em um log, nem no detalhe de um job.",
  "integrations.secret.replaceNotice": "Já há um valor armazenado. Salvar o SUBSTITUI; não há nada para editar porque nada pode ser lido de volta. A referência não muda, então toda inscrição ou projeto que a use passa a usar o novo valor na próxima execução.",
  "integrations.backend.title": "O backend de segredos ainda não está ativado",
  "integrations.backend.intro": "Enquanto isso, os valores das credenciais não podem ser armazenados a partir desta tela. Esta é a única parte das integrações que não pode ser feita pela web: o backend em que um formulário web escreve precisa ser habilitado por variáveis de deploy. Os passos exatos:",
  "integrations.channels.addBtn": "Adicionar credencial",
  "integrations.channels.nameLabel": "Nome",
  "integrations.channels.nameHint": "Passa a fazer parte do caminho do segredo, por isso aceita letras minúsculas, dígitos, '.', '_' e '-'. Não pode ser alterado depois, pois o caminho é construído a partir dele.",
  "integrations.channels.descriptionLabel": "Descrição (opcional)",
  "integrations.channels.createBtn": "Registrar",
  "integrations.channels.unused": "Ainda não é usada por nenhuma inscrição.",
  "integrations.channels.deleteConfirm": "Excluir a credencial '{name}' e seu valor armazenado? A exclusão é recusada enquanto alguma inscrição ainda a usar.",
  "integrations.sources.title": "Conexões de fontes de dados",
  "integrations.sources.intro": "Uma conexão pode ser compartilhada com todos os projetos deste cliente ou pertencer a um só. Compartilhar é o que torna possível 'um warehouse, uma credencial' em vez de uma cópia por projeto.",
  "integrations.sources.empty": "Ainda não há conexões.",
  "integrations.sources.shared": "Compartilhada",
  "integrations.sources.ownedBy": "Somente {slug}",
  "integrations.sources.shareBtn": "Compartilhar com todos os projetos",
  "integrations.sources.unused": "Nenhum projeto aponta para ela ainda.",
  "integrations.sources.deleteConfirm": "Excluir a conexão '{name}'? A exclusão é recusada enquanto a fonte de dados de algum projeto ainda apontar para ela.",
  "integrations.sources.alsoShared": "+ {count} mais",
  "integrations.sources.grantBtn": "Compartilhar com…",
  "integrations.sources.grantTitle": "Permitir também que estes projetos usem '{name}'",
  "integrations.sources.grantHint": "O proprietário ({slug}) sempre pode. Compartilhar com todos os projetos é o botão ao lado. Desmarcar um projeto cuja fonte de dados ainda depende desta conexão é recusado, indicando o projeto.",
  "integrations.sources.grantNoOthers": "Ainda não há outro projeto.",
  "integrations.sources.grantSave": "Salvar compartilhamento",
  "integrations.sources.grantSaved": "Compartilhamento de '{name}' salvo.",
  "nav.admin.operations": "Operações",
  // «Caché» page (Administración → Caché, 2026-10-26).
  "nav.admin.cache": "Cache",
  "cache.title": "Cache",
  "cache.subtitle": "O que cada recarga calcula antes de publicar, para que os relatórios abram do cache.",
  "cache.day.title": "Pré-aquecimento do dia (estimativa)",
  "cache.day.breakdown": "Valores padrão {defaults} · todas as combinações +{extra} · {languages} idioma(s)",
  "cache.day.note": "Estimativa com a última recarga de cada projeto, {workers} em paralelo, escopo «todos».",
  "cache.day.unmeasured": "{count} relatório(s) ainda sem dados: fora do total.",
  "cache.locales.title": "Idiomas a pré-aquecer",
  "cache.locale.en": "Inglês",
  "cache.locale.es": "Espanhol",
  "cache.locale.pt": "Português (Brasil)",
  "cache.locales.help": "Só contam para os relatórios que usam o idioma no SQL. Um idioma desmarcado é calculado na primeira vez que alguém o abre e daí em diante fica em cache.",
  "cache.alert.title": "Alerta por e-mail",
  "cache.alert.label": "Se o pré-aquecimento de um projeto passar de (minutos)",
  "cache.alert.help": "Não impede a publicação. Se o pré-aquecimento falhar, a recarga não é publicada e o e-mail sai sempre.",
  "cache.settings.save": "Salvar",
  "cache.settings.saved": "Salvo. Vale a partir da próxima recarga de cada projeto.",
  "cache.settings.needOneLocale": "Marque pelo menos um idioma.",
  "cache.settings.badMinutes": "O limite precisa ser um número inteiro de minutos entre 1 e {max}.",
  "cache.option.saved": "Salvo. Vale a partir da próxima recarga de {project}.",
  "cache.option.yes": "Sim",
  "cache.option.no": "Não",
  "cache.option.aria": "Pré-aquecer todas as combinações de {report}",
  "cache.option.followsOn": "Segue as abas: sim",
  "cache.option.followsOff": "Segue as abas: não",
  "cache.groupOptions": "Opções do grupo {group}",
  "cache.readsLocale": "usa o idioma",
  "cache.col.report": "Relatório",
  "cache.col.buttons": "Filtros-botão e combinações",
  "cache.col.option": "Todas as combinações",
  "cache.col.cost": "Soma por recarga",
  "cache.noData": "sem dados ainda",
  "cache.ifEnabled": "se ativado",
  "cache.last.none": "Sem pré-aquecimento ainda",
  "cache.last.failed": "Falhou {when}: os dados anteriores continuam",
  "cache.last.overThreshold": "Passou do limite {when} · {dur}",
  "cache.last.complete": "Completo {when} · {dur}",
  "cache.project.desc": "{count} relatório(s) com filtros-botão · {dur} por recarga",
  "cache.without.title": "{count} projeto(s) sem filtros-botão",
  "cache.without.desc": "Só os valores padrão são pré-aquecidos · {dur} por dia",
  "cache.broken.title": "Relatórios publicados que não montam: cada recarga do projeto falha até corrigi-los",
  "cache.empty.title": "Nenhum relatório tem filtros-botão",
  "cache.empty.desc": "Cada recarga pré-aquece a visão padrão de todos os relatórios.",
  "nav.guide": "Guia do builder",
  "common.refresh": "Atualizar",
  "hub.tab.delivery": "Envios",
  "hub.tab.embed": "Embed",
  "common.remove": "Remover",
  "embed.form.title": "Emitir uma chave de embed",
  "embed.form.help": "Uma chave de embed permite que um visitante ANÔNIMO de um site de terceiros converse com um relatório deste projeto. Ela é limitada a um cliente + um contexto de chat e só pode ser chamada a partir das origens exatas que você listar.",
  "embed.form.submit": "Emitir chave",
  "embed.form.incomplete": "Rótulo, cliente, contexto de chat e pelo menos uma origem são obrigatórios.",
  "embed.field.label": "Rótulo",
  "embed.field.labelPlaceholder": "página de marketing de customer.example",
  "embed.field.clientKey": "Chave do cliente",
  "embed.field.chatContextKey": "Contexto de chat",
  "embed.field.chatContextPick": "Escolha um contexto de chat…",
  "embed.field.origins": "Origens permitidas",
  "embed.field.originAdd": "Adicionar origem",
  "embed.field.originsHelp": "Valores exatos scheme://host[:port], um por chip. Sem curingas: '*' e 'null' são rejeitados, e http://localhost:8899 é uma origem DIFERENTE de http://127.0.0.1:8899.",
  "embed.field.maxToolIterations": "Orçamento de tools por resposta",
  "embed.field.maxToolIterationsHelp": "1-8. Menor que o padrão autenticado (8) de propósito: um turno anônimo deve custar menos.",
  "embed.field.dailyQuota": "Cota diária de mensagens",
  "embed.field.dailyQuotaHelp": "Deixe vazio para NENHUMA cota. Uma chave sem limite em uma página movimentada consumirá crédito de LLM até acabar.",
  "embed.field.allowFreeSql": "Permitir SQL livre (desativado por padrão)",
  "embed.field.allowFreeSqlWarning": "Perigo: isso permite que o modelo execute SELECTs arbitrários sobre o DuckDB deste projeto, guiado por uma pergunta que QUALQUER visitante do site do cliente pode escrever. Deixe desativado, salvo se tiver um motivo específico.",
  "embed.error.badOrigin": "Origem inválida. Use scheme://host[:port] sem caminho, query nem curinga.",
  "embed.issued.title": "Chave emitida",
  "embed.issued.warning": "Copie agora: só se armazena um hash, então esta chave nunca poderá ser exibida de novo. Uma chave perdida precisa ser reemitida.",
  "embed.issued.key": "Chave de embed (texto plano)",
  "embed.issued.snippet": "Snippet pronto para colar",
  "embed.list.empty": "Este projeto ainda não tem chaves de embed.",
  "embed.col.label": "Chave",
  "embed.col.scope": "Escopo",
  "embed.col.origins": "Origens",
  "embed.col.policy": "Política",
  "embed.col.usage": "Uso",
  "embed.col.iterations": "{n} rodadas de tools",
  "embed.col.total": "{n} no total",
  "embed.status.active": "Ativa",
  "embed.status.revoked": "Revogada",
  "embed.badge.freeSql": "SQL livre ATIVO",
  "embed.quota.none": "sem cota",
  "embed.action.revoke": "Revogar",
  "embed.action.enableFreeSql": "Ativar SQL livre",
  "embed.action.disableFreeSql": "Desativar SQL livre",
  "delivery.title": "Envio agendado",
  "delivery.subtitle": "Envie os insights de IA deste projeto a um canal em um agendamento. As credenciais são escolhidas em Integrações, nunca digitadas aqui.",
  "delivery.empty": "Ainda não há envios agendados.",
  "delivery.noJobs": "Ainda não há tentativas de envio.",
  "delivery.channel.webhook": "Webhook",
  "delivery.channel.email": "E-mail",
  "delivery.channel.slack": "Slack",
  "delivery.channel.teams": "Teams",
  "delivery.field.name": "Nome",
  "delivery.field.report": "Relatório",
  "delivery.field.channel": "Canal",
  "delivery.field.cron": "Cron",
  "delivery.field.timezone": "Fuso horário",
  "delivery.field.locale": "Idioma",
  "delivery.locale.en": "Inglês",
  "delivery.locale.es": "Espanhol",
  "delivery.field.recipients": "Destinatários",
  "delivery.field.subjectPrefix": "Prefixo do assunto",
  "delivery.field.url": "URL do webhook",
  "delivery.field.mode": "Modo",
  "delivery.field.slackChannel": "Canal do Slack",
  "delivery.field.maxContentAge": "Idade máxima do conteúdo (dias)",
  "delivery.field.onMissingContent": "Quando falta conteúdo",
  "delivery.field.enabled": "Ativado",
  "delivery.col.nextRun": "Próxima execução",
  "delivery.col.lastStatus": "Último status",
  "delivery.col.schedule": "Agendamento",
  "delivery.wizard.titleNew": "Novo envio agendado",
  "delivery.wizard.titleEdit": "Editar envio agendado",
  "delivery.wizard.step.what": "O que enviar",
  "delivery.wizard.step.who": "Para quem",
  "delivery.wizard.step.when": "Quando",
  "delivery.wizard.step.review": "Revisar e testar",
  "delivery.wizard.back": "Voltar",
  "delivery.wizard.next": "Próximo",
  "delivery.wizard.saveAndTest": "Salvar e testar",
  "delivery.wizard.savedTestFailed": "Salvo, mas o teste falhou:",
  "delivery.wizard.namePlaceholder": "Resumo semanal para a equipe de operações",
  "delivery.schedule.kind.daily": "Todos os dias",
  "delivery.schedule.kind.weekly": "Toda semana",
  "delivery.schedule.kind.monthly": "Todo mês",
  "delivery.schedule.kind.custom": "Personalizado (cron)",
  "delivery.schedule.time": "Hora",
  "delivery.schedule.monthDay": "Dia do mês",
  "delivery.schedule.monthDayHint": "Os meses sem esse dia são ignorados: o dia 31 não dispara em abril.",
  "delivery.schedule.summary.daily": "Todos os dias às {time}",
  "delivery.schedule.summary.weekly": "Toda semana em {days} às {time}",
  "delivery.schedule.summary.monthly": "No dia {day} de todo mês às {time}",
  "delivery.schedule.summary.custom": "Agendamento personalizado: {cron}",
  "delivery.weekday.0": "Domingo",
  "delivery.weekday.1": "Segunda-feira",
  "delivery.weekday.2": "Terça-feira",
  "delivery.weekday.3": "Quarta-feira",
  "delivery.weekday.4": "Quinta-feira",
  "delivery.weekday.5": "Sexta-feira",
  "delivery.weekday.6": "Sábado",
  "delivery.error.weekdays": "Escolha pelo menos um dia.",
  "delivery.advanced.title": "Avançado",
  "delivery.advanced.cronHint": "Editar o cron muda o agendamento para o modo personalizado; a string é armazenada exatamente como foi digitada.",
  "delivery.slackMode.incomingWebhook": "Incoming webhook (recomendado)",
  "delivery.slackMode.botToken": "Bot + canal",
  "delivery.review.enabledHint": "Deixe desativado até que um teste pareça correto. Você pode ativá-lo a qualquer momento nesta tela.",
  "delivery.review.testOk": "Nada foi enviado",
  "delivery.teams.guide.title": "Como obter a URL do Workflow do Teams",
  "delivery.teams.guide.doneInTeams": "Feito no Microsoft Teams, não aqui",
  "delivery.teams.guide.retiredNotice": "Se você já tem um endereço de webhook do Teams que contém webhook.office.com, ele está desativado. A Microsoft desligou os conectores do Office 365 entre 18 e 22 de maio de 2026 e esses endereços nunca mais entregarão nada. Nosso remetente os recusa e explica o motivo. Crie um Workflow no lugar.",
  "delivery.teams.guide.intro": "Somente um membro do canal de destino do Teams pode criar isto, dentro do seu próprio tenant da Microsoft. Envie estes passos ao responsável pelo canal (leva cerca de um minuto) e peça o endereço gerado no final.",
  "delivery.teams.guide.step1": "No Microsoft Teams, abra o canal que deve receber o relatório. Precisa ser um canal dentro de uma equipe, não uma conversa individual.",
  "delivery.teams.guide.step2": "Aponte para o nome do canal na lista à esquerda e clique no botão ... (Mais opções) que aparece ao lado.",
  "delivery.teams.guide.step3": "Escolha Workflows. O Teams abre uma galeria de modelos de workflow.",
  "delivery.teams.guide.step4": "Escolha o modelo \"Send webhook alerts to a channel\". Seu gatilho se chama \"When a Teams webhook request is received\".",
  "delivery.teams.guide.step5": "O Teams mostra com qual conta Microsoft o workflow será executado. Essa conta passa a ser a proprietária, o que importa (veja abaixo). Confirme a equipe e o canal e salve.",
  "delivery.teams.guide.step6": "Copie o endereço https que o workflow mostra depois de criado. Copie antes de fechar a janela: é tudo o que alguém precisa para publicar nesse canal, então trate-o como uma credencial.",
  "delivery.teams.guide.step7": "Entregue esse endereço ao operador da sua plataforma, que o define como valor de {envVar} no container do builder. Este formulário guarda uma referência, nunca o valor de uma credencial.",
  "delivery.teams.guide.step7Web": "Cole esse endereço no campo acima e salve. Ele é armazenado criptografado e nunca é exibido novamente; se precisar alterá-lo, você o substitui.",
  "delivery.teams.guide.refNote": "A URL do Workflow é registrada como uma credencial do Teams em Integrações; os agendamentos de envio a escolhem então de uma lista. Ninguém digita mais uma referência à mão.",
  "delivery.teams.guide.warnTitle": "Duas coisas que complicam depois",
  "delivery.teams.guide.warnOwner": "O workflow pertence à PESSOA que o criou, não ao canal. Se essa pessoa sair da organização ou perder a licença, os relatórios deixam de chegar sem aviso. Logo após criá-lo, abra o workflow no Power Automate e adicione coproprietários.",
  "delivery.teams.guide.warnLimits": "A Microsoft rejeita mensagens maiores que 28 KB e limita acima de 4 requisições por segundo. Um relatório agendado é uma mensagem, então isso só importa quando muitos envios disparam no mesmo minuto: escalone os minutos do cron deles.",
  "delivery.teams.guide.unavailableTitle": "Não disponível nesta rota",
  "delivery.teams.guide.noBotIdentity": "Sem nome nem ícone de remetente personalizados: as mensagens chegam sob o app Workflows.",
  "delivery.teams.guide.noInteractive": "Sem botões interativos dentro da mensagem. O cartão traz um link que abre o relatório completo no portal.",
  "delivery.teams.guide.docsLink": "Anúncio da Microsoft sobre a desativação dos conectores",
  "delivery.onMissing.fail": "Falhar o envio (recomendado)",
  "delivery.onMissing.triggerWatcher": "Pedir ao portal uma passada do watcher",
  "delivery.status.pending": "Pendente",
  "delivery.status.running": "Em execução",
  "delivery.status.sent": "Enviado",
  "delivery.sentMeaning": "Enviado significa que o servidor de e-mail aceitou a mensagem. Se um endereço não existir, o retorno de erro pode chegar minutos depois e não aparece aqui.",
  "delivery.status.failed": "Falhou",
  "delivery.status.dead": "Descartado",
  "delivery.status.disabled": "Desativado",
  "delivery.action.new": "Novo envio",
  "delivery.action.test": "Testar",
  "delivery.action.sendNow": "Enviar agora",
  "delivery.action.retry": "Tentar novamente",
  "delivery.action.delete": "Excluir",
  "delivery.action.history": "Histórico",
  "delivery.confirmSendNow": "Enviar este envio agora mesmo, ao destino real?",
  "delivery.confirmDelete": "Excluir o envio {name}? Seu histórico é mantido.",
  "delivery.sendNowResult": "O envio terminou com status: {status}",
  "delivery.test.title": "Pré-visualização: dados em {date} ({locale}). Nada foi enviado.",
  "delivery.error.cron": "O cron deve ter 5 campos (minuto hora dia mês dia da semana).",
  "delivery.error.url": "Deve começar com https://",
  "delivery.error.recipients": "É necessário pelo menos um destinatário.",
  "delivery.error.slackChannel": "O canal é obrigatório no modo bot_token.",
  "delivery.recent.title": "Envios recentes",
  "delivery.recent.empty": "Ainda não há envios.",
  "operations.title": "Operações",
  "operations.subtitle": "Scheduler global, agendamentos por projeto e execuções ao vivo. O detalhe (histórico, painel de reconciliação) fica na aba Auto-refresh de cada projeto.",
  "operations.scheduler.title": "Scheduler",
  "operations.scheduler.enabled": "ativado",
  "operations.scheduler.disabled": "desativado",
  "operations.scheduler.running": "em execução",
  "operations.scheduler.noLeader": "sem líder",
  "operations.scheduler.paused": "pausado",
  "operations.scheduler.lease": "Lease",
  "operations.scheduler.lastTick": "Último tick",
  "operations.scheduler.pause": "Pausar scheduler",
  "operations.scheduler.resume": "Retomar scheduler",
  "operations.scheduler.confirmDisable": "Pausar o scheduler global? Nenhum cron disparará até que seja retomado (o Run now manual continua funcionando). Reiniciar um pod o reativa.",
  "operations.scheduler.note": "Kill-switch no nível do processo. A intenção persistida é o cron de cada projeto; pausar aqui interrompe todos os agendamentos de uma vez.",
  "operations.projects.title": "Agendamentos por projeto",
  "operations.projects.project": "Projeto",
  "operations.projects.schedule": "Agendamento",
  "operations.projects.lastRun": "Última execução",
  "operations.projects.nextRun": "Próxima execução",
  "operations.projects.manualOnly": "somente manual",
  "operations.projects.empty": "Ainda não há projetos.",
  "operations.projects.hubLink": "hub",
  "operations.runNow": "Executar agora",
  "operations.runStarted": "Recarga iniciada para {slug}.",
  "operations.forceReap": "Force-reap",
  "operations.forceReapTitle": "Abortar primeiro o job em andamento e depois iniciar uma recarga nova",
  "operations.confirmForceReap": "Abortar à força o job em andamento de {slug} e iniciar uma recarga nova? Use apenas quando um job estiver realmente travado.",
  "operations.jobs.title": "Execuções recentes",
  "operations.jobs.hint": "em todos os projetos, das mais recentes às mais antigas",
  "operations.jobs.status": "Status",
  "operations.jobs.phase": "Fase",
  "operations.jobs.started": "Início",
  "operations.jobs.duration": "Duração",
  "operations.jobs.recon": "Reconciliação",
  "operations.jobs.empty": "Ainda não há execuções.",
  "operations.scopes.title": "Escopos de dados",
  "operations.scopes.summary": "{scopes} escopo(s) em {projects} projeto(s) · {size} em disco · {free} livres",
  "operations.scopes.stuckCount": "{count} travados",
  "operations.scopes.failedCount": "{count} com falha",
  "operations.scopes.sizeIncomplete": "Total em disco incompleto, não medido: {projects}",
  "operations.scopes.col.project": "Projeto",
  "operations.scopes.col.scope": "Escopo",
  "operations.scopes.col.status": "Última construção",
  "operations.scopes.col.freshness": "Atualidade",
  "operations.scopes.col.rows": "Linhas",
  "operations.scopes.col.size": "Tamanho",
  "operations.scopes.col.lock": "Lock mantido",
  "operations.scopes.col.when": "Quando",
  "operations.scopes.status.built": "Construído",
  "operations.scopes.status.building": "Construindo",
  "operations.scopes.status.failed": "Falhou",
  "operations.scopes.status.noMapping": "Recorte vazio",
  "operations.scopes.status.notApplicable": "Não se aplica",
  "operations.scopes.status.neverBuilt": "Nunca construído",
  "operations.scopes.status.stuck": "Travado",
  "operations.scopes.stuckHint": "Está construindo além do limite de obsolescência e bloqueia toda nova construção deste escopo neste projeto. Nada o libera automaticamente: o comando exato está no histórico de construções em Acessos › Escopos.",
  "operations.scopes.unknownStatus": "Este status ainda não tem rótulo. Mostrando o valor bruto do banco de dados.",
  "operations.scopes.freshnessHint": "Se o escopo foi recortado do arquivo do projeto que está em uso agora.",
  "operations.scopes.fresh": "Atualizado",
  "operations.scopes.stale": "Desatualizado",
  "operations.scopes.lockHint": "Tempo medido dentro do lock de escrita do cliente e quanto dele os tempos por passo não explicam.",
  "operations.scopes.notMeasured": "não medido",
  "operations.scopes.gap": "{pct}% sem explicação",
  "operations.scopes.empty.title": "Nenhum escopo foi construído ainda",
  "operations.scopes.empty.body": "Um escopo recebe seu arquivo na próxima recarga do projeto ou em Acessos › Escopos › Reconstruir.",
  "operations.scopes.orphans.title": "Escopos derivados que ninguém resolve",
  "operations.scopes.orphans.body": "Seus arquivos continuam em disco e nada os remove automaticamente. Confira-os com a listagem de arquivos antes de excluir qualquer coisa à mão.",
  "operations.scopes.gaps.title": "O que estes números não cobrem",
  "operations.scopes.gaps.body": "Leia-os tendo estes limites em mente. Cada um deles é uma propriedade do código atual, não desta tela.",
  "operations.scopes.gaps.noTimings": "Uma construção com falha não registra nenhum tempo, então todos os valores de lock aqui descrevem apenas construções bem-sucedidas, e as retenções mais longas são justamente as que falham.",
  "operations.scopes.gaps.noEnd": "Somente uma construção bem-sucedida recebe horário de término, então uma duração derivada dele descartaria em silêncio todas as que falharam ou ficaram vazias.",
  "operations.scopes.gaps.noElapsed": "O tempo total (wall clock) de um único escopo não é armazenado: ele só sobrevive no job do loader da recarga que o construiu.",
  "operations.scopes.gaps.untranslated": "Este limite ainda não tem texto traduzido. Mostrando o texto do próprio backend.",
  "guide.title": "Guia do builder",
  "guide.subtitle": "Como a plataforma funciona, capítulo por capítulo: dos dados brutos até quem pode ler quais linhas.",
  "guide.detailsTitle": "Detalhes que importam",
  "guide.data.title": "Dados e views",
  "guide.data.intro": "Do parquet no S3 até os elementos que cada dashboard renderiza.",
  "guide.data.node1": "S3",
  "guide.data.node1sub": "parquet (OBT)",
  "guide.data.node2": "Loader",
  "guide.data.node2sub": "download + swap",
  "guide.data.node3": "DuckDB",
  "guide.data.node3sub": "um arquivo por projeto",
  "guide.data.node4": "Views",
  "guide.data.node4sub": "por relatório",
  "guide.data.node5": "Elementos",
  "guide.data.node5sub": "KPIs · gráficos · tabelas",
  "guide.data.step1": "O projeto declara UMA fonte de dados (o parquet OBT no S3) na sua aba Dados.",
  "guide.data.step2": "O loader a baixa e grava a tabela bruta no arquivo DuckDB próprio do projeto com um swap atômico.",
  "guide.data.step3": "Cada relatório declara SUAS PRÓPRIAS views sobre a OBT (sources[] na configuração do relatório). A recarga rematerializa todas elas.",
  "guide.data.step4": "Cada elemento (KPI, gráfico, tabela, filtro) executa SQL sobre as views do relatório, nunca diretamente sobre a tabela bruta.",
  "guide.data.step5": "O portal lê o mesmo arquivo DuckDB e detecta novas versões automaticamente pela chave de versão por projeto.",
  "guide.data.detail1": "Cada relatório é dono das suas views, mesmo quando duplicam as de outro relatório: autonomia acima de deduplicação (regra durável da equipe).",
  "guide.data.detail2": "Um piso de data fixo no SQL de uma view corta o histórico em silêncio: as views devem conter TODOS os dados; quem faz o janelamento são os filtros.",
  "guide.data.detail3": "Tudo o que deriva dos dados de um projeto deve abrir a conexão por projeto (slug). A global é o ponto cego clássico.",
  "guide.dimensions.title": "Dimensões",
  "guide.dimensions.intro": "Uma única definição de uma coluna: os filtros do relatório a oferecem e os escopos de acesso recortam por ela.",
  "guide.dimensions.node1": "Tabela bruta",
  "guide.dimensions.node1sub": "a do próprio projeto",
  "guide.dimensions.node2": "Dimensão",
  "guide.dimensions.node2sub": "coluna · mapeamento · SQL",
  "guide.dimensions.node3": "Enriquecimento",
  "guide.dimensions.node3sub": "dentro da recarga",
  "guide.dimensions.node4": "Views",
  "guide.dimensions.node4sub": "enxergam a nova coluna",
  "guide.dimensions.node5": "Usada por",
  "guide.dimensions.node5sub": "filtros e escopos",
  "guide.dimensions.step1": "As dimensões ficam em Projeto › Dados › Dimensões. Uma dimensão é UMA definição de uma coluna: os filtros do relatório a oferecem e os escopos de acesso cortam por ela, então não há uma segunda lista para manter sincronizada. Declará-la não muda nada até a próxima recarga.",
  "guide.dimensions.step2": "Origem «coluna»: escolha uma coluna que a tabela raw já traz. Nomeie essa coluna de forma explícita (ela nunca é deduzida da chave da dimensão) e marque «Escopo» em «Utilizável para», porque o padrão é não servir para nada.",
  "guide.dimensions.step3": "Origem «mapeamento»: escolha o Master, a planilha, a coluna de chave e a coluna de valor. Essa planilha é mantida pelo CLIENTE (país → região comercial, seller → carteira de KAM), e todo valor presente nos dados precisa ter uma linha nela.",
  "guide.dimensions.step4": "Origem «calculada»: uma expressão apenas SELECT sobre as colunas da própria linha, como a marcação 2P, o preço parcelado ou a definição de 1P/3P que muda por país. Sem subconsulta, sem função de janela, sem agregação: o servidor valida a expressão contra o arquivo real antes de salvar.",
  "guide.dimensions.step5": "Recarregue. A fase enrich_dimensions acrescenta à tabela raw uma coluna real por dimensão de mapeamento e calculada, dentro da transação de escrita e antes de construir a primeira view, então nenhum SQL de view muda e os escopos conseguem enxergá-la. As fases do job e o seu result_json mostram o que ele fez.",
  "guide.dimensions.step6": "Quando ele informa valores sem mapeamento: a fase parou, nada foi publicado, os dados anteriores continuam no ar, e a mensagem indica os valores, quantas linhas eles cobrem e qual planilha não os tem. Adicione essas linhas ao Master e execute a recarga novamente.",
  "guide.dimensions.detail1": "Definida uma vez, usada duas vezes: a mesma dimensão alimenta os filtros do relatório e os escopos de acesso. Não há uma segunda lista para manter sincronizada e, portanto, não há como as duas discordarem.",
  "guide.dimensions.detail2": "O enriquecimento reescreve a tabela raw no lugar e roda ANTES da primeira view. Essa ordem é todo o desenho: uma coluna acrescentada depois das views fica invisível para elas e para o predicado do escopo, que se resolve a partir de um DESCRIBE da tabela raw do arquivo do projeto.",
  "guide.dimensions.detail3": "Não existe um balde «Outros» e o valor nunca fica NULL. Um valor raw sem linha no Master faz a fase falhar, indicando o valor e a quantidade de linhas, pois uma linha que saísse em silêncio de todos os escopos seria invisível para todos.",
  "guide.dimensions.detail4": "Uma dimensão que ninguém marcou como utilizável para escopos faz todo escopo que a nomeia resolver «não se aplica» neste projeto, e nada na tela parece quebrado. O padrão é fail-closed, não «sem definir»: ela precisa ser marcada.",
  "guide.scopes.title": "Escopos",
  "guide.scopes.intro": "Quem lê quais linhas é decidido por um arquivo real por projeto, nunca por uma cláusula WHERE que alguém pode esquecer.",
  "guide.scopes.node1": "Regras",
  "guide.scopes.node1sub": "dimensão = valores",
  "guide.scopes.node2": "Predicado",
  "guide.scopes.node2sub": "AND · IN",
  "guide.scopes.node3": "Arquivo do escopo",
  "guide.scopes.node3sub": "um por projeto",
  "guide.scopes.node4": "Leitor",
  "guide.scopes.node4sub": "abre só este",
  "guide.scopes.node5": "Estado",
  "guide.scopes.node5sub": "construído ou fechado",
  "guide.scopes.step1": "Os escopos ficam em Acessos › Escopos e pertencem ao cliente inteiro, não a um projeto. O id É o nome do arquivo (1 a 40 caracteres de [a-z0-9_-]) e nunca é convertido para minúsculas, então us-amazon e us_amazon são dois escopos diferentes. O nome é o que as pessoas leem. Criar um escopo ainda não move nada no disco.",
  "guide.scopes.step2": "Adicione regras: uma dimensão e uma lista de valores tirados dos dados. As regras se combinam com AND e os valores dentro de uma regra com OR. Os tipos não são cosméticos: uma coluna de texto com a regra do número 1 é recusada, porque o DuckDB converteria a coluna e «1», «01» e «1.0» coincidiriam, entregando três sellers diferentes a uma mesma pessoa.",
  "guide.scopes.step3": "«Projetos onde se aplica» responde projeto a projeto. Um que declara todas as dimensões que as regras nomeiam mostra seu estado e sua contagem de linhas; um que não tem alguma dimensão mostra «não se aplica» e não concede nada ali, o que ou está correto, ou significa que a dimensão nunca foi marcada como utilizável para escopos.",
  "guide.scopes.step4": "A edição das regras exige reconhecimento do impacto. A simulação indica os grupos e o número de pessoas que a mudança alcança, e o salvamento precisa devolver essa lista, para que ninguém mude quem vê o quê sem ter lido a consequência. A resposta então diz com todas as letras que nada foi reconstruído.",
  "guide.scopes.step5": "«Reconstruir» corta o arquivo, para um projeto, agora. Ele mantém o bloqueio de escrita do cliente enquanto roda e pode durar mais que o proxy que carregou a requisição; quando isso acontece, a fonte da verdade é a lista de builds, não a requisição que falhou. A próxima recarga do projeto também o reconstrói, inclusive uma recarga que é pulada porque os dados não mudaram.",
  "guide.scopes.step6": "«Tudo» é o escopo reservado e não tem arquivo próprio: ele se resolve literalmente para o arquivo do próprio projeto. Não pode ser reconstruído nem editado para virar um escopo restrito, e todos o têm até que alguém os coloque em um grupo que carregue outro.",
  "guide.scopes.detail1": "Quem está em vários grupos lê a UNIÃO dos escopos deles: as uniões ampliam, nunca intersectam. Quem está em exatamente um grupo resolve para o escopo desse grupo em si e não para uma cópia dele, então o arquivo já existe e nenhuma edição o deixa sem acesso enquanto uma reconstrução está pendente.",
  "guide.scopes.detail2": "Quando a união não pode ser escrita como um único conjunto de regras, ela é recusada, nomeando os dois grupos, em vez de ser mesclada. Mesclar «US e amazon» com «CL e meli» entregaria ao leitor US com meli e CL com amazon: linhas que nenhum dos grupos concedeu, em um arquivo com o formato certo e uma contagem de linhas plausível, sem que nada adiante consiga detectar.",
  "guide.scopes.detail3": "Uma construção que falha nunca bloqueia o projeto e nunca amplia o acesso de ninguém: os leitores mantêm o arquivo anterior, a recarga publica normalmente e o único lugar onde aparece é a coluna de estado aqui. Alguém lendo números ANTIGOS sem nenhum erro na tela é a cara de uma reconstrução que falhou.",
  "guide.scopes.detail4": "Excluir um escopo que alguém resolve é recusado, indicando quem o resolve, e um escopo sem arquivo responde 503 em vez do arquivo do projeto. Não há fallback para os dados sem restrição, e esse fallback é justamente o vazamento que todo este desenho existe para evitar.",
  "guide.groups.title": "Grupos",
  "guide.groups.intro": "Um grupo é o único lugar onde o acesso é escrito: um escopo, uma matriz de conteúdo e as pessoas que herdam os dois.",
  "guide.groups.node1": "Grupo",
  "guide.groups.node1sub": "para quem é",
  "guide.groups.node2": "Escopo",
  "guide.groups.node2sub": "quais linhas",
  "guide.groups.node3": "Conteúdo",
  "guide.groups.node3sub": "relatórios · seções",
  "guide.groups.node4": "Membros",
  "guide.groups.node4sub": "pessoas",
  "guide.groups.node5": "A pessoa",
  "guide.groups.node5sub": "portal · e-mail · chat",
  "guide.groups.step1": "Os grupos são criados aqui, no builder, pela Omnitok. O administrador do próprio cliente atribui pessoas aos grupos que existem e nunca cria um, porque criar um grupo é decidir o que um papel SIGNIFICA nessa conta.",
  "guide.groups.step2": "Aba «Escopo»: escolha o escopo do grupo, exatamente um. Essa única escolha decide quais linhas cada membro do grupo lê, em todos os projetos aos quais o escopo se aplica.",
  "guide.groups.step3": "Aba «Conteúdo»: a matriz de relatórios, seções e ações. Uma célula que ninguém definiu recorre ao padrão do papel em vez de «negado», exceto «Ver», que não tem padrão algum: um relatório que nenhum grupo da pessoa abre não é aberto, e nenhum padrão do papel o resgata. A permissão de uma pessoa é o OR das células explícitas de todos os seus grupos, então uma negação em um grupo não é apagada por um grupo que simplesmente não tem opinião.",
  "guide.groups.step4": "Aba «Membros»: adicione e remova pessoas. Adicionar alguém recalcula seu escopo efetivo na mesma transação, então a resposta na tela da própria pessoa já está certa antes de você sair desta.",
  "guide.groups.step5": "A lista destaca «não concede nada»: um grupo sem nenhuma linha de visualização de dashboard. Quem entra nele não abre nenhum relatório, e em um SELECT simples sobre a tabela o grupo parece perfeito. A contagem de membros acompanha esse aviso, então um grupo vazio e que não concede nada não é reduzido em silêncio a apenas um dos dois.",
  "guide.groups.detail1": "Não existem mais permissões individuais. Uma exceção é um grupo de uma pessoa, e um grupo de uma pessoa SOBREVIVE à pessoa: quando alguém sai, o papel não sai com ela, e quem a substitui entra em um grupo que já carrega o acesso correto.",
  "guide.groups.detail2": "Vários grupos significam a união dos escopos e o OR das permissões, nunca o produto cruzado das regras. Dois grupos de um país cada veem os dois países; intersectá-los daria as linhas de ninguém.",
  "guide.groups.detail3": "O administrador do próprio cliente continua vendo tudo, e um grupo não o restringe. Esse bypass é deliberado e não mudou: um administrador que não pudesse ver todos os seus próprios dados seria outro papel, e esse papel não existe.",
  "guide.people.title": "Pessoas",
  "guide.people.intro": "Cada pessoa é a união dos seus grupos; esta tela é onde você lê essa união e a confere antes de ela entrar.",
  "guide.people.node1": "Pessoa",
  "guide.people.node1sub": "entra ou recebe",
  "guide.people.node2": "Grupos",
  "guide.people.node2sub": "um ou mais",
  "guide.people.node3": "União",
  "guide.people.node3sub": "o escopo efetivo",
  "guide.people.node4": "Arquivo",
  "guide.people.node4sub": "um por projeto",
  "guide.people.node5": "Portal",
  "guide.people.node5sub": "tela · e-mail · chat",
  "guide.people.step1": "Acessos › Pessoas lista todos os deste cliente: as pessoas que entram e os endereços que apenas recebem. Alguém é criado aqui com um papel e um e-mail que não pode ser editado depois, porque esse endereço é a identidade contra a qual toda linha de auditoria é escrita.",
  "guide.people.step2": "Aba «Grupos»: atribuir grupos é a única forma de dar acesso. Nada nesta tela escreve uma permissão sobre uma pessoa; a matriz que antes ficava aqui foi removida, e suas linhas pertencem aos grupos em que a pessoa está.",
  "guide.people.step3": "«Escopo efetivo» é somente leitura e calculado: o cartão indica o escopo para o qual os grupos da pessoa se resolvem e os grupos de onde ele veio, e nada mais. A contagem de linhas e o estado de construção por projeto NÃO estão nele, estão na página do próprio escopo, em Acessos › Escopos, a um clique. Abra-a e compare a contagem com a do analista ali. Uma contagem que não coincide é o momento de parar, e esta é a tela para parar, em vez de depois que a pessoa entrar.",
  "guide.people.step4": "Alguém em NENHUM grupo aparece como «desconhecido» nesse cartão, não como «Tudo»: nenhum grupo informa um escopo para a pessoa, e o cartão não pinta um rótulo confiante sobre uma associação que nenhum grupo escolheu. De qualquer forma ela não lê nada, porque a matriz de conteúdo responde não para todo relatório. São dois fatos separados e o cartão os mantém separados: um escopo não é uma permissão, é um corte.",
  "guide.people.step5": "«Acesso ao builder» é por pessoa e nunca por grupo: essas flags são o acesso da equipe da Omnitok a este console, enquanto os grupos governam o que as pessoas de um cliente veem no portal. Um grupo que pudesse carregá-las permitiria que um objeto voltado ao cliente concedesse entrada ao console de administração.",
  "guide.people.step6": "Desativar alguém vale a partir da PRÓXIMA REQUISIÇÃO, não do próximo login: a linha da pessoa é lida a cada requisição, então nem uma mudança de grupo nem uma desativação exige que ela saia da sessão. Não há nada a esperar nem a limpar.",
  "guide.people.detail1": "Aqui vivem dois tipos de identidade: quem entra e um destinatário que apenas recebe e-mails e arquivos. Ambos podem ter grupos e ambos resolvem um escopo efetivo; o que os separa é se o portal os deixa entrar, e isso agora é imposto, não apenas registrado: uma identidade só de envios tem a sessão interativa recusada e só é alcançável pelos tokens que renderizam seu e-mail ou o consultam em modo somente leitura.",
  "guide.people.detail2": "«Assinaturas» e «exceções» aparecem uma vez, como nota, e nunca como números de destaque: elas contam linhas nas tabelas por pessoa que este slice aposenta. São mostradas para que uma migração que deixou alguém para trás fique visível na tela.",
  "guide.people.detail3": "«Ver como» existe em duas formas e não são a mesma ferramenta. Por ESCOPO, na pré-visualização do próprio builder: autorizado contra a linha do próprio usuário, aceito em seis rotas comparadas exatamente e recusado em todas as outras, e registra o que mostrou antes de vincular qualquer coisa. Por PESSOA, a partir do console da plataforma: quinze minutos, só portal, estritamente somente leitura (toda escrita sob ele é recusada, indicando a rota), e sua linha de auditoria é escrita ANTES de o token ser assinado, então uma escrita que falha significa que não há token.",
  "guide.verify.title": "Verificar antes de conceder",
  "guide.verify.intro": "O percurso a fazer antes de vincular uma pessoa real a um escopo restrito: construí-lo, contá-lo, olhar pelos olhos dela e depois ler o rastro.",
  "guide.verify.node1": "Construir",
  "guide.verify.node1sub": "o arquivo do escopo",
  "guide.verify.node2": "Contar",
  "guide.verify.node2sub": "contra o analista",
  "guide.verify.node3": "Olhar",
  "guide.verify.node3sub": "somente leitura · 15 min",
  "guide.verify.node4": "E-mail",
  "guide.verify.node4sub": "como o destinatário",
  "guide.verify.node5": "Rastro",
  "guide.verify.node5sub": "quem fez o quê",
  "guide.verify.step1": "Construa o arquivo antes de haver alguém no grupo: Acessos › Escopos, abra o escopo, «Reconstruir» por projeto, ou deixe a próxima recarga do projeto fazê-lo. Depois leia a coluna de estado. «Construído» com uma contagem de linhas é o único estado a partir do qual você pode continuar; «não se aplica» significa que este projeto não declara nenhuma das dimensões que as regras nomeiam, então o escopo não concede nada ali.",
  "guide.verify.step2": "Compare essa contagem de linhas com o número do próprio analista para o mesmo corte, projeto a projeto. Esta é a barreira: enquanto os dois divergirem, ninguém entra no grupo. Um escopo construído com zero linhas não é erro em nenhuma tela, o dashboard simplesmente fica vazio, e a causa habitual é um valor escrito de um jeito nos dados e de outro na regra.",
  "guide.verify.step3": "«Ver como este escopo», na pré-visualização do próprio builder, responde a metade barata sem precisar de uma pessoa: o relatório é renderizado a partir do arquivo desse escopo, em seis rotas comparadas exatamente e recusado em todas as outras, e a linha de auditoria é escrita antes de vincular qualquer coisa. Peça-o da mesma forma que se pede a visão por pessoa, com um header nessas seis chamadas de pré-visualização; nenhuma tela o envia ainda, então hoje este é um passo de API. Use-o enquanto as contagens ainda estão mudando.",
  "guide.verify.step4": "«Ver como» uma PESSOA é a travessia somente leitura que o console da plataforma emite: quinze minutos, só portal, e somente leitura de verdade (toda escrita sob ele volta recusada com uma frase que indica a rota; um POST é exceção porque É uma leitura: o drill de linha, cuja consulta não cabe em uma URL). É a única forma de ver o que recebe um destinatário só de envios, já que essa identidade nunca pode entrar. Hoje é pedido pela API do console, que aceita uma flag de somente leitura; o botão é o que ainda falta.",
  "guide.verify.step5": "Pergunte ao chat algo que o escopo NÃO deve responder, como um mercado fora do corte. Não encontrar nada é a resposta certa e um número não é, porque o sandbox tem o arquivo desse escopo anexado e nenhum outro. Mais duas coisas mudam aqui: uma conversa iniciada sob outro escopo se recusa a ser retomada em vez de se repetir, e os exemplos de treinamento ficam retidos a menos que alguém os marque como seguros, então um chat restrito é deliberadamente mais sem graça.",
  "guide.verify.step6": "O e-mail é enviado pela pessoa, a partir da sua própria tela: uma visão não pode pressionar «Enviar», esse POST é recusado como todos os outros. O que mudou por baixo é através dos olhos de quem a captura de tela é feita. Por padrão cada destinatário recebe o dashboard capturado com um token emitido para ele, então a imagem mostra a sua própria fatia; só um administrador que escolhe «Meu escopo de dados» envia a imagem do seu próprio corte, e ninguém mais pode escolhê-lo. A imagem nunca é a visão sem restrição da plataforma. Se a captura não consegue mostrar o dashboard, ou mostra cartões de erro em vez de dados, o e-mail não é enviado: o envio falha e seu dono é informado do motivo.",
  "guide.verify.step7": "Termine lendo o rastro, e saiba qual. As mudanças de acesso (o grupo, seus membros, as regras de um escopo) vão para Acessos › Auditoria com o autor, o antes e o depois. A visão por pessoa NÃO vai: o console da plataforma a escreve na sua própria auditoria, como uma travessia marcada como somente leitura. Dois rastros, porque duas pessoas diferentes respondem por eles.",
  "guide.verify.detail1": "Um agendamento que inclui a análise de IA e pertence a uma pessoa restrita é enviado, e a narrativa é escrita a partir do arquivo da própria pessoa: o escopo viaja com a requisição que o builder faz ao portal, onde é exigido em vez de assumido, e a captura de tela ao lado é feita pela mesma identidade, então as duas metades de um e-mail descrevem a mesma fatia. O que o e-mail não fará é sair sem contabilização: o portal devolve qual escopo leu, e um eco ausente ou diferente (o que responde um portal com uma versão mais antiga) faz o job falhar em vez de entregá-lo.",
  "guide.verify.detail2": "Os Insights são por escopo e ficam desligados até que um grupo os peça: um escopo ganha sua própria narrativa somente quando alguém que lê sob ele pertence a um grupo com a opção ligada, e apenas nos projetos cujo arquivo ele de fato construiu. O número ao lado da opção é aritmética (relatórios × escopos × recargas) e a contagem medida nos últimos trinta dias fica ao lado, para que os dois nunca sejam lidos como um só.",
  "guide.verify.detail3": "Nada em um e-mail fica congelado no momento de salvar. O escopo sob o qual ele é renderizado é lido de novo quando dispara, a partir da linha da própria pessoa, então restringir o acesso de alguém alcança o próximo e-mail dela sem que ninguém edite um agendamento. Os alertas por limite e por SQL funcionam do mesmo jeito: ambos abrem o arquivo dessa pessoa, nunca o do projeto.",
  "guide.verify.detail4": "Todo passo aqui falha fechado e nenhum toma emprestado um arquivo mais amplo. Um escopo sem construção responde 503, uma narrativa ausente para esse escopo é uma recusa e não a sem restrição, e um dono cuja linha não é encontrada interrompe o envio. Se uma tela parece vazia ou um e-mail não chegou, procure o que falta: nenhum padrão preencheu a lacuna em silêncio.",
  "guide.refresh.title": "Atualização automática e reconciliação",
  "guide.refresh.intro": "O cron recarrega a OBT e uma verificação em 3 pontas barra toda publicação.",
  "guide.refresh.node1": "Cron",
  "guide.refresh.node1sub": "por projeto",
  "guide.refresh.node2": "Job do loader",
  "guide.refresh.node2sub": "heartbeat ~5 s",
  "guide.refresh.node3": "Swap atômico",
  "guide.refresh.node3sub": "views reconstruídas",
  "guide.refresh.node4": "Gate A↔B",
  "guide.refresh.node4sub": "golden vs engine",
  "guide.refresh.node5": "Portal",
  "guide.refresh.node5sub": "detecção da versão",
  "guide.refresh.step1": "Cada projeto agenda sua recarga (cron + fuso horário) na aba Atualização automática do hub; Operations mostra todas.",
  "guide.refresh.step2": "Uma execução baixa o parquet, reconstrói a tabela raw e rematerializa as views de cada relatório em um swap de staging.",
  "guide.refresh.step3": "Antes de subir a versão, o GATE de reconciliação compara o SQL golden (A) com o engine em produção (B) para cada elemento coberto.",
  "guide.refresh.step4": "Se o gate falha, o swap é descartado: os dados ANTIGOS continuam no ar, o job é marcado como falho e um e-mail de alerta é enviado.",
  "guide.refresh.step5": "Depois da publicação, a fase 2 compara o engine com o que o portal de fato serve (B↔C), somente com alerta, e reaquece o cache.",
  "guide.refresh.detail1": "Os manifests golden ficam por relatório (reconciliation.yaml); adicionar um elemento sem uma asserção BLOQUEIA o gate, sem lacunas silenciosas.",
  "guide.refresh.detail2": "Os jobs fazem heartbeat a cada ~5 s; o reaper encerra os obsoletos. O Force-reap (Operations ou hub) aborta um job travado antes de uma nova execução.",
  "guide.refresh.detail3": "O gate falhar significa que os dados continuaram consistentes. Nunca execute de novo às cegas; leia primeiro o painel de cada elemento.",
  "guide.publish.title": "Publicação",
  "guide.publish.intro": "Das edições do rascunho até o portal, com histórico e reversão.",
  "guide.publish.node1": "Rascunho",
  "guide.publish.node1sub": "salvamento automático",
  "guide.publish.node2": "Validação",
  "guide.publish.node2sub": "SQL + layout",
  "guide.publish.node3": "Publicar",
  "guide.publish.node3sub": "snapshot para o histórico",
  "guide.publish.node4": "Portal",
  "guide.publish.node4sub": "detecção em ~60 s",
  "guide.publish.step1": "Salvar grava o relatório. Um rascunho não é servido; um relatório publicado muda no portal com o salvamento (o portal serve as linhas publicadas), por isso o salvamento passa antes pelas mesmas validações de Publicar. Em um grupo de relatórios, o que o grupo repete é copiado para os relatórios irmãos no mesmo salvamento.",
  "guide.publish.step2": "Publicar valida o SQL e o layout (limites da grade, alturas); uma validação que falha bloqueia, de forma ruidosa.",
  "guide.publish.step3": "Publicar tira um snapshot da configuração anterior para o Histórico, e qualquer snapshot pode ser revertido com um clique.",
  "guide.publish.step4": "O portal consulta report_drafts a cada 60 s e assume a nova configuração sem reiniciar.",
  "guide.publish.detail1": "O builder é a única fonte da verdade; o portal nunca edita dashboard_config.",
  "guide.publish.detail2": "Os campos exclusivos do backend (runtime_view_sql, …) são preservados ao publicar; a UI nunca os vê nem os apaga.",
  "guide.publish.detail3": "A pré-visualização compartilhada (/preview/:key) renderiza EXATAMENTE o mesmo DashboardBody que o portal usa: o que você vê é o que vai ao ar.",
  "guide.ai.title": "A IA e seu ciclo de melhoria",
  "guide.ai.intro": "O treinamento alimenta o chat; os issues devolvem o treinamento.",
  "guide.ai.node1": "Treinamento",
  "guide.ai.node1sub": "DDL · docs · Q&A",
  "guide.ai.node2": "Chat",
  "guide.ai.node2sub": "por relatório",
  "guide.ai.node3": "Issues",
  "guide.ai.node3sub": "thumbs-down",
  "guide.ai.node4": "Triagem",
  "guide.ai.node4sub": "AI Panorama",
  "guide.ai.node5": "IA melhor",
  "guide.ai.node5sub": "promover a exemplo",
  "guide.ai.step1": "O painel Knowledge de cada relatório guarda seus docs de schema e os exemplos canônicos de Q&A, e isso É o treinamento do chat.",
  "guide.ai.step2": "O chat responde com SQL sobre as views do relatório; as perguntas iniciais e os CTAs são configurados por relatório.",
  "guide.ai.step3": "Um thumbs-down no portal abre um issue com a conversa completa anexada.",
  "guide.ai.step4": "O AI Panorama enfileira os issues de TODOS os relatórios; faça a triagem ali (resolver, descartar ou promover).",
  "guide.ai.step5": "Promover um issue transforma a resposta corrigida em um exemplo de treinamento, a correção de maior alavancagem para a qualidade do chat.",
  "guide.ai.detail1": "Os Insights são separados do chat: specs + janela temporal + snapshots, configurados no painel Insights do relatório.",
  "guide.ai.detail2": "As notas de contexto vivem no nível do PROJETO e fluem para todo snapshot afetado; regenere os afetados depois de editar.",
  "guide.ai.detail3": "Uma resposta ruim do chat é uma lacuna de treinamento, não um problema de prompt: adicione um exemplo canônico antes de mexer nos prompts.",
  "screenhelp.button": "O que é esta tela?",
  "screenhelp.forThisScreen": "Ajuda desta tela",
  "screenhelp.contents": "Conteúdo",
  "screenhelp.openGuide": "Abrir o guia",
  "screenhelp.dimensions.title": "Dimensões",
  "screenhelp.dimensions.body": "Esta tela define as colunas pelas quais este projeto pode ser filtrado e pelas quais o acesso pode ser cortado, uma só definição para os dois usos. Uma dimensão é uma coluna que os dados já trazem, um valor traduzido por uma planilha de um Master que o cliente mantém, ou uma coluna calculada com uma expressão SQL sobre a linha. O que surpreende a todos: declará-la não muda nada até a próxima recarga, porque as colunas de mapeamento e calculadas são escritas nos dados pela própria recarga.",
  "screenhelp.scopes.title": "Escopos",
  "screenhelp.scopes.body": "Esta tela decide quem lê quais linhas. Um escopo é um conjunto de regras sobre dimensões (uma dimensão, uma lista de valores, combinadas com AND), e cada um é materializado como um arquivo DuckDB real por projeto, então um projeto que não declara uma dimensão que as regras nomeiam não concede nada ali, em vez de conceder tudo. Editar as regras aposenta os arquivos do escopo de imediato: todos que leem por ele recebem um erro (503) até que alguém o reconstrua, ou até a próxima recarga do projeto.",
  "screenhelp.scope.title": "Este escopo",
  "screenhelp.scope.body": "Um escopo: suas regras, os projetos aos quais se aplica e cada build que já teve. O salvamento exige reconhecimento do impacto (a simulação indica os grupos e as pessoas que a mudança alcança, e o salvamento precisa devolvê-los), e a reconstrução é síncrona, mantém o bloqueio de escrita do cliente e pode durar mais que o proxy. Quando a requisição morre, a tabela de builds abaixo é a fonte da verdade, não o erro.",
  "screenhelp.groups.title": "Grupos",
  "screenhelp.groups.body": "A lista de grupos. Um grupo carrega um escopo e uma matriz de conteúdo e é o único lugar onde o acesso é escrito; a Omnitok os cria aqui e o administrador do próprio cliente apenas atribui pessoas a eles. O estado a procurar é «não concede nada»: um grupo sem nenhuma linha de visualização de dashboard, que não abre nenhum relatório para seus membros e parece perfeito no banco de dados.",
  "screenhelp.group.title": "Este grupo",
  "screenhelp.group.body": "As três abas deste grupo: quem está nele, quais linhas ele abre e quais relatórios e seções ele concede. Mudar o escopo muda o que cada membro lê na próxima requisição, sem novo login, mas só até onde o grupo mais amplo da pessoa permitir: o escopo de uma pessoa é a UNIÃO dos escopos dos seus grupos, e a união com «Tudo» é «Tudo», então um membro que também está em um grupo sem restrição continua lendo tudo. A coluna «Resolve para» diz qual é qual, linha a linha: «lê tudo» é uma restrição que este grupo não está aplicando. Uma célula não definida na matriz de conteúdo significa o padrão do papel, não «negado», exceto «Ver», que não tem padrão: sem uma linha nela o relatório não é aberto de forma alguma.",
  "screenhelp.groupAi.title": "A IA deste grupo",
  "screenhelp.groupAi.body": "O que o chat e os insights fazem pelas pessoas deste grupo. A opção de insights é um CUSTO e fica desligada até que alguém a ligue: ligada, cada relatório que produz Análise de IA é narrado mais uma vez para o escopo deste grupo, além do sem restrição, e o número ao lado do interruptor é aritmética (relatórios × escopos × recargas), com a contagem medida ao lado para que os dois nunca sejam lidos como um só. A nota de contexto é anexada aos prompts que seus membros alcançam. E sob um escopo restrito o chat mantém apenas os exemplos de treinamento que alguém marcou como seguros, então responde com menos do que para um leitor sem restrição, de propósito e não por acaso. Nada aqui concede acesso; decide o que a IA diz às pessoas que já o têm.",
  "screenhelp.groupExperience.title": "A experiência deste grupo",
  "screenhelp.groupExperience.body": "Com o que um membro deste grupo começa: o quadro de Início que é montado para ele na primeira vez que abre o portal. Editar o modelo do quadro ressincroniza os quadros dos membros e nunca altera um cartão que alguém adicionou por conta própria; um cartão que um membro não pode ler volta como negado em vez de desaparecer, porque o provisionamento decide com o que uma pessoa COMEÇA e nunca o que ela pode ver. A outra metade da coluna, o e-mail padrão do grupo, não tem formulário nesta aba: nada grava a linha de agendamento de um membro a partir dele, e um formulário para um modelo que ninguém entrega faria um administrador achar que agendou algo. O agendamento que as pessoas recebem de fato é o que elas configuram para si mesmas no portal.",
  "screenhelp.people.title": "Pessoas",
  "screenhelp.people.body": "Todos neste cliente, tanto quem entra quanto quem só recebe. A coluna que importa é o escopo efetivo: é a união dos grupos da pessoa, o MAIS AMPLO entre eles, então um único grupo sem restrição torna inertes todas as restrições que ela tiver. É calculado e nunca digitado à mão, e quem não está em nenhum grupo aparece como «desconhecido» em vez de um escopo, porque nenhum grupo informa um; de qualquer forma essa pessoa não lê nada, pois a matriz de conteúdo responde não para todos os relatórios.",
  "screenhelp.person.title": "Esta pessoa",
  "screenhelp.person.body": "Os grupos desta pessoa, o escopo efetivo a que esses grupos resolvem e o acesso dela ao builder, que é acesso da equipe a este console e é por pessoa de propósito, não por grupo. O cartão do escopo nomeia o escopo e os grupos de onde ele veio, e nada mais: a quantidade de linhas e o estado do build por projeto ficam na página do próprio escopo, a um clique. Leia a união como ela resolve: vence o grupo MAIS AMPLO, então um único grupo sem restrição torna inertes todas as restrições que esta pessoa tiver. Nada aqui grava uma permissão diretamente: o acesso é dado adicionando a pessoa a um grupo.",
  "screenhelp.cache.title": "Cache",
  "screenhelp.cache.body":
    "O que cada recarga calcula antes de publicar. Cada recarga pré-aquece a visão padrão de cada relatório publicado do seu projeto, e os filtros de cada grupo, antes que os dados novos apareçam; um relatório com «Todas as combinações» ligado pré-aquece também cada combinação dos seus filtros-botão. Se algo falhar, a recarga NÃO é publicada: os dados anteriores continuam com o cache completo, a execução falha e sai um e-mail. Os idiomas só contam para os relatórios cujo SQL usa o idioma; o resto é calculado uma vez para todos. As estimativas vêm da última recarga de cada projeto e são recalculadas ao mudar uma chave; um relatório sem medição diz isso em vez de mostrar um número. As mudanças valem a partir da próxima recarga de cada projeto.",
  "screenhelp.audit.title": "Registro de auditoria",
  "screenhelp.audit.body": "Cada mudança de acesso feita em Acessos, com quem a fez e quando: escopos, grupos, a matriz de conteúdo, associações, os padrões por função e cada escopo efetivo recalculado. A linha é gravada na mesma transação da mudança, então as duas coisas acontecem juntas ou nenhuma acontece: uma mudança que não pôde ser registrada não ocorreu. A migração única que criou os primeiros grupos também está aqui, marcada como «automático». O que NÃO está aqui é o que foi feito fora deste console: um SQL executado direto no banco do cliente altera o acesso e não deixa rastro aqui, então uma ação ausente desta lista não foi feita em Acessos, o que não é o mesmo que não ter sido feita. Nada é filtrado no navegador: uma visão que escondesse em silêncio linhas que o servidor devolveu é justamente como uma reconstrução perde a linha que importava.",
  "common.copy": "Copiar",
  "common.copied": "Copiado",
  "common.expand": "Expandir",
  "common.collapse": "Recolher",
  "admin.prompts.titleGlobal": "Prompts de IA globais",
  "admin.prompts.subtitleGlobal": "Modelos de fallback que o portal usa por padrão em todos os relatórios.",
  "admin.prompts.newBtnGlobal": "Novo prompt global",
  "admin.prompts.scopeBannerBodyIter27": "Estes são os prompts GLOBAIS aos quais todo relatório recorre. As substituições por relatório são editadas na aba IA do editor do relatório (Knowledge → Advanced) e não aparecem aqui para edição.",
  "admin.prompts.overridesTitle": "Relatórios com substituições ativas",
  "admin.prompts.overridesHint": "Resumo somente leitura. Edite cada substituição na aba IA do respectivo relatório.",
  "admin.prompts.editInAiTab": "Editar na aba IA",
  "admin.prompts.clientScopeReadonly": "escopo do cliente · somente leitura aqui",
  "admin.prompts.overrideDraftMissing": "relatório não encontrado, sem link",
  "inspector.identity.title": "Identidade",
  "inspector.sql.title": "Consulta SQL",
  "inspector.sql.empty": "Não definido",
  "inspector.sql.notSet": "Não definido",
  "inspector.sql.mode": "Modo de exibição do SQL",
  "inspector.sql.template": "Modelo",
  "inspector.sql.live": "Ao vivo",
  "inspector.sql.live.loading": "Carregando SQL ao vivo…",
  "inspector.sql.live.error": "Falha ao carregar o SQL ao vivo.",
  "inspector.behavior.title": "Comportamento",
  "inspector.structural.title": "Estrutural (somente leitura)",
  "inspector.kpi.sqlHint": "Interpolado no SELECT de KPI do engine, junto com a cláusula WHERE montada a partir dos filtros ativos.",
  "inspector.kpi.previousSql": "SQL do período anterior",
  "inspector.kpi.sparklineSql": "SQL do sparkline",
  "inspector.kpi.expectedSql": "SQL do valor esperado",
  "inspector.kpi.breakdownSql": "SQL do detalhamento",
  "inspector.kpi.goalDirection": "Direção da meta",
  "inspector.chart.rawSql": "SQL bruto",
  "inspector.chart.rawSqlHint": "Usado quando o gráfico precisa de um SELECT completo (por exemplo, tabelas de comparação trimestral). Os placeholders {where} e {filter:KEY} são substituídos pelo engine.",
  "inspector.table.sourceSql": "SQL de origem",
  "inspector.table.sourceSqlHint": "Consulta interna que o engine envolve com o WHERE dos filtros ativos + ordenação/limite antes de buscar as linhas.",
  "inspector.text.sql": "SQL",
  "inspector.text.sqlHint": "SQL inline opcional que o engine executa para interpolar os placeholders {value} no texto.",
  "list.col.key": "Chave",
  "list.col.name": "Nome de exibição",
  "list.col.table": "Tabela DuckDB",
  "list.col.status": "Status",
  "list.col.updated": "Atualizado",
  "list.col.actions": "Ações",
  "list.status.draft": "Rascunho",
  "list.status.published": "Publicado",
  "list.delete.confirm": "Excluir este relatório? Isso remove o rascunho e não pode ser desfeito.",
  "list.create.title": "Novo relatório",
  "list.create.key": "Chave (minúsculas, sublinhados)",
  "list.create.keyInvalid": "somente letras minúsculas, dígitos e sublinhados, e deve começar com uma letra",
  "list.create.keyExists": "A chave \"{key}\" já existe",
  "list.create.name": "Nome de exibição (obrigatório)",
  "list.create.table": "Tabela DuckDB (opcional)",
  "list.create.tableHint": "Deixe vazio se o relatório obtém seus dados de uma fonte na aba Data: a primeira fonte define a tabela. Preencha apenas para apontar para uma tabela que já existe.",
  "header.signOut": "Sair",
  "header.lang": "Idioma",
  "nav.reports": "Relatórios",
  "nav.reportsAndProjects": "Relatórios e projetos",
  "nav.templates": "Modelos",
  "templates.title": "Modelos",
  "templates.subtitle": "Pontos de partida reutilizáveis para novos relatórios.",
  "templates.empty": "Ainda não há modelos. Os modelos integrados são criados automaticamente pelo backend.",
  "templates.noDescription": "(sem descrição)",
  "templates.use": "Usar",
  "templates.edit": "Editar",
  "templates.builtin": "Integrado",
  "templates.backToList": "Voltar aos modelos",
  "templates.deleteConfirm": "Excluir o modelo \"{title}\"? Isso não pode ser desfeito.",
  "templates.stat.sections": "Seções",
  "templates.stat.items": "Itens",
  "templates.stat.filters": "Filtros",
  "nav.projects": "Projetos",
  "projects.title": "Projetos",
  "projects.subtitle": "Agrupe relatórios por projeto.",
  "nav.components": "Componentes",
  "shell.label": "Builder",
  "shell.labelTenant": "Builder · {tenant}",
  "shell.toggleMenu": "Mostrar ou ocultar o menu",
  "nav.section.intelligence": "Inteligência",
  "nav.section.admin": "Administração",
  "nav.section.help": "Ajuda",
  "gallery.title": "Componentes",
  "gallery.subtitle": "Uma base visual para o kit, os componentes de BI e o render de relatórios. Cada exemplo é o componente real com dados de exemplo.",
  "gallery.section.kpis": "Cartões de KPI",
  "gallery.section.chartsStatic": "Gráficos: estáticos",
  "gallery.section.chartsInteractive": "Gráficos: interativos (passe o mouse para ver as dicas)",
  "gallery.section.tables": "Tabelas",
  "gallery.section.filters": "Filtros",
  "gallery.section.dates": "Seletores de data",
  "gallery.section.analytics": "Analytics",
  "gallery.section.maps": "Mapas geográficos",
  "gallery.toc.title": "Nesta página",
  "gallery.toc.kpis": "Cartões de KPI",
  "gallery.toc.chartsStatic": "Gráficos: estáticos",
  "gallery.toc.chartsInteractive": "Gráficos: interativos",
  "gallery.toc.tables": "Tabelas",
  "gallery.toc.filters": "Filtros",
  "gallery.toc.dates": "Seletores de data",
  "gallery.toc.analytics": "Analytics",
  "gallery.toc.maps": "Mapas",
  "gallery.layout.grid": "Grade",
  "gallery.layout.full": "Completo",
  "gallery.code.copy": "Copiar",
  "gallery.code.copied": "Copiado",
  "gallery.code.import": "Uso: importação",
  "gallery.toggle.tooltip": "Alternar entre layout em grade e largura total",
  "projects.new": "Novo projeto",
  "projects.edit.title": "Editar projeto",
  "projects.empty": "Ainda não há projetos.",
  "projects.slug": "Slug",
  "projects.slugInvalid": "somente letras minúsculas, dígitos, hifens e sublinhados",
  "projects.slugLocked": "O slug não pode ser alterado depois que o projeto existe: seus arquivos de dados, permissões e envios dependem dele.",
  "projects.name": "Nome",
  "projects.description": "Descrição",
  "projects.color": "Cor",
  "projects.icon": "Ícone",
  "projects.iconNone": "Nenhum",
  "projects.orderIndex": "Ordem na barra lateral",
  "projects.orderIndex.help": "Números menores aparecem primeiro na barra lateral do portal; projetos com o mesmo valor são ordenados por nome.",
  "editor.chart.dataLabels.title": "Rótulos de dados e formato dos eixos",
  "editor.chart.dataLabels.show": "Mostrar rótulos de dados",
  "editor.chart.dataLabels.formatLabel": "Formato",
  "editor.chart.dataLabels.formatRaw": "Bruto",
  "editor.chart.dataLabels.formatCompact": "Compacto (K / M / B)",
  "editor.chart.dataLabels.formatCurrency": "Moeda",
  "editor.chart.dataLabels.formatPercent": "Porcentagem",
  "editor.chart.dataLabels.decimalsLabel": "Decimais",
  "editor.chart.dataLabels.axesTitle": "Eixos",
  "editor.chart.dataLabels.axisX": "Formato do eixo X",
  "editor.chart.dataLabels.axisY": "Formato do eixo Y",
  "projects.toggles.title": "Seções",
  "projects.toggles.subtitle": "Escolha quais seções de nível superior este projeto expõe na barra lateral do portal.",
  "projects.toggles.dashboard": "Dashboards",
  "projects.toggles.maestros": "Arquivos mestre",
  "projects.toggles.files": "Arquivos",
  "projects.toggles.requireOne": "Pelo menos uma seção deve permanecer habilitada.",
  "projects.form.tab.general": "Geral",
  "projects.form.tab.maestros": "Arquivos mestre",
  "projects.form.tab.archivos": "Arquivos",
  "projects.form.maestros.intro": "Personalização da aparência + prefixos S3 para a página de arquivos mestre do projeto. Campos vazios usam os textos genéricos do portal.",
  "projects.form.maestros.pageTitle": "Título da página",
  "projects.form.maestros.pageTitlePlaceholder": "ex.: Catálogos HP",
  "projects.form.maestros.subtitle": "Subtítulo",
  "projects.form.maestros.subtitlePlaceholder": "ex.: Dados de referência para este relatório",
  "projects.form.maestros.emptyMessage": "Mensagem de estado vazio",
  "projects.form.maestros.emptyMessagePlaceholder": "Exibida quando nenhum prefixo está configurado",
  "projects.form.maestros.prefixesNote": "Os prefixos S3 do loader de dados mestre hoje ficam na coluna JSONB e são gerenciados pelo pipeline do loader. Eles aparecerão aqui como uma lista editável em uma iteração futura.",
  "projects.form.archivos.intro": "Aparência + raiz S3 + tipos permitidos para a página Arquivos do projeto. O portal usa esses valores por projeto.",
  "projects.form.archivos.pageTitle": "Título da página",
  "projects.form.archivos.pageTitlePlaceholder": "ex.: Downloads trimestrais",
  "projects.form.archivos.subtitle": "Subtítulo",
  "projects.form.archivos.subtitlePlaceholder": "ex.: Relatórios e exportações trimestrais",
  "projects.form.archivos.emptyMessage": "Mensagem de estado vazio",
  "projects.form.archivos.emptyMessagePlaceholder": "Exibida quando a listagem S3 na raiz está vazia",
  "projects.form.archivos.s3RootPath": "Caminho raiz S3",
  "projects.form.archivos.allowedTypes": "Tipos de arquivo permitidos",
  "projects.form.archivos.allowedTypesNote": "Quando vazio, o portal aceita todos os tipos; clique em um chip para adicionar/remover.",
  "projects.form.archivos.maxSize": "Tamanho máximo de upload (MB)",
  "projects.form.archivos.allowUpload": "Mostrar o botão de upload na página Arquivos",
  "projects.form.tab.data": "Dados",
  "projects.form.tab.loader": "Atualização automática",
  "loader.loading": "Carregando…",
  "loader.noDataSource": "Configure primeiro uma fonte de dados na aba Data: o loader precisa de algo para atualizar.",
  "loader.scheduleTitle": "Agendamento",
  "loader.enabled": "Habilitar atualização automática",
  "loader.cron": "Expressão cron",
  "loader.cronHelp": "Cron padrão de 5 campos: minuto hora dia mês dia da semana. Exemplo: 0 3 * * * executa todos os dias às 03:00.",
  "loader.timezone": "Fuso horário",
  "loader.timezoneHelp": "Nome IANA (UTC, America/Argentina/Buenos_Aires, …). Determina quando o cron dispara.",
  "loader.mode": "Modo de atualização",
  "loader.mode.reload": "Recarga completa (recomendado)",
  "loader.mode.incremental": "Incremental",
  "loader.mode.rebuild": "Reconstrução",
  "loader.maxRuntime": "Tempo máximo de execução (segundos)",
  "loader.maxRuntimeHelp": "Em breve. Hoje não há limite de tempo: uma atualização roda até terminar ou falhar.",
  "loader.soon": "Em breve",
  "loader.loadFailed": "Não foi possível carregar o agendamento de atualização, por isso o formulário permanece oculto: salvá-lo agora sobrescreveria o agendamento armazenado com valores padrão.",
  "loader.runNowTitle": "Atualização manual",
  "loader.runNowHelp": "Executa o loader agora usando o modo do agendamento salvo. Bloqueia até concluir ou falhar.",
  "loader.runNow": "Executar agora",
  "loader.runNowHint": "Inativo. O botão Executar agora enfileira uma nova recarga e aguarda até que ela termine.",
  "loader.forceReap": "Forçar interrupção + executar agora",
  "loader.forceReapHelp": "Há um job em andamento. Forçar interrupção o encerra (marcando-o como falho) e inicia uma recarga nova.",
  "loader.forceReapConfirm": "Isso marcará o job pendente/em execução atual como falho e iniciará uma nova recarga. Continuar?",
  "loader.recentJobsTitle": "Jobs recentes",
  "loader.noJobs": "Ainda não há jobs. Agende um ou clique em Executar agora.",
  "loader.statusActive": "Agendador ativo",
  "loader.statusIdle": "Agendador inativo",
  "loader.statusDisabled": "Agendador desabilitado",
  "loader.statusLoadFailed": "Não foi possível carregar o status do agendador: {error}",
  "loader.leaseHolder": "Líder",
  "loader.lastTick": "Último tick",
  "loader.recon.title": "Detalhe da reconciliação",
  "loader.recon.jobLabel": "Job",
  "loader.recon.loading": "Carregando linhas de reconciliação…",
  "loader.recon.empty": "Não há dados de reconciliação para este job.",
  "loader.recon.layerGate": "Gate (A·B)",
  "loader.recon.layerPortalCache": "Portal (B·C)",
  "loader.recon.layerPortalHttp": "Portal HTTP (B·C)",
  "loader.recon.colElement": "Elemento",
  "loader.recon.colLayer": "Camada",
  "loader.recon.colStatus": "Status",
  "loader.recon.colGolden": "Golden (A)",
  "loader.recon.colObserved": "Observado",
  "loader.recon.colDelta": "Δ",
  "loader.recon.noChecks": "Sem verificações",
  "loader.recon.noChecksTitle": "Nenhuma asserção foi comparada nesta execução.",
  "loader.recon.portalNotChecked": "Portal não verificado: 0 asserções comparadas.",
  "projects.form.data.intro": "Configure UMA fonte consolidada para o projeto inteiro: um parquet no S3, um arquivo DuckDB, ou um arquivo CSV / Excel carregado aqui. A fatia de dados de cada relatório passa a ser uma view SQL sobre esse dado bruto; defina o corpo da view na aba Data do próprio relatório.",
  "projects.form.data.kindLabel": "Tipo",
  "projects.form.data.urlLabel": "URL do S3",
  "projects.form.data.tableLabel": "Tabela de destino (opcional)",
  "projects.form.data.tableHint": "O padrão é project_raw_{slug}. As views referenciam esse nome em seus SELECT.",
  "projects.form.data.aliasLabel": "Alias de attach (opcional)",
  "projects.form.data.saveBtn": "Salvar URL",
  "projects.form.data.reloadBtn": "Recarregar do S3",
  "projects.form.data.clearBtn": "Limpar",
  "projects.form.data.clearConfirm": "Limpar a fonte de dados do projeto? Isso descarta a tabela bruta materializada e zera os campos de auditoria. Os relatórios do tipo view falharão até você reconfigurar.",
  "projects.form.data.loadedAt": "Última carga",
  "projects.form.data.rows": "Linhas",
  "projects.form.data.columns": "Colunas",
  "projects.form.data.tables": "Tabelas",
  "projects.form.data.columnsShort": "cols",
  "projects.form.data.schemaTitle": "Esquema",
  "projects.form.data.catalogTitle": "Catálogo",
  "projects.form.data.viewWarnings": "A recarga foi concluída, mas algumas views dependentes não puderam ser recriadas:",
  "projects.form.data.connectionLabel": "Conexão",
  "projects.form.data.connectionNone": "(nenhuma)",
  "projects.form.data.connectionHint": "As credenciais vêm da conexão selecionada. Obrigatória para fontes postgres e api, e para qualquer URL s3://.",
  "projects.form.data.blockedUrl": "Informe a URL do S3 do arquivo a carregar.",
  "projects.form.data.blockedParquetExt": "A URL deve terminar em .parquet para uma fonte parquet.",
  "projects.form.data.blockedDuckdbExt": "A URL deve terminar em .duckdb para uma fonte duckdb (attach).",
  "projects.form.data.blockedTable": "Informe o nome da tabela de origem a copiar do arquivo .duckdb anexado.",
  "projects.form.data.blockedUpload": "Carregue o arquivo primeiro.",
  "projects.form.data.blockedSheet": "Escolha qual planilha da pasta de trabalho carregar.",
  "projects.form.data.blockedConnection": "Escolha uma conexão: uma URL s3:// é lida com as credenciais dela, não há acesso anônimo.",
  "projects.form.data.blockedNoConnections": "Este projeto ainda não tem conexão, e uma URL s3:// é lida com as credenciais de uma conexão, não há acesso anônimo. Crie uma com “Adicionar conexão” acima (uma conexão compartilhada de outro projeto pode ser reutilizada apontando para a mesma referência de segredo).",
  "projects.form.data.attachTableLabel": "Tabela de origem dentro do arquivo",
  "projects.form.data.attachTableHint": "Obrigatório: a tabela a copiar do .duckdb anexado para project_raw_{slug}. Não há valor padrão.",
  "projects.form.data.kind.parquet": "Parquet no S3 (OBT)",
  "projects.form.data.kind.duckdb_attach": "Arquivo DuckDB (attach)",
  "projects.form.data.kind.postgres": "Consulta Postgres",
  "projects.form.data.kind.api": "API JSON",
  "projects.form.data.kindSoon": "Em breve",
  "projects.form.data.blockedKindSoon": "Este projeto usa uma fonte {kind}. Este formulário ainda não consegue editar essa fonte (em breve), então ela é somente leitura aqui; a recarga ainda a executa como foi salva.",
  "projects.form.data.kindCsv": "Arquivo CSV / TSV (upload)",
  "projects.form.data.kindExcel": "Arquivo Excel .xlsx (upload)",
  "projects.form.data.saveUploadBtn": "Salvar arquivo como fonte",
  "projects.form.data.reloadUploadBtn": "Recarregar dados do projeto",
  "projects.form.data.upload.title": "Arquivo carregado",
  "projects.form.data.upload.subtitle": "Todo o conjunto de dados do projeto vem deste arquivo. Aceitos: .csv, .tsv e .xlsx, até 100 MB.",
  "projects.form.data.upload.chooseBtn": "Escolher um arquivo…",
  "projects.form.data.upload.replaceBtn": "Escolher outro arquivo…",
  "projects.form.data.upload.uploading": "Carregando e inspecionando…",
  "projects.form.data.upload.rowsRead": "{rows} linhas · {columns} colunas lidas",
  "projects.form.data.upload.stagedNote": "Carregado, mas ainda não publicado. Salve a fonte e depois recarregue os dados do projeto.",
  "projects.form.data.upload.sheetLabel": "Planilha",
  "projects.form.data.upload.sheetPlaceholder": "Escolha uma planilha…",
  "projects.form.data.upload.sheetNoWorkbook": "Carregue um arquivo .xlsx para listar suas planilhas.",
  "projects.form.data.upload.sheetHint": "Somente esta planilha é carregada. Nada mais da pasta de trabalho é lido. Para usar outra, escolha-a aqui, salve e recarregue.",
  "projects.form.data.upload.sheetRequired": "Esta pasta de trabalho tem mais de uma planilha. Escolha a que contém os dados: ela nunca é adivinhada.",
  "projects.form.data.upload.delimiterLabel": "Separador de campos (opcional)",
  "projects.form.data.upload.delimiterPlaceholder": "detecção automática",
  "projects.form.data.upload.delimiterHint": "Deixe vazio e o separador será detectado a partir do arquivo. Digite um caractere para forçá-lo (\\t para tab).",
  "projects.form.data.upload.headerLabel": "A primeira linha contém os nomes das colunas",
  "projects.form.data.upload.allVarcharLabel": "Ler todas as colunas como texto",
  "projects.form.data.upload.allVarcharHint": "Use quando um código estiver sendo lido como número e perdendo os zeros à esquerda (CEPs, IDs de produto).",
  "projects.form.data.upload.guideTitle": "Como preparar e carregar o arquivo, passo a passo",
  "projects.form.data.upload.guideStep1": "Os formatos aceitos são .csv, .tsv e .xlsx. Os antigos .xls, pastas de trabalho com macros (.xlsm), pastas binárias (.xlsb), OpenDocument (.ods) e arquivos do Apple Numbers são recusados, porque não podem ser lidos de forma confiável.",
  "projects.form.data.upload.guideStep2": "Se o seu arquivo for um desses, converta-o primeiro. No Excel: Arquivo > Salvar como > Procurar e, em 'Tipo', escolha 'Pasta de Trabalho do Excel (*.xlsx)' ou 'CSV UTF-8 (delimitado por vírgulas) (*.csv)'. No Google Sheets: Arquivo > Fazer download > 'Microsoft Excel (.xlsx)' ou 'Valores separados por vírgula (.csv)'. No LibreOffice Calc: Arquivo > Salvar como e, em 'Tipo de arquivo', escolha 'Excel 2007-365 (.xlsx)' ou 'CSV de texto'.",
  "projects.form.data.upload.guideStep3": "A primeira linha deve conter os nomes das colunas, sem linhas de título, sem células mescladas e sem linhas em branco acima dela. Se o seu arquivo realmente não tem linha de cabeçalho, desmarque 'A primeira linha contém os nomes das colunas' abaixo e as colunas serão chamadas column0, column1, …",
  "projects.form.data.upload.guideStep4": "Tamanho máximo: 100 MB. Um arquivo maior é recusado; nesses casos, use uma conexão parquet, DuckDB ou Postgres, que leem direto do armazenamento e não têm limite de tamanho.",
  "projects.form.data.upload.guideStep5": "Clique em 'Escolher um arquivo…' acima. O arquivo é carregado e inspecionado na hora, e você verá quantas linhas e colunas foram realmente lidas. Nada é publicado ainda: o que o portal serve não mudou.",
  "projects.form.data.upload.guideStep6": "Somente Excel: escolha a planilha. Uma pasta de trabalho com uma única planilha a seleciona sozinha; uma com várias sempre pergunta, porque carregar a aba errada publicaria números errados sem nenhum erro. Somente a planilha escolhida é lida.",
  "projects.form.data.upload.guideStep7": "Clique em 'Salvar arquivo como fonte' e depois em 'Recarregar dados do projeto'. É a recarga que publica: a tabela project_raw_{slug} é reconstruída e todas as views de relatório sobre ela são recriadas.",
  "projects.form.data.upload.guideStep8": "Para atualizar os dados depois, carregue um arquivo novo do mesmo modo. Cada recarga SUBSTITUI a tabela inteira: é uma substituição completa, nunca um acréscimo, então as linhas que você apagar do arquivo somem dos dashboards. O arquivo antigo é removido assim que o novo é salvo.",
  "projects.form.data.upload.guideStep9": "Se o novo arquivo estiver vazio, ilegível ou gerar zero linhas, a recarga falha e os dados já publicados continuam no ar, intactos. Mantenha estáveis os nomes e tipos das colunas: se mudarem, a recarga informa exatamente qual view de relatório quebrou.",
  "projects.data.sub.source": "Fonte",
  "projects.data.sub.dimensions": "Dimensões",
  "projects.data.sub.ariaLabel": "Seções de dados",
  "dimensions.title": "Dimensões",
  "dimensions.subtitle": "Uma coluna pela qual os dados podem ser filtrados e restringidos. É definida uma única vez aqui e serve para as duas coisas.",
  "dimensions.add": "Adicionar dimensão",
  "dimensions.col.dimension": "Dimensão",
  "dimensions.col.origin": "Origem",
  "dimensions.col.definition": "Definição",
  "dimensions.col.values": "Valores",
  "dimensions.col.usedIn": "Usada em",
  "dimensions.col.status": "Status",
  "dimensions.origin.column": "Coluna",
  "dimensions.origin.mapping": "Mapeamento",
  "dimensions.origin.computed": "Calculada",
  "dimensions.def.mapping": "{match} → «{collection}» / {sheet}: {key} → {value}",
  "dimensions.def.noneHint": "Esta linha não tem definição, então nada consegue resolvê-la. Ela não foi criada a partir desta tela.",
  "dimensions.status.ok": "Pronta",
  "dimensions.status.needs_reload": "Recarga pendente",
  "dimensions.status.inert": "Não habilitada para nada",
  "dimensions.status.schema_drift": "Esquema divergente",
  "dimensions.status.unresolvable": "Não pode ser resolvida",
  "dimensions.usableAs.filter": "Filtro",
  "dimensions.usableAs.scope": "Escopo",
  "dimensions.usableAs.none": "Não habilitada para nada",
  "dimensions.usableAs.noneHint": "Uma dimensão sem nenhum uso habilitado fica invisível para os filtros e faz com que todo escopo que a nomeie não conceda nenhum acesso. Marque «Escopo» antes de escrever uma regra com ela.",
  "dimensions.usedIn.scopes": "{n} escopo(s)",
  "dimensions.usedIn.noneHint": "Ainda não há regras de escopo de acesso nesta dimensão.",
  "dimensions.values.n": "{n} distintos",
  "dimensions.values.view": "Ver valores",
  "dimensions.values.unavailable": "Não está nos dados",
  "dimensions.values.unavailableHint": "A coluna a que esta dimensão resolve não está no arquivo vivo do projeto, então não há nada para contar. A coluna Status explica o motivo.",
  "dimensions.values.errorTitle": "Não foi possível ler os valores",
  "dimensions.values.summary": "{shown} de {total} valores distintos de «{column}» ({type}).",
  "dimensions.values.nulls": "{n} linha(s) não têm valor. Elas não pertencem a nenhum escopo restrito: uma regra IN nunca corresponde a um valor vazio.",
  "dimensions.values.notScopableTitle": "Não utilizável em regras de acesso",
  "dimensions.values.notScopable": "Estes valores são reais e funcionam como filtro, mas uma regra de escopo sobre uma coluna {type} é recusada quando o arquivo de escopo é construído. Para acesso, use uma dimensão de tipo texto ou numérico.",
  "dimensions.values.rowCount": "{n} linha(s)",
  "dimensions.values.nullValue": "(sem valor)",
  "dimensions.values.versionKey": "Lido da versão {key} do arquivo do projeto.",
  "dimensions.detail.whyTitle": "Por que este estado",
  "dimensions.detail.notInStoredSchema": "O arquivo vivo contém esta coluna, mas a última recarga não a registrou no esquema do projeto. O que decide é o arquivo, e nada aqui reconcilia os dois.",
  "dimensions.actions.edit": "Editar",
  "dimensions.actions.delete": "Excluir",
  "dimensions.delete.confirm": "Excluir a dimensão «{name}»? Qualquer escopo de acesso que dependa dela deixa de conceder acesso a este projeto na próxima recarga.",
  "dimensions.error.title": "O que o servidor respondeu",
  "dimensions.empty.title": "Ainda não há dimensões",
  "dimensions.empty.desc": "Ainda não é possível filtrar nem restringir nada por nada aqui. Uma dimensão é uma coluna: uma que já existe, um valor traduzido por um arquivo mestre que o cliente mantém, ou uma calculada com SQL.",
  "dimensions.loaderUnavailable": "Não foi possível verificar a última recarga, então uma falha nas dimensões não apareceria aqui: {message}",
  "dimensions.reloadFailed.title": "A última recarga parou na dimensão «{dimension}»",
  "dimensions.reloadFailed.titleGeneric": "A última recarga parou na fase de dimensões",
  "dimensions.reloadFailed.more": "Ver o que o servidor respondeu",
  "dimensions.reloadFailed.less": "Ocultar",
  "dimensions.reloadFailed.unmapped": "O arquivo mestre indicado abaixo não cobre todos os valores dos dados. Abra os arquivos mestre deste projeto no portal, adicione as linhas que faltam na planilha indicada e execute a recarga novamente. Não existe um grupo «Outros», de propósito, e enquanto isso os dados anteriores continuam publicados.",
  "dimensions.reloadFailed.body": "Nada foi publicado e os dados anteriores continuam no ar. Corrija a definição indicada abaixo e execute a recarga novamente.",
  "dimensions.form.createTitle": "Nova dimensão",
  "dimensions.form.editTitle": "Editar dimensão",
  "dimensions.form.rejected": "O servidor recusou esta definição",
  "dimensions.form.keyLabel": "Chave",
  "dimensions.form.keyHelp": "Letras minúsculas, dígitos e sublinhados, começando com uma letra. Em uma dimensão de mapeamento ou calculada, ela vira uma coluna real dos dados e é o que as regras de acesso referenciam.",
  "dimensions.form.keyHelpEdit": "Renomear é permitido, mas o servidor recusa enquanto houver um escopo de acesso que conceda regras deste projeto sobre a chave antiga, e a recusa nomeia esses escopos.",
  "dimensions.form.keyInvalid": "A chave deve conter apenas letras minúsculas, dígitos e sublinhados, e começar com uma letra.",
  "dimensions.form.labelLabel": "Nome",
  "dimensions.form.labelHelp": "Os dois idiomas são obrigatórios: um nome preenchido pela metade aparece como chave bruta em uma das duas telas.",
  "dimensions.form.labelIncomplete": "Preencha o nome nos dois idiomas.",
  "dimensions.form.originLabel": "Origem",
  "dimensions.form.originHelp": "Uma coluna que já está nos dados, um valor traduzido por um arquivo mestre que o cliente mantém, ou uma calculada com SQL.",
  "dimensions.form.originHelpEdit": "A origem não pode ser alterada: ela decide o que a coluna de origem SIGNIFICA, enquanto todas as regras de acesso existentes continuariam apontando para a mesma chave. Exclua a dimensão e crie-a novamente.",
  "dimensions.form.usableAsLabel": "Utilizável para",
  "dimensions.form.usableAsHelp": "Para que esta dimensão é oferecida. Os filtros a leem no editor de relatórios; os escopos criam regras sobre ela para decidir quem vê quais linhas.",
  "dimensions.form.column.sourceLabel": "Coluna de origem",
  "dimensions.form.column.sourceHelp": "A lista é o que a última recarga registrou. O servidor verifica o arquivo VIVO, então uma coluna que não está na lista ainda pode existir.",
  "dimensions.form.column.other": "Outra coluna, que não está na lista…",
  "dimensions.form.column.otherLabel": "Nome da coluna",
  "dimensions.form.mapping.matchLabel": "Coluna a traduzir",
  "dimensions.form.mapping.matchHelp": "A coluna bruta cujos valores são procurados na planilha do arquivo mestre.",
  "dimensions.form.mapping.collectionLabel": "Arquivo mestre (slug)",
  "dimensions.form.mapping.collectionHelp": "O slug de um arquivo mestre DESTE projeto. Não é possível nomear aqui o arquivo mestre de outro projeto.",
  "dimensions.form.mapping.sheetLabel": "Planilha (nome normalizado)",
  "dimensions.form.mapping.sheetHelp": "Em minúsculas, com espaços e hifens convertidos em sublinhados.",
  "dimensions.form.mapping.keyColumnLabel": "Coluna-chave da planilha",
  "dimensions.form.mapping.keyColumnHelp": "Pelo que o valor bruto é procurado.",
  "dimensions.form.mapping.valueColumnLabel": "Coluna de valor da planilha",
  "dimensions.form.mapping.valueColumnHelp": "No que o valor bruto SE TORNA. É gravado nos dados como uma nova coluna com o nome da chave acima.",
  "dimensions.form.mapping.sameColumn": "A chave e o valor não podem ser a mesma coluna: o mapeamento seria uma coluna de cópias.",
  "dimensions.form.mapping.noPickerTitle": "Ainda não há seletor para estes três",
  "dimensions.form.mapping.noPicker": "Digite os nomes como aparecem em Arquivos mestre, no portal. Se algum estiver errado, o servidor responde com a lista real de arquivos mestre, planilhas ou colunas que encontrou, e essa resposta é exibida aqui.",
  "dimensions.form.computed.exprLabel": "Expressão SQL",
  "dimensions.form.computed.exprHelp": "Uma expressão sobre uma linha: sem SELECT, sem subconsulta, sem função de janela e sem agregação. O servidor a verifica contra o arquivo real antes de salvar.",
  "dimensions.form.computed.unknownColumns": "Estas colunas entre aspas não estão no esquema registrado: {columns}",
  "dimensions.form.computed.caseMismatch": "«{used}» está escrito com maiúsculas/minúsculas diferentes de «{suggest}».",
  "projects.connections.title": "Conexões",
  "projects.connections.intro": "Origens nomeadas das quais este projeto pode ler. Uma conexão guarda host / url e um PONTEIRO para suas credenciais, nunca as credenciais em si.",
  "projects.connections.addBtn": "Adicionar conexão",
  "projects.connections.empty": "Ainda não há conexões.",
  "projects.connections.nameLabel": "Nome",
  "projects.connections.kindLabel": "Tipo",
  "projects.connections.configLabel": "Configuração (JSON, somente campos não secretos)",
  "projects.connections.configInvalidJson": "A configuração não é um JSON válido: {detail}",
  "projects.connections.secretRefLabel": "Referência do segredo",
  "projects.connections.secretRefHint": "env:NAME lê a variável de ambiente BUILDER_SECRET_<TENANT>_NAME (um objeto JSON com todos os campos); não há fallback para o nome sem prefixo. vault:tenants/<tenant>/connections/<name> lê o mesmo objeto JSON do secret store (grave-o com `python -m tenancy.secret_store set`). Deixe vazio somente para fontes que não precisam de credenciais.",
  "projects.connections.saveBtn": "Salvar",
  "projects.connections.cancelBtn": "Cancelar",
  "projects.connections.editBtn": "Editar",
  "projects.connections.deleteBtn": "Excluir",
  "projects.connections.testBtn": "Testar",
  "projects.connections.testing": "Testando…",
  "projects.connections.testOk": "Conexão OK",
  "projects.connections.testFailed": "Falha na conexão",
  "projects.connections.deleteConfirm": "Excluir a conexão \"{name}\"? Qualquer fonte de dados de projeto que aponte para ela deve ser redirecionada antes.",
  "projects.connections.noCredentialsNotice": "Este formulário nunca aceita uma senha ou token. Coloque os valores na variável de ambiente indicada pela referência do segredo.",
  "projects.deleteConfirm": "Excluir o projeto \"{name}\"? Os relatórios não serão excluídos, apenas desvinculados.",
  "list.group.noProject": "Sem grupo",
  "list.create.project": "Projeto",
  "list.create.project.none": "(nenhum)",
  "list.create.template": "Começar a partir de",
  "list.create.template.empty": "Vazio (começar do zero)",
  "editor.preset.title": "Presets",
  "editor.preset.add": "Adicionar preset",
  "editor.preset.empty": "Nenhum preset configurado: adicione pelo menos um para que os chips apareçam no portal.",
  "editor.preset.default": "padrão",
  "editor.preset.defaultHint": "Referenciado como default_value",
  "editor.preset.resolves": "Resolve para:",
  "editor.preset.resolving": "Resolvendo…",
  "editor.preset.moveUp": "Mover para cima",
  "editor.preset.moveDown": "Mover para baixo",
  "editor.preset.lengthDays": "Duração (dias)",
  "editor.preset.lengthMonths": "Duração (meses)",
  "editor.preset.kind.absolute_range": "Intervalo absoluto",
  "editor.preset.kind.relative_days": "Dias relativos",
  "editor.preset.kind.relative_months": "Meses relativos",
  "editor.preset.kind.hp_fiscal_q": "Trimestre fiscal HP",
  "editor.preview": "Pré-visualização",
  "editor.save": "Salvar",
  "editor.publish": "Publicar",
  "editor.unpublish": "Despublicar",
  "editor.autosave": "Salvamento automático",
  "editor.dirty": "Não salvo",
  "editor.saved": "Salvo",
  "editor.saveFailed": "Falha ao salvar",
  "editor.saveInProgress": "Já há um salvamento em andamento. Aguarde a conclusão e tente novamente.",
  "editor.unpublishFailed": "Falha ao despublicar",
  "editor.published": "Publicado",
  "tab.dashboard": "Dashboard",
  "tab.data": "Dados",
  "tab.ai": "IA",
  "tab.master": "Arquivos mestre",
  "tab.files": "Arquivos",
  "publish.title": "Publicar relatório",
  "publish.body": "Publicar torna o relatório visível para todos os usuários do hp-portal no próximo reinício do backend. A versão publicada anterior (se houver) é substituída.",
  "publish.validating": "Validando contra o esquema do DuckDB…",
  "publish.passed": "Validação aprovada, pronto para publicar.",
  "publish.success": "Publicado com sucesso. Fechando…",
  "publish.warningsTitle": "avisos",
  "publish.errorsTitle": "Não é possível publicar, corrija estes problemas primeiro",
  "publish.confirm": "Publicar",
  "publish.close": "Fechar",
  "publish.confirmAnyway": "Publicar mesmo assim",
  "views.checking": "Testando as visões salvas do Home com IA que leem este relatório…",
  "views.checkFailed": "Não foi possível testar as visões salvas do Home com IA.",
  "views.checkFailedBody": "A resposta foi: {error}. Você pode seguir mesmo assim, sem saber se alguma quebra.",
  "views.none": "Nenhuma visão salva do Home com IA lê este relatório.",
  "views.ok_one": "A visão salva do Home com IA que lê este relatório continua funcionando.",
  "views.ok_other": "As {count} visões salvas do Home com IA que leem este relatório continuam funcionando.",
  "views.brokenTitle_one": "1 visão salva do Home com IA deixaria de funcionar",
  "views.brokenTitle_other": "{count} visões salvas do Home com IA deixariam de funcionar",
  "views.brokenBody_one": "Testamos a visão que lê este relatório com a configuração nova, como o dono a abriria. Se publicar mesmo assim, o dono verá o erro ao abri-la.",
  "views.brokenBody_other": "Testamos as {count} visões que leem este relatório com a configuração nova, como cada dono as abriria. Se publicar mesmo assim, cada dono verá o erro ao abrir sua visão.",
  "views.brokenBodyLive_one": "Testamos a visão que lê este relatório com a configuração nova, como o dono a abriria. Se salvar mesmo assim, o dono verá o erro ao abri-la.",
  "views.brokenBodyLive_other": "Testamos as {count} visões que leem este relatório com a configuração nova, como cada dono as abriria. Se salvar mesmo assim, cada dono verá o erro ao abrir sua visão.",
  "views.stillWork_one": "Mais {count} visão continua funcionando",
  "views.stillWork_other": "Mais {count} visões continuam funcionando",
  "views.copy": "Copiar a lista",
  "views.copied": "Copiada",
  "views.alreadyBroken_one": "1 visão já falhava antes desta mudança",
  "views.alreadyBroken_other": "{count} visões já falhavam antes desta mudança",
  "views.colView": "Visão salva",
  "views.colOwner": "Dono",
  "views.colFails": "O que falha",
  "views.wholeView": "Não abre",
  "views.someElements_one": "{count} elemento",
  "views.someElements_other": "{count} elementos",
  "views.saveTitle": "Salvar alterações",
  "views.saveBody": "Este relatório está publicado: ao salvar, as alterações ficam ao vivo para todos.",
  "views.keepEditing": "Continuar editando",
  "views.saveAnyway": "Salvar mesmo assim",
  "views.publishGroupTitle": "Publicar grupo de relatórios",
  "views.publishGroupBody": "Alguns relatórios deste grupo quebrariam visões salvas do Home com IA ao ficarem ao vivo.",
  "publish.unpublishConfirm": "Despublicar este relatório? Ele desaparecerá do hp-portal no próximo reinício do backend.",
  "table.title": "Dados",
  "table.search": "Buscar…",
  "table.crossfilter.apply": "Filtrar o relatório por este valor",
  "filterbar.profile": "Perfil",
  "filterbar.saveView": "Salvar visão",
  "filterbar.soon": "em breve",
  "filterbar.savedFilters": "Filtros salvos",
  "filterbar.skuList": "Lista de SKU",
  "filterbar.skuListApplied": "Lista de SKU · {n}",
  "filterbar.skuListCodes": "{n} códigos",
  "filterbar.skuListUpload": "Enviar arquivo…",
  "filterbar.skuListClear": "Remover a lista de SKU",
  "inspector.dashboard.filtersLayoutRows": "Linhas",
  "table.action.filter": "Filtrar",
  "table.action.clear": "Limpar filtro",
  "table.total": "Total",
  "table.crossfilter.clear": "Limpar este filtro",
  "table.rowdrill.hint": "Clique para expandir o detalhe da linha",
  "table.rowdrill.open": "Ver detalhe",
  "table.rowdrill.close": "Fechar detalhe",
  "table.rowdrill.back": "Voltar",
  "table.rowdrill.detail": "Detalhe da linha",
  "table.rowdrill.invalidMode": "O row_drill_mode desta tabela é '{value}', mas deve ser accordion ou swap. Corrija no builder.",
  "table.rowdrill.view.table": "Tabela",
  "table.rowdrill.view.chart": "Gráfico",
  "table.rowdrill.view.both": "Ambos",
  "table.rowdrill.view.label": "Visão",
  "table.export": "Exportar",
  "table.exportXlsx": "Exportar para XLSX",
  "table.exportCsvLatam": "Exportar para CSV (LatAm)",
  "table.exportCsvUs": "Exportar para CSV (EUA)",
  "table.exportFailed": "Falha na exportação, nenhum arquivo foi baixado.",
  "table.exporting": "Exportando…",
  "table.exportXlsxAsCsv": "A tabela tem mais de 250.000 linhas, então foi exportada como CSV (LATAM) em um ZIP com um arquivo a cada 250.000 linhas, em vez de Excel.",
  "table.openLink": "Ver ↗",
  "table.fullscreen": "Tela cheia",
  "table.exitFullscreen": "Sair da tela cheia",
  "table.chips.filter": "Filtros rápidos",
  "table.chips.sort": "Ordenar por",
  "table.noData": "Sem dados",
  "table.previous": "Anterior",
  "table.next": "Próxima",
  "dashboard.table.previous": "Anterior",
  "dashboard.tabs.aria": "Visões do relatório",
  "dashboard.tabs.back": "Voltar para {tab}",
  "dashboard.glossary.open": "Glossário",
  "dashboard.glossary.title": "Glossário",
  "dashboard.glossary.close": "Fechar o glossário",
  "dashboard.scope.aria": "Filtros ativos",
  "dashboard.scope.all": "Todos",
  "dashboard.scope.latest": "Último dia com dados",
  "inspector.section.tab": "Aba",
  "inspector.section.tabNone": "(primeira aba)",
  "dashboard.longwait.label": "Ainda consultando os dados…",
  "chart.clickFilter": "Clique para filtrar",
  "chart.shareBreakdown.of": "de",
  "dashboard.table.next": "Próxima",
  "dashboard.chart.calloutNoRow": "Este bloco não retornou nenhuma linha",
  "dashboard.chart.missingMetric": "A consulta não retorna a coluna \"metric\" (colunas: {columns}). Dê o alias metric ao valor.",
  "dashboard.chart.aiGenerated": "IA",
  "dashboard.chart.aiGeneratedLong": "Gerado por IA",
  "dashboard.chart.unknownType": "Tipo de gráfico desconhecido: {type}",
  "dashboard.chart.calendarDuplicateDay": "Mais de uma linha para o mesmo dia: {day}",
  "dashboard.kpi.previous": "Anterior",
  "dashboard.error.charts": "Não foi possível carregar os gráficos",
  "dashboard.error.texts": "Não foi possível carregar os textos",
  "dashboard.error.drill": "Não foi possível carregar o detalhe",
  "table.exportSheet": "Dados",
  "dashboard.chart.bulletMissingTargetMax": "Cada linha deste gráfico precisa de uma meta numérica e de um máximo maior que 0",
  "dashboard.chart.mapLoadError": "Não foi possível carregar os limites do mapa",
  "dashboard.chart.map.byCountry": "Por país",
  "dashboard.chart.map.byRegion": "Por região",
  "dashboard.chart.map.scale": "Escala",
  "dashboard.chart.map.low": "Baixo",
  "dashboard.chart.map.high": "Alto",
  "dashboard.chart.map.noData": "Sem dados",
  "dashboard.chart.map.loading": "Carregando mapa…",
  "dashboard.chart.calendar.less": "Menos",
  "dashboard.chart.calendar.more": "Mais",
  "dashboard.kpi.anomalyExpected": "esperado",
  "dashboard.chart.readoutLoading": "Gerando a leitura…",
  "dashboard.chart.readoutUnavailable": "A leitura narrativa é gerada no portal",
  "dashboard.portfolio.unavailable": "O portfólio de visões salvas é calculado no portal, para o usuário conectado",
  "dashboard.portfolio.loading": "Carregando suas visões salvas…",
  "dashboard.portfolio.stale": "Mostrando o portfólio anterior — a atualização falhou",
  "dashboard.portfolio.empty.title": "Salve sua primeira visão",
  "dashboard.portfolio.empty.body": "Restrinja os filtros a um grupo comparável de produtos e salve. Cada visão salva aparece aqui como um cartão, com a posição da marca nela.",
  "dashboard.portfolio.empty.cta": "Abrir filtros salvos",
  "dashboard.portfolio.header.save": "Salvar filtros atuais",
  "dashboard.portfolio.summary.winRate": "Win rate",
  "dashboard.portfolio.summary.winRateHint": "{lead} de {total} visões com a marca foco líder",
  "dashboard.portfolio.summary.behind": "Atrás",
  "dashboard.portfolio.summary.behindHint": "{n} de {total} visões",
  "dashboard.portfolio.summary.position": "Posição",
  "dashboard.portfolio.summary.positionHint": "com comparação em {present} de {total} visões",
  "dashboard.portfolio.summary.leaders": "Liderança entre marcas",
  "dashboard.portfolio.summary.leadersHint": "quem lidera cada visão",
  "dashboard.portfolio.summary.of": "de",
  "dashboard.portfolio.card.leader": "Líder: {brand}",
  "dashboard.portfolio.card.open": "Abrir esta visão →",
  "dashboard.portfolio.card.focus": "Foco",
  "dashboard.portfolio.card.noFilters": "Todo o catálogo",
  "dashboard.chart.readoutStale": "Exibindo a leitura anterior: a atualização falhou",
  "dashboard.blockError.title": "Não foi possível carregar estes dados",
  "dashboard.blockError.retry": "Tentar novamente",
  "dashboard.blockError.stale": "Falha na atualização: exibindo os dados anteriores",
  "dashboard.table.showing": "Exibindo {from}-{to} de {total}",
  "common.export": "Exportar",
  "common.noData": "Sem dados",
  "common.loadingData": "Carregando dados…",
  "table.showingOf": "Exibindo {from}-{to} de {total} {label}",
  "table.rowsLabel": "linhas",
  "table.rows": "{count} linhas",
  "table.count": "{count} produtos",
  "filterbar.title": "FILTROS",
  "filterbar.clearAll": "Limpar tudo",
  "filterbar.pick": "Escolher…",
  "filterbar.all": "Todos",
  "filterbar.locked": "bloqueado",
  "filterbar.clear": "Limpar",
  "filterbar.searchOptions": "Buscar…",
  "filterbar.noOptions": "Sem opções.",
  "filterbar.nSelected": "{n} selecionados",
  "filterbar.relDays": "Últimos {length} dias",
  "filterbar.relWeeks": "Últimas {length} semanas",
  "filterbar.relMonths": "Últimos {length} meses",
  "filterbar.relYears": "Últimos {length} anos",
  "filterbar.gte": "≥ {v}",
  "filterbar.lte": "≤ {v}",
  "filters.title": "Filtros",
  "filters.removeChip": "Remover {label}",
  "filters.resetAll": "Limpar tudo",
  "reportGroup.column": "Grupo",
  "reportGroup.backToProject": "Voltar ao projeto",
  "reportGroup.subtitle": "Os relatórios deste grupo são as abas de uma página e compartilham um único conjunto de filtros.",
  "reportGroup.loadError": "Não foi possível carregar o grupo de relatórios",
  "reportGroup.save": "Salvar",
  "reportGroup.saving": "Salvando…",
  "reportGroup.saved": "Salvo. Os relatórios publicados do grupo o recebem em menos de um minuto.",
  "reportGroup.publish": "Publicar grupo",
  "reportGroup.publishing": "Publicando…",
  "reportGroup.published": "Todos os relatórios do grupo foram publicados.",
  "reportGroup.publishPending": "Publicar grupo · {count} pendente(s)",
  "reportGroup.pendingHint": "Cada filtro precisa de uma decisão em cada relatório: usa ou não se aplica.",
  "reportGroup.reports": "Relatórios",
  "reportGroup.reportsHint": "A ordem deles é a ordem das abas.",
  "reportGroup.openReport": "Abrir {key} no editor",
  "reportGroup.moveUp": "Subir",
  "reportGroup.moveDown": "Descer",
  "reportGroup.filters": "Filtros do grupo · {count}",
  "reportGroup.filtersHint": "Na ordem da cascata. Cada relatório usa um filtro em uma de suas colunas, ou ele não se aplica.",
  "reportGroup.filter": "Filtro",
  "reportGroup.uses": "Usa a coluna",
  "reportGroup.notApplicable": "Não se aplica",
  "reportGroup.missing": "Falta",
  "reportGroup.cellAria": "Decisão de {report} para o filtro {filter}",
  "reportGroup.columnAria": "Coluna de {report} para o filtro {filter}",
  "reportGroup.reasonAria": "Por que {filter} não se aplica a {report}",
  "reportGroup.reasonPlaceholder": "Motivo (opcional)",
  "reportGroup.legendUses": "o relatório filtra por essa coluna",
  "reportGroup.legendNotApplicable": "não se aplica: decisão explícita, o valor é mantido para as outras abas",
  "reportGroup.legendMissing": "bloqueia a publicação",
  "reportGroup.memberError": "Este relatório é uma aba de um grupo de relatórios e seus filtros estão incompletos: {error}",
  "reportGroup.membersHint": "Todos os relatórios do projeto são abas; um relatório novo entra no grupo. Para tirar relatórios, mostre o projeto como lista:",
  "reportGroup.membersHintLink": "Configurações do projeto",
  "projectMode.title": "Como o projeto mostra seus relatórios",
  "projectMode.description": "Abas ou lista na barra lateral, nunca as duas. Uma mudança confirmada chega ao portal em menos de um minuto.",
  "projectMode.tabs": "Abas",
  "projectMode.tabsHint": "Uma página com todos os relatórios como abas e um único conjunto de filtros para todos.",
  "projectMode.list": "Lista na barra lateral",
  "projectMode.listHint": "Cada relatório é uma linha da barra lateral do portal, com seus próprios filtros.",
  "projectMode.current": "Atual",
  "projectMode.openGroup": "Abrir o grupo",
  "projectMode.review": "Revisar a mudança",
  "projectMode.reviewing": "Revisando…",
  "projectMode.reviewTitleTabs": "Ao passar para abas:",
  "projectMode.reviewTitleList": "Ao passar para lista:",
  "projectMode.r.tabsReports": "os {count} relatórios passam a ser as abas do grupo {group}, na ordem da barra lateral",
  "projectMode.r.tabsFilters": "seus filtros passam para o grupo: {count} ({filters})",
  "projectMode.r.notApplicable": "{report}: «não se aplica» em {filters} (não os tinha)",
  "projectMode.r.savedViewsUp": "{count} visualização(ões) salva(s) passam para o grupo",
  "projectMode.r.listReports": "cada um dos {count} relatórios recupera como seus os filtros que usa",
  "projectMode.r.removedAction": "um botão que abria outro relatório é removido: {action}",
  "projectMode.r.savedViewsDown": "{count} visualização(ões) salva(s) voltam ao seu relatório",
  "projectMode.r.trimmed": "são removidos valores de filtros que o relatório já não tem: {item}",
  "projectMode.r.lostAliases": "os links antigos com ?tab= ({tabs}) abrirão o primeiro relatório",
  "projectMode.reviewBlocked": "A mudança não pode ser feita:",
  "projectMode.confirm": "Confirmar a mudança",
  "projectMode.applying": "Aplicando…",
  "projectMode.appliedTabs": "O projeto agora mostra seus relatórios como abas.",
  "projectMode.appliedList": "O projeto agora mostra seus relatórios como lista na barra lateral.",
  "projectMode.loadError": "Não foi possível ler o modo do projeto",
  "projectMode.mixedTitle": "Este projeto mistura abas e lista",
  "projectMode.mixedBody": "Tem um grupo de relatórios junto a relatórios fora dele, de antes da regra. Mova relatórios para outro projeto até que cada projeto seja abas ou lista; então seu modo pode ser escolhido.",
  "projectMode.mixedGroups": "Grupos",
  "projectMode.mixedLoose": "Relatórios fora de grupo",
  "filters.notApplicableIn": "não se aplica em {report}",
  "filters.pinnedNotApplicable": "Não se aplica em {report}: {filters}",
  "filters.phoneShow": "Ver controles",
  "filters.phoneHide": "Ocultar controles",
  "filters.phoneChanged": "Filtros alterados: {count}",
  "filters.notApplicableLine": "Não se aplicam em {report}:",
  "filters.notApplicableKept": "Seus valores são mantidos para as outras abas.",
  "dashboard.group.orphanKeys": "Estes filtros não existem mais e não foram aplicados: {keys}",
  "filterbar.noMatches": "Sem resultados.",
  "filterbar.searchPlaceholder": "Digite para buscar…",
  "filterbar.narrowSearch": "Exibindo 200 de {count}: refine sua busca.",
  "filterbar.typeToSearch": "Digite {min}+ letras para buscar",
  "filterbar.dayPlaceholder": "aaaa-mm-dd",
  "filterbar.required": "Obrigatório",
  "filterbar.requiredHint": "Escolha um valor para o filtro destacado para carregar o dashboard.",
  "daterange.preset.hp_all": "Todos",
  "daterange.preset.hp_q_actual": "Q atual",
  "daterange.preset.hp_last_q": "Último Q",
  "daterange.preset.hp_last_4_q": "Últimos 4 Q",
  "daterange.preset.hp_last_8_q": "Últimos 8 Q",
  "inspector.dashboard.filtersLayout": "Cabeçalho de filtros",
  "inspector.dashboard.filtersLayoutBar": "Banner",
  "inspector.dashboard.filtersLayoutCajon": "Cajón",
  "inspector.dashboard.filtersLayoutBarHint": "Filtros embutidos no banner do cabeçalho (o layout clássico).",
  "inspector.dashboard.filtersLayoutCajonHint": "Linha de chips no cabeçalho que se expande no próprio lugar para editar os filtros.",
  "inspector.dashboard.advanced": "Avançado",
  "inspector.dashboard.runtimeViewSql": "SQL da view de runtime",
  "inspector.dashboard.runtimeViewSqlPlaceholder": "WITH _runtime_view AS (SELECT … FROM gating_fact_seller_weekly {where} …) SELECT * FROM _runtime_view",
  "inspector.dashboard.runtimeViewSqlHint": "SQL materializado como TEMP VIEW _runtime_view antes da execução dos KPIs/gráficos. Use {where} como placeholder do filtro do dashboard. Valide com o skill report-builder antes de publicar.",
  "daterange.placeholder": "Escolha um intervalo de datas",
  "daterange.today": "Hoje",
  "daterange.yesterday": "Ontem",
  "daterange.last_7_days": "7 dias anteriores",
  "daterange.last_30_days": "30 dias anteriores",
  "daterange.last_week": "Semana anterior",
  "daterange.last_month": "Mês anterior",
  "daterange.last_3_months": "3 meses anteriores",
  "daterange.last_12_months": "12 meses anteriores",
  "daterange.fixed": "Intervalo de datas fixo…",
  "daterange.relative": "Intervalo de datas relativo…",
  "daterange.none": "(nenhum)",
  "daterange.startDate": "Data de início",
  "daterange.endDate": "Data de término",
  "daterange.apply": "Aplicar",
  "daterange.cancel": "Cancelar",
  "daterange.back": "Voltar",
  "daterange.lastN": "Últimos",
  "daterange.units.days": "dias",
  "daterange.units.weeks": "semanas",
  "daterange.units.months": "meses",
  "daterange.rangeSeparator": "→",
  "daterange.invalid": "Intervalo inválido",
  "daterange.start": "Início",
  "daterange.end": "Fim",
  "daterange.pending": "pendente",
  "daterange.clear": "Limpar",
  "daterange.hintPickStart": "Clique em um dia para escolher a data de início",
  "daterange.hintPickEnd": "Clique em um dia para escolher a data de fim",
  "daterange.goToStartMonth": "Ir para o mês da data de início",
  "daterange.goToEndMonth": "Ir para o mês da data de fim",
  "daterange.startPending": "Data de início pendente",
  "daterange.endPending": "Data de fim pendente",
  "dateslider.noData": "Sem dados de datas",
  "dateslider.from": "De",
  "dateslider.to": "Até",
  "numrange.min": "Mín.",
  "numrange.max": "Máx.",
  "numrange.noData": "Sem valores para definir um intervalo",
  "numrange.logScale": "escala log",
  "numrange.logUnusable": "A escala log precisa de valores maiores que 0",
  "numrange.histogramError": "Não foi possível carregar a distribuição",
  "numrange.remaining": "Restam {n} de {total}",
  "numrange.clear": "Remover limite",
  "filter.country": "País",
  "filter.marketplace": "Marketplace",
  "filter.seller": "Vendedor",
  "filter.account": "Conta",
  "filter.category": "Categoria",
  "filter.seller_status": "Status do vendedor",
  "filter.in_listing": "Na listagem",
  "filter.brand": "Marca",
  "filter.region": "Região",
  "preview.defaultTableTitle": "Dados",
  "kpi.total_annual_rev": "Receita anual total",
  "kpi.total_skus": "SKUs totais",
  "kpi.seller_status": "Status do vendedor",
  "kpi.avg_buy_box_rate": "Buy Box médio",
  "kpi.listed": "Listados %",
  "kpi.revenue_3m": "Receita 3M",
  "kpi.1p_revenue_3m": "Receita 1P 3M",
  "kpi.3p_revenue_3m": "Receita 3P 3M",
  "kpi.week_start": "Início da semana",
  "kpi.week_end": "Fim da semana",
  "chart.top_10_asins_by_annual_rev": "Top 10 ASINs por receita anual",
  "chart.revenue_1p_vs_3p": "Receita 1P vs 3P",
  "chart.woh_vs_annual_rev_by_asin": "WOH vs receita anual por ASIN",
  "chart.avg_woh_by_category": "WOH médio por categoria",
  "chart.buy_box_rate_vs_1p_rev_by_asin": "Buy Box vs % de receita 1P por ASIN",
  "chart.risk_score_by_asin": "Pontuação de risco por ASIN",
  "column.sku": "SKU",
  "column.category": "Categoria",
  "column.listing_title": "Título do listing",
  "column.annual_rev": "Receita anual",
  "column.rev_3m": "Receita 3M",
  "column.1p_rev_3m": "Receita 1P 3M",
  "column.1p_rev": "1P %",
  "column.3p_rev_3m": "Receita 3P 3M",
  "column.3p_rev": "3P %",
  "column.woh": "WOH",
  "column.1p": "1P",
  "column.mpa": "# MPA",
  "column.non_mpa": "# Não MPA",
  "column.buy_box_rate": "Buy Box",
  "column.asin": "ASIN",
  "column.risk_score": "Pontuação de risco",
  "column.buy_box": "Buy Box %",
  "section.kpis_principales": "KPIs principais",
  "section.dashboard_explorer": "Dashboard Explorer",
  "section.diagnosticos_del_mercado": "Diagnósticos do mercado",
  "sectionSubtitle.analisis_visual_de_cobertura_mix_1p_3p_y_riesgo_por_asin": "Análise visual de cobertura, mix 1P/3P e risco por ASIN",
  "preview.title": "Pré-visualização · dados ao vivo",
  "preview.close": "Fechar",
  "preview.filtersError": "Não foi possível carregar as opções de filtro: {err}",
  "preview.loadingCanvas": "Carregando pré-visualização…",
  "preview.empty": "Adicione seções no editor para vê-las aqui.",
  "preview.charts.title": "Diagnósticos",
  "preview.charts.subtitle": "Análise visual com os dados mais recentes.",
  "preview.tableSubtitle": "%{count} linhas",
  "editor.inspector.reportIdentity": "Identidade do relatório",
  "editor.inspector.displayNameLabel": "Nome de exibição",
  "editor.inspector.displayNamePlaceholder": "Meu relatório",
  "editor.inspector.duckdbTableLabel": "Tabela DuckDB",
  "editor.inspector.duckdbTableHint": "Tabela de origem. Define as colunas disponíveis nos editores.",
  "editor.inspector.duckdbTablePlaceholder": "my_table",
  "editor.inspector.descriptionLabel": "Descrição (opcional)",
  "editor.inspector.descriptionPlaceholder": "O que este relatório cobre.",
  "editor.filters.globalTitle": "Filtros globais",
  "editor.filters.globalDesc": "Aplicados a todas as seções, a menos que sejam substituídos localmente.",
  "editor.filters.sectionTitle": "Filtros da seção",
  "editor.filters.sectionDesc": "Aplicam-se apenas aos itens desta seção. Combinados com os filtros globais em tempo de execução.",
  "editor.filters.addBtn": "Adicionar filtro",
  "editor.filters.emptyMsg": "Ainda não há filtros.",
  "editor.filters.duplicateKeys": "Chaves de filtro duplicadas: {keys}. O motor descartará todas, exceto a primeira.",
  "editor.filter.unnamed": "(sem nome)",
  "editor.filter.duplicateBtn": "Duplicar filtro",
  "editor.filter.removeBtn": "Remover filtro",
  "editor.filter.keyLabel": "Chave",
  "editor.filter.keyPlaceholder": "country",
  "editor.filter.keyValidation": "apenas letras minúsculas, dígitos e sublinhados",
  "inspector.filter.selectionMode": "Seleção",
  "inspector.filter.required": "Seleção obrigatória",
  "inspector.filter.extraOptions": "Opções adicionais (separadas por vírgula)",
  "inspector.filter.extraOptionsHint": "Mantém valores compatíveis selecionáveis mesmo sem dados. Isso adiciona opções, nunca registros nem métricas.",
  "inspector.filter.dependencies": "Depende de",
  "inspector.filter.legacyCascade": "Todos os outros filtros (legado)",
  "inspector.filter.rootCascade": "Nenhum, primeira seleção",
  "inspector.filter.dependenciesHint": "Somente estes filtros restringem as opções. Alterar um filtro anterior limpa os dependentes.",
  "inspector.filter.tabs": "Visível nas abas",
  "inspector.filter.tabsHint": "Desmarque uma aba para ocultar este controle nela. O filtro continua valendo para os dados; só precisam mostrá-lo as abas cujos elementos o leem.",
  "inspector.sql.edit": "Editar SQL",
  "inspector.sql.apply": "Aplicar à pré-visualização",
  "inspector.sql.editHint": "Revise a pré-visualização antes de salvar. Salvar um relatório publicado altera o relatório ao vivo.",
  "inspector.filter.checkboxDropdown": "Lista suspensa com caixas de seleção (múltipla)",
  "inspector.filter.multipleDefault": "O valor padrão contém vários valores. Mantenha a seleção múltipla ou edite o padrão primeiro.",
  "inspector.filter.fixedOptions": "{count} opções fixas; a lista não acompanha os outros filtros.",
  "inspector.filter.useLiveOptions": "Usar valores dos dados e em cascata com outros filtros",
  "inspector.filter.liveOptions": "As opções vêm dos dados e acompanham os outros filtros.",
  "inspector.dashboard.snapshot": "Ver snapshot salvo do relatório",
  "inspector.dashboard.downloadSnapshot": "Baixar snapshot (JSON)",
  "editor.filter.typeLabel": "Tipo",
  "editor.filter.typeSelect": "Seleção",
  "editor.filter.typeAutocomplete": "Preenchimento automático",
  "editor.filter.typeMultiSelect": "Seleção múltipla",
  "editor.filter.typeChip": "Chips (múltiplos)",
  "editor.filter.typeRange": "Controle deslizante de intervalo",
  "editor.filter.typeSearch": "Busca (texto contém)",
  "editor.filter.typeDateRange": "Intervalo de datas",
  "editor.filter.typeDateCalendar": "Data única",
  "editor.filter.typeDateRelative": "Período relativo",
  "editor.filter.defaultDateHint": "Aplicado no primeiro carregamento (data ISO).",
  "editor.filter.jsonNoDefaultHint": "Filtro em formato JSON. Deixe os padrões em branco; o widget em execução controla a entrada.",
  "editor.filter.columnLabel": "Coluna",
  "editor.filter.columnHint": "Escolha entre as colunas da tabela do relatório.",
  "editor.filter.columnHintTemporal": "Somente colunas DATE / TIMESTAMP são exibidas.",
  "editor.filter.defaultLabel": "Valor padrão",
  "editor.filter.defaultNone": "(nenhum)",
  "editor.filter.defaultPresetHint": "Aplicado no primeiro carregamento; o usuário pode alterá-lo na barra de filtros.",
  "editor.filter.lockedLabel": "Valor bloqueado",
  "editor.filter.lockedHint": "Fixo; o usuário não pode alterá-lo.",
  "editor.filter.lockedNone": "(desbloqueado)",
  "editor.filter.requiredLabel": "Obrigatório (escolhe um valor automaticamente ao carregar)",
  "editor.diagram.addSection": "Adicionar seção",
  "editor.diagram.emptyTitle": "Dashboard vazio",
  "editor.diagram.emptyHint": "Adicione a primeira seção para começar a compor o relatório.",
  "editor.diagram.emptyHintReadOnly": "As seções e os itens são gerenciados pelo Claude com a skill report-builder.",
  "editor.diagram.sectionFallback": "Seção",
  "editor.diagram.itemsLabel": "itens",
  "editor.diagram.readOnlyTitle": "Somente leitura.",
  "editor.diagram.readOnlyBody": "As alterações estruturais (adicionar, remover e reordenar seções e itens, largura do item) passam pelo Claude com a skill report-builder. Clique em um item para editar o conteúdo no painel lateral.",
  "editor.diagram.readOnlyNote": "O canvas do dashboard é somente leitura; as edições passam pela skill report-builder.",
  "editor.section.dragToReorder": "Arraste para reordenar",
  "editor.section.duplicateBtn": "Duplicar seção",
  "editor.section.deleteBtn": "Excluir seção",
  "editor.section.renameBtn": "Renomear seção",
  "editor.section.addBtn": "Adicionar",
  "editor.section.emptyHint": "Seção vazia. Adicione o primeiro item:",
  "editor.section.emptyHintReadOnly": "Seção vazia. Adicione itens pelo Claude com a skill report-builder.",
  "editor.section.deleteConfirm": "Excluir a seção \"{title}\" e todos os seus itens?",
  "editor.section.itemCountSingular": "item",
  "editor.section.itemCountPlural": "itens",
  "editor.element.dragToReorder": "Arraste para reordenar",
  "editor.element.duplicateBtn": "Duplicar",
  "editor.element.deleteBtn": "Excluir",
  "editor.kpi.untitled": "KPI sem título",
  "editor.chart.untitled": "Gráfico sem título",
  "editor.chart.typeSubtitle": "tipo: {type}",
  "editor.table.label": "Tabela de dados",
  "editor.table.columnSingular": "coluna",
  "editor.table.columnPlural": "colunas",
  "editor.text.label": "Bloco de texto",
  "editor.section.editingTitle": "Editando {element}",
  "editor.section.settingsTitle": "Configurações da seção",
  "editor.section.dashboardSettingsTitle": "Configurações do dashboard",
  "editor.section.itemHint": "Configuração por elemento.",
  "editor.section.sectionHint": "Configurações da seção e filtros locais.",
  "editor.section.dashboardHint": "Escolha uma seção ou item no canvas, ou edite abaixo a configuração geral do dashboard.",
  "editor.section.titleLabel": "Título",
  "editor.section.subtitleLabel": "Subtítulo (opcional)",
  "editor.section.itemsLabel": "Itens desta seção ({count})",
  "editor.section.noItemsHint": "Ainda não há itens. Use o menu \"Adicionar\" no cabeçalho da seção.",
  "editor.item.widthLabel": "Largura (colunas da grade)",
  "editor.item.rawPropsLabel": "Props brutas (JSON)",
  "editor.item.duplicateBtn": "Duplicar",
  "editor.item.addAnotherBtn": "Adicionar outro",
  "editor.item.deleteBtn": "Excluir",
  "editor.kpi.labelLabel": "Rótulo",
  "editor.kpi.labelPlaceholder": "Receita anual total",
  "editor.kpi.sqlLabel": "Expressão SQL",
  "editor.kpi.sqlHint": "Agregação sobre a tabela DuckDB do relatório. Em tempo de execução é envolvida em SELECT … FROM table.",
  "editor.kpi.sqlPlaceholder": "SUM(\"Annual Rev\")",
  "editor.kpi.formatLabel": "Formato",
  "editor.kpi.accentColorLabel": "Cor de destaque",
  "editor.kpi.accentColorHint": "Faixa colorida da borda do card de KPI. Automático alterna conforme a posição do item.",
  "editor.kpi.ignoreFiltersLabel": "Ignorar filtros (opcional)",
  "editor.kpi.ignoreFiltersHint": "Chaves de filtro que este KPI NÃO deve respeitar, por exemplo \"in_listing\" para que um KPI de cobertura ignore o filtro do usuário.",
  "editor.kpi.ignoreFiltersPlaceholder": "Digite uma chave de filtro…",
  "editor.kpi.ignoreFiltersEmptyPlaceholder": "Adicione filtros primeiro para sugerir chaves aqui…",
  "editor.kpi.variantLabel": "Variante",
  "editor.kpi.variantHint": "Estilo visual deste KPI. As variantes marcadas com SQL exigem uma consulta extra (sparkline / período anterior).",
  "editor.kpi.variantNeedsSqlHint": "Requer SQL extra configurado abaixo",
  "editor.kpi.variantCard": "Card",
  "editor.kpi.variantCardDesc": "Card básico com destaque na borda esquerda (padrão)",
  "editor.kpi.variantSparkline": "Sparkline",
  "editor.kpi.variantSparklineDesc": "Valor + mini linha de tendência + pílula de delta",
  "editor.kpi.variantRing": "Anel",
  "editor.kpi.variantRingDesc": "Valor dentro de um anel de progresso circular",
  "editor.kpi.variantBar": "Barra",
  "editor.kpi.variantBarDesc": "Valor sobre uma barra de progresso horizontal",
  "editor.kpi.variantHero": "Hero",
  "editor.kpi.variantHeroDesc": "Card grande com gradiente da marca + ícone opcional",
  "editor.kpi.variantCompare": "Comparar",
  "editor.kpi.variantCompareDesc": "Atual vs anterior, delta automático",
  "editor.kpi.variantCompact": "Compact",
  "editor.kpi.variantCompactDesc": "Layout de uma linha para listas densas de KPIs",
  "editor.kpi.variantIconStat": "Icon stat",
  "editor.kpi.variantIconStatDesc": "Valor com um ícone em uma caixa colorida",
  "editor.kpi.variantAnomaly": "Anomalia",
  "editor.kpi.variantAnomalyDesc": "Valor com tom de severidade, linha de base esperada + descrição",
  "editor.kpi.variantScore": "Score",
  "editor.kpi.variantScoreDesc": "Anel de score de 0 a máx., com barras de detalhamento opcionais",
  "editor.kpi.variantCore": "Core (faixa DSA)",
  "editor.kpi.variantCoreDesc": "Card na cor da marca: selo CORE, delta em pp contra previous_sql, subtítulo e faixa de ação",
  "editor.kpi.severityLabel": "Severidade",
  "editor.kpi.severityHint": "Define a rampa de cores (vermelho / âmbar / roxo).",
  "editor.kpi.severityCritical": "Crítica (vermelho)",
  "editor.kpi.severityWarning": "Aviso (âmbar)",
  "editor.kpi.severityInfo": "Info (roxo)",
  "editor.kpi.expectedSqlLabel": "SQL esperado",
  "editor.kpi.expectedSqlHint": "Agregação opcional para a linha de base. Mesmo escopo do KPI principal; o % de desvio é calculado automaticamente.",
  "editor.kpi.expectedSqlPlaceholder": "AVG(metric) OVER ()",
  "editor.kpi.descriptionLabel": "Descrição",
  "editor.kpi.descriptionHint": "Texto livre exibido abaixo do valor. Mantenha curto.",
  "editor.kpi.descriptionPlaceholder": "Volume de listings +320% vs média dos últimos 30 dias.",
  "editor.kpi.scoreMaxHint": "Score máximo no anel (padrão: 100).",
  "editor.kpi.breakdownSqlLabel": "SQL de detalhamento",
  "editor.kpi.breakdownSqlHint": "SELECT que retorna linhas no formato (label, value). Cada linha vira uma barra de detalhamento de 0 a 100%.",
  "editor.kpi.breakdownSqlPlaceholder": "SELECT axis AS label, score AS value FROM scores GROUP BY axis",
  "editor.kpi.maxLabel": "Valor máximo",
  "editor.kpi.maxHint": "Usado pelas variantes de anel e barra para dimensionar o progresso.",
  "editor.kpi.gradientLabel": "Gradiente",
  "editor.kpi.gradientHint": "Gradiente de fundo para a variante hero.",
  "editor.kpi.gradientPrimary": "Primary (roxo)",
  "editor.kpi.gradientAccent": "Accent (rosa)",
  "editor.kpi.gradientPrimaryToAccent": "Primary → accent",
  "editor.kpi.gradientSuccess": "Success (verde)",
  "editor.kpi.gradientWarning": "Warning (âmbar)",
  "editor.kpi.iconLabel": "Ícone",
  "editor.kpi.iconHint": "Ícone Lucide exibido ao lado do valor.",
  "editor.kpi.iconNone": "Nenhum",
  "editor.kpi.iconAlert": "Alerta",
  "editor.kpi.iconTrending": "Tendência",
  "editor.kpi.iconDollar": "Dólar",
  "editor.kpi.iconUsers": "Usuários",
  "editor.kpi.iconPackage": "Pacote",
  "editor.kpi.iconCheck": "Check",
  "editor.kpi.iconZap": "Zap",
  "editor.kpi.iconTarget": "Alvo",
  "editor.kpi.iconBgLabel": "Fundo do ícone",
  "editor.kpi.iconBgHint": "Nome de cor do Tailwind, por exemplo primary pinta a caixa do ícone de roxo.",
  "editor.kpi.iconBgPrimary": "Primary",
  "editor.kpi.iconBgAccent": "Accent",
  "editor.kpi.iconBgEmerald": "Emerald",
  "editor.kpi.iconBgAmber": "Amber",
  "editor.kpi.iconBgRose": "Rose",
  "editor.kpi.sparklineSqlLabel": "SQL do sparkline",
  "editor.kpi.sparklineSqlHint": "Retorna uma lista de números (por exemplo, LIST(metric ORDER BY month)). O backend a executa junto com a consulta principal do KPI.",
  "editor.kpi.sparklineSqlPlaceholder": "LIST(metric ORDER BY month)",
  "editor.kpi.previousSqlLabel": "SQL do período anterior",
  "editor.kpi.previousSqlHint": "Agregação da linha de base de comparação (por exemplo, SUM(metric) WHERE date < CURRENT_DATE - INTERVAL '1 month').",
  "editor.kpi.previousSqlPlaceholder": "SUM(metric) WHERE date < CURRENT_DATE - INTERVAL '1 month'",
  "editor.table.defaultSortLabel": "Coluna de ordenação padrão",
  "editor.table.defaultSortHint": "Use aspas quando necessário.",
  "editor.table.directionLabel": "Direção da ordenação",
  "editor.table.descending": "Decrescente",
  "editor.table.ascending": "Crescente",
  "editor.table.pageSizeLabel": "Tamanho da página",
  "editor.table.densityLabel": "Densidade das linhas",
  "editor.table.densityHint": "Controla o espaçamento vertical das linhas da tabela na pré-visualização.",
  "editor.table.densityAriaLabel": "Densidade das linhas",
  "editor.table.densityCompact": "compacta",
  "editor.table.densityNormal": "normal",
  "editor.table.densityComfortable": "confortável",
  "editor.table.columnsLabel": "Colunas ({count})",
  "editor.table.addColumnBtn": "Adicionar coluna",
  "editor.table.noColumnsHint": "Ainda não há colunas. Adicione uma para preencher a tabela.",
  "editor.table.emptyLabel": "(vazio)",
  "editor.table.columnLabel": "Coluna",
  "editor.table.labelLabel": "Rótulo",
  "editor.table.labelPlaceholder": "Nome de exibição",
  "editor.table.formatLabel": "Formato",
  "editor.table.widthLabel": "Largura / truncar (opcional)",
  "inspector.table.maxWidth": "Largura máxima da coluna",
  "inspector.table.autoWidth": "Automática (conteúdo completo)",
  "inspector.table.maxWidthHint": "Textos longos são encurtados visualmente; passe o mouse para ler completo. As exportações mantêm o valor completo.",
  "editor.table.widthPlaceholder": "auto · max-w-[200px] truncate",
  "editor.table.renderLabel": "Renderização da célula (opcional)",
  "editor.table.renderHint": "Como cada célula desta coluna é exibida. O padrão usa o formato acima; as variantes mais ricas substituem o visual da célula.",
  "editor.table.renderDefault": "Padrão (texto / número)",
  "editor.table.renderHeat": "Heat, colorido por mín/máx",
  "editor.table.renderSparkline": "Sparkline, lista de números",
  "editor.table.renderStatus": "Status, selo colorido",
  "editor.table.renderProgress": "Progress, barra de 0 a 100",
  "editor.table.renderCompare": "Compare, seta de delta",
  "editor.chart.titleLabel": "Título",
  "editor.chart.titlePlaceholder": "Top 10 ASINs por receita",
  "editor.chart.typeLabel": "Tipo de gráfico",
  "editor.chart.dimensionLabel": "Dimensão",
  "editor.chart.dimensionHint": "Coluna do GROUP BY.",
  "editor.chart.groupingHint": "Coluna de agrupamento compartilhada por todas as métricas.",
  "editor.chart.metricLabel": "Métrica",
  "editor.chart.metricHint": "Expressão de agregação.",
  "editor.chart.metricPlaceholder": "SUM(\"Annual Rev\")",
  "editor.chart.xAxisLabel": "Eixo X",
  "editor.chart.yAxisLabel": "Eixo Y",
  "editor.chart.bubbleSizeLabel": "Tamanho da bolha",
  "editor.chart.labelColLabel": "Coluna de rótulo (opcional)",
  "editor.chart.labelColHint": "Acompanha x/y para rotular cada ponto ao passar o mouse.",
  "editor.chart.metricsLabel": "Métricas ({count})",
  "editor.chart.addMetricBtn": "Adicionar métrica",
  "editor.chart.groupedBarHint": "Adicione pelo menos duas métricas para um gráfico de barras agrupadas.",
  "editor.chart.seriesLabel": "Série {idx}",
  "editor.chart.seriesLabelPlaceholder": "Rótulo da série",
  "editor.chart.metricsPlaceholder": "SUM(\"Rev 1P\")",
  "editor.chart.removeBtn": "Remover",
  "editor.chart.stackedLabel": "Empilhado",
  "editor.chart.stackedHint": "Empilha as séries em vez de agrupá-las lado a lado",
  "editor.chart.columnsLabel": "Colunas ({count})",
  "editor.chart.addBtn": "Adicionar",
  "editor.chart.noColumnsHint": "Ainda não há colunas. Adicione pelo menos uma.",
  "editor.chart.columnLabel": "Coluna {idx}",
  "editor.chart.keyPlaceholder": "chave (alias)",
  "editor.chart.labelPlaceholder": "Rótulo de exibição",
  "editor.chart.badgePlaceholder": "selo (por exemplo, \"risk_score\")",
  "editor.chart.sortLabel": "Expressão de ordenação",
  "editor.chart.sortHint": "ORDER BY da mini tabela.",
  "editor.chart.sortPlaceholder": "SUM(\"Rev\")",
  "editor.chart.moreOptions": "Mais opções do gráfico",
  "editor.chart.sharedSortLabel": "Ordenação",
  "editor.chart.sortDefault": "Padrão",
  "editor.chart.sortAsc": "Crescente",
  "editor.chart.sortDesc": "Decrescente",
  "editor.chart.limitLabel": "Limite (top N)",
  "editor.chart.limitNone": "(nenhum)",
  "editor.chart.xFormatLabel": "Dica de formato do eixo X",
  "editor.chart.yFormatLabel": "Dica de formato do eixo Y",
  "editor.text.contentLabel": "Conteúdo em Markdown",
  "editor.text.contentHint": "Exibido em linha no dashboard.",
  "editor.text.contentPlaceholder": "## Nota da seção\n\nEscreva seu contexto aqui.",
  "editor.chart.typeBar": "Barra",
  "editor.chart.barDesc": "Uma série, barras verticais",
  "editor.chart.typeBarHorizontal": "Barra (h)",
  "editor.chart.barHDesc": "Barras horizontais",
  "editor.chart.typeLine": "Linha",
  "editor.chart.lineDesc": "Tendência ao longo de uma dimensão",
  "editor.chart.typePie": "Pizza",
  "editor.chart.pieDesc": "Participação em um todo",
  "editor.chart.typeGrouped": "Agrupado",
  "editor.chart.groupedDesc": "Várias métricas lado a lado",
  "editor.chart.typeScatter": "Dispersão",
  "editor.chart.scatterDesc": "Pontos X / Y",
  "editor.chart.typeBubble": "Bolhas",
  "editor.chart.bubbleDesc": "Pontos X / Y / tamanho",
  "editor.chart.typeTable": "Tabela",
  "editor.chart.tableDesc": "Mini tabela compacta",
  "editor.chart.advancedGroup": "Avançado",
  "editor.chart.typeStackedBar": "Barra empilhada",
  "editor.chart.stackedBarDesc": "Várias métricas empilhadas em uma barra",
  "editor.chart.typeStackedArea": "Área empilhada",
  "editor.chart.stackedAreaDesc": "Áreas de série temporal empilhadas ao longo do tempo",
  "editor.chart.typeMultiLine": "Múltiplas linhas",
  "editor.chart.multiLineDesc": "Várias linhas no mesmo eixo",
  "editor.chart.typeCombo": "Combo",
  "editor.chart.comboDesc": "Barra + linha com dois eixos Y",
  "editor.chart.typeRadar": "Radar",
  "editor.chart.radarDesc": "Compara métricas entre eixos categóricos",
  "editor.chart.typeFunnel": "Funil",
  "editor.chart.funnelDesc": "Etapas de um processo de conversão",
  "editor.chart.typeTreemap": "Treemap",
  "editor.chart.treemapDesc": "Participação hierárquica por área",
  "editor.chart.typeWaterfall": "Cascata",
  "editor.chart.waterfallDesc": "Total acumulado com passos positivos e negativos",
  "editor.chart.typeLollipop": "Lollipop",
  "editor.chart.lollipopDesc": "Variante de barra que destaca o ponto do valor",
  "editor.chart.typeBarTrend": "Barra + tendência",
  "editor.chart.barTrendDesc": "Barras com uma linha de regressão ajustada",
  "editor.chart.typeLineTrend": "Linha + projeção",
  "editor.chart.lineTrendDesc": "Linha histórica mais projeção",
  "editor.chart.typeHeatmap": "Heatmap",
  "editor.chart.heatmapDesc": "Grade bidimensional colorida pelo valor agregado",
  "editor.chart.typeBullet": "Bullet",
  "editor.chart.bulletDesc": "Valor por linha vs meta em uma escala máxima",
  "editor.chart.heatmapRowLabel": "Coluna das linhas",
  "editor.chart.heatmapRowHint": "Coluna categórica do eixo Y (linhas da matriz).",
  "editor.chart.heatmapColLabel": "Coluna das colunas",
  "editor.chart.heatmapColHint": "Coluna categórica do eixo X (colunas da matriz).",
  "editor.chart.heatmapValueLabel": "Valor (agregação)",
  "editor.chart.heatmapValueHint": "Expressão de agregação, executada como SUM/AVG/COUNT em cada célula (linha, coluna).",
  "editor.chart.heatmapValuePlaceholder": "AVG(metric)",
  "editor.chart.bulletLabelLabel": "Coluna de rótulo",
  "editor.chart.bulletValueLabel": "Valor (agregação)",
  "editor.chart.bulletValuePlaceholder": "AVG(metric)",
  "editor.chart.bulletTargetLabel": "Meta",
  "editor.chart.bulletTargetHint": "Constante ou expressão, por exemplo 85 ou AVG(target_col).",
  "editor.chart.bulletMaxLabel": "Escala máxima",
  "editor.chart.bulletMaxHint": "Constante ou expressão. Se ficar em branco, o padrão é 100.",
  "editor.chart.typeMap": "Mapa",
  "editor.chart.mapDesc": "Mapa coroplético colorido pela métrica de cada região",
  "editor.chart.typeCalendarHeatmap": "Calendário",
  "editor.chart.calendarHeatmapDesc": "Grade de densidade diária de um ano inteiro",
  "editor.chart.mapVariantLabel": "Região",
  "editor.chart.mapVariantHint": "América do Sul usa códigos de país ISO (CL, AR, BR…). Chile usa códigos de região (RM, V, VIII…).",
  "editor.chart.mapSouthAmerica": "América do Sul",
  "editor.chart.mapChile": "Chile (regiões)",
  "editor.chart.calendarYearLabel": "Ano (opcional)",
  "editor.chart.calendarYearHint": "Deixe em branco para inferir dos dados. Caso contrário, AAAA.",
  "editor.chart.typeTimeline": "Linha do tempo",
  "editor.chart.timelineDesc": "Fases em estilo Gantt com início, fim e progresso opcional",
  "editor.chart.timelineLabelLabel": "Coluna de rótulo",
  "editor.chart.timelineLabelHint": "Coluna com o rótulo da linha (por exemplo, projeto / fase / SKU).",
  "editor.chart.timelineStartLabel": "Início (índice)",
  "editor.chart.timelineStartHint": "Índice numérico na trilha de meses (0 = primeira célula).",
  "editor.chart.timelineEndLabel": "Fim (índice)",
  "editor.chart.timelineEndHint": "Índice numérico de fim, deve ser maior que o início.",
  "editor.chart.timelineProgressLabel": "Progresso (0 a 1, opcional)",
  "editor.chart.timelineProgressHint": "Valor fracionário de 0 a 1 para a sobreposição de progresso. Em branco = sem sobreposição.",
  "editor.chart.timelineMonthsLabel": "Rótulos de meses / fases",
  "editor.chart.timelineMonthsHint": "Rótulos separados por vírgula para a trilha do eixo X. O padrão é Jan…Dez.",
  "editor.color.accentLabel": "Cor de destaque",
  "editor.color.autoTooltip": "Rotação automática por índice do item",
  "editor.color.auto": "Auto",
  "editor.color.red": "Vermelho",
  "editor.color.blue": "Azul",
  "editor.color.emerald": "Esmeralda",
  "editor.color.purple": "Roxo",
  "editor.color.amber": "Âmbar",
  "editor.color.cyan": "Ciano",
  "editor.color.pink": "Rosa",
  "editor.color.indigo": "Índigo",
  "editor.column.placeholder": "Escolha uma coluna…",
  "editor.column.loading": "Carregando colunas…",
  "editor.column.tableNotFound": "Tabela não encontrada no DuckDB",
  "editor.column.noColumns": "Nenhuma coluna disponível. Defina primeiro a tabela DuckDB do relatório.",
  "editor.format.number": "Número",
  "editor.format.numberExample": "1,234",
  "editor.format.currency": "Moeda",
  "editor.format.currencyExample": "$1,234",
  "editor.format.percent": "Percentual",
  "editor.format.percentExample": "12.3%",
  "editor.format.text": "Texto",
  "editor.format.textExample": "como está",
  "editor.format.label": "Formato",
  "editor.sql.unknownColumnSingular": "Coluna desconhecida",
  "editor.sql.unknownColumnPlural": "Colunas desconhecidas",
  "editor.sql.columnNotInTable": "não existe na tabela DuckDB do relatório.",
  "editor.sql.caseMismatch": "difere em maiúsculas e minúsculas de",
  "editor.sql.fixButton": "Corrigir",
  "editor.sql.aggregateLabel": "Agregação",
  "editor.sql.insertColumn": "Inserir coluna",
  "editor.sql.moreColumns": "+{count} mais",
  "editor.sql.noSemicolons": "Ponto e vírgula não é permitido.",
  "editor.sql.forbiddenKeyword": "Palavra-chave proibida: {keyword}",
  "editor.sql.valid": "Parece válido.",
  "editor.ai.tabs.ariaLabel": "Abas de configuração de IA",
  "editor.ai.tabs.general": "IA geral",
  "editor.ai.tabs.chat": "IA de Chat",
  "editor.translatePt.button": "Traduzir para PT",
  "editor.translatePt.busy": "Traduzindo…",
  "editor.translatePt.error": "Não foi possível traduzir: {message}",
  "editor.ai.tabs.insights": "IA de Insights",
  "editor.ai.executions.title": "Execuções",
  "editor.ai.executions.description": "Gerações anteriores de insights deste relatório (os snapshots semanais que o portal persiste). Somente leitura.",
  "editor.ai.executions.loading": "Carregando execuções…",
  "editor.ai.executions.error": "Não foi possível carregar as execuções",
  "editor.ai.executions.empty": "Ainda não há execuções de insights para este relatório.",
  "editor.ai.executions.col.period": "Período",
  "editor.ai.executions.col.model": "Modelo",
  "editor.ai.executions.col.duration": "Duração",
  "editor.ai.executions.col.insights": "Insights",
  "editor.ai.executions.col.regenerated": "Regenerado",
  "editor.ai.executions.col.created": "Criado",
  "editor.ai.insights.modelTitle": "Modelo da narrativa",
  "editor.ai.insights.modelDescription": "Modelo da OpenAI usado para gerar a narrativa da Análise de IA (painel de Insights). Escolha uma substituição por relatório quando este relatório precisar de um modelo diferente do padrão do portal.",
  "editor.ai.insights.specsTitle": "Insights configurados",
  "editor.ai.insights.specsDescription": "Defina O QUE cada insight deve responder. Cada especificação gera uma entrada no snapshot. Deixe vazio para que o LLM escreva 3 insights livremente (comportamento legado).",
  "editor.ai.insights.specsEmpty": "Nenhum insight configurado. Clique em Adicionar para definir um; o LLM ainda escreverá 3 insights livremente como alternativa.",
  "editor.ai.insights.addSpec": "Adicionar insight",
  "editor.ai.insights.removeSpec": "Remover",
  "editor.ai.insights.spec.idLabel": "ID da especificação",
  "editor.ai.insights.spec.idHint": "Identificador estável usado para associar insights entre execuções. Minúsculas e sublinhados. Sugerido automaticamente a partir do título.",
  "editor.ai.insights.spec.idPlaceholder": "yoy_revenue",
  "editor.ai.insights.spec.titleLabel": "Título do insight (bilíngue)",
  "editor.ai.insights.spec.titleHint": "Exibido literalmente como cabeçalho do card do insight no portal. O LLM NÃO o inventa: a especificação prevalece.",
  "editor.ai.insights.spec.questionLabel": "O que o LLM deve procurar (bilíngue)",
  "editor.ai.insights.spec.questionHint": "Instrução em linguagem simples. Ex.: \"Como mudou o número de vendedores NO em relação a 52 semanas atrás?\" O LLM responde usando o contexto dos dados.",
  "editor.ai.insights.spec.dataFocusLabel": "Foco nos dados (opcional)",
  "editor.ai.insights.spec.dataFocusHint": "Chaves de KPI ou títulos de gráficos que o LLM deve considerar neste insight. Vazio = o LLM usa todos os dados disponíveis.",
  "editor.ai.insights.spec.dataFocusPlaceholder": "Digite uma chave de KPI ou título de gráfico e pressione Enter…",
  "editor.ai.insights.spec.priorityLabel": "Prioridade",
  "editor.ai.insights.spec.priorityHint": "O menor é executado primeiro. Deixe em branco para usar a ordem de inserção.",
  "editor.ai.insights.spec.enabledLabel": "Ativo",
  "editor.ai.titleLabel": "Configuração de IA",
  "editor.ai.identityDescription": "Configurações globais da IA deste relatório. Alterne ``Enabled`` para controlar se o botão ``+ Show AI Analysis`` e a barra lateral ``Chat AI`` aparecem no portal. As ``Focus areas`` são temas que o LLM enfatiza em todas as respostas sobre este relatório.",
  "editor.ai.enabledLabel": "Ativar ferramentas de chat e Análise de IA para este relatório",
  "editor.ai.modelLabel": "Modelo",
  "editor.ai.modelCatalogError": "Não foi possível carregar a lista de modelos: {err}",
  "editor.ai.focusAreasLabel": "Áreas de foco",
  "editor.ai.focusAreasHint": "Indique os temas que a IA deve priorizar ao resumir este relatório.",
  "editor.ai.focusAreasPlaceholder": "Digite uma área de foco e pressione Enter…",
  "editor.ai.chatModel.title": "Modelo do chat",
  "editor.ai.chatModel.description": "Modelo da OpenAI usado pela barra lateral do chat (ciclo de ferramentas do InsightAgent). Escolha um modelo por relatório somente quando o relatório precisar de um diferente do modelo do cliente.",
  "editor.ai.chatModel.label": "Modelo",
  "editor.ai.chatModel.hint": "Padrão = o modelo de chat do cliente, definido no console da plataforma (modelos de IA).",
  "editor.ai.model.useDefault": "Padrão",
  "editor.ai.model.useDefaultNamed": "Padrão ({model})",
  "editor.ai.model.outsideCatalog": "{model} (fora do catálogo deste cliente)",
  "editor.ai.starterQuestions.title": "Perguntas iniciais",
  "editor.ai.starterQuestions.description": "Perguntas selecionadas exibidas no estado vazio da barra lateral do chat. Busque entre 3 e 5 que mostrem os ângulos mais úteis do relatório; misture consultas de dados com uma sugestão acionável, se fizer sentido. Deixe vazio para usar os padrões genéricos.",
  "editor.ai.starterQuestions.empty": "Sem perguntas iniciais. Usando os padrões genéricos do frontend.",
  "editor.ai.starterQuestions.placeholder": "Quantos vendedores NO temos esta semana?",
  "editor.ai.starterQuestions.add": "Adicionar pergunta inicial",
  "editor.ai.starterQuestions.remove": "Remover",
  "editor.ai.ctaCatalog.title": "CTAs acionáveis",
  "editor.ai.ctaCatalog.description": "Modelos exibidos como CTAs de continuação na barra lateral do chat. Use placeholders como {seller_name}, {asin}, {sku}, {client}; o portal os preenche com os dados do último turno.",
  "editor.ai.ctaCatalog.empty": "Nenhum CTA configurado. Adicione um para começar a exibir sugestões acionáveis.",
  "editor.ai.ctaCatalog.labelTemplate": "Rótulo do CTA (modelo)",
  "editor.ai.ctaCatalog.labelTemplatePlaceholder": "Redigir e-mail para {seller_name} com recomendações",
  "editor.ai.ctaCatalog.descriptionLabel": "Nota interna (opcional)",
  "editor.ai.ctaCatalog.descriptionPlaceholder": "Exibida apenas na UI do builder, não para os usuários finais.",
  "editor.ai.ctaCatalog.add": "Adicionar CTA",
  "editor.ai.ctaCatalog.remove": "Remover",
  "editor.ai.snapshots.title": "Cadência dos Insights",
  "editor.ai.snapshots.description": "Configure como o portal gera os snapshots persistidos da Análise de IA. Os relatórios legados rodam semanalmente; mude para o modelo temporal por relatório para ancorar em outra granularidade.",
  "editor.ai.snapshots.weekColumnLabel": "Coluna de semana ISO",
  "editor.ai.snapshots.weekColumnHint": "Coluna do DuckDB que o watcher usa para detectar novas semanas de dados. O padrão é \"week_iso\".",
  "editor.ai.snapshots.maxInsightsLabel": "Máximo de insights por snapshot",
  "editor.ai.snapshots.maxInsightsHint": "O servidor limita entre 1 e 6. O padrão é 3.",
  "editor.ai.snapshots.priorOffsetsLabel": "Deslocamentos anteriores (em semanas)",
  "editor.ai.snapshots.priorOffsetsHint": "Deslocamentos históricos de âncora usados para dar ao LLM o contexto de tendência. O padrão é [1, 2, 4, 8, 13, 26, 52]. Digite números inteiros e pressione Enter.",
  "editor.ai.snapshots.temporalCtaDescription": "Por padrão, este relatório ancora os insights em semanas ISO. Mude para o modelo temporal por relatório para escolher a coluna de data, a granularidade (dia / semana / mês / trimestre / trimestre fiscal) e quantos períodos de dados e de análises anteriores alimentam cada insight.",
  "editor.ai.snapshots.switchToTemporal": "Mudar para configuração temporal por relatório",
  "editor.ai.snapshots.temporalActiveBadge": "Modelo temporal por relatório ativo",
  "editor.ai.snapshots.revertToWeekly": "Voltar ao semanal legado",
  "editor.ai.snapshots.dateColumnLabel": "Coluna de data",
  "editor.ai.snapshots.dateColumnHint": "Coluna do DuckDB que define a cadência dos períodos. As colunas temporais aparecem primeiro.",
  "editor.ai.snapshots.granularityLabel": "Granularidade (atomicidade)",
  "editor.ai.snapshots.granularityHint": "Como os insights são agrupados e ancorados. \"Trimestre\" é o calendário; \"Trimestre fiscal\" é o ano fiscal da HP (nov a out).",
  "editor.ai.snapshots.dataLookbackLabel": "Janela de dados (períodos)",
  "editor.ai.snapshots.dataLookbackHint": "Quantos períodos de dados alimentam o diagnóstico de completude. Mínimo 1.",
  "editor.ai.snapshots.analysisLookbackLabel": "Janela de análises (períodos)",
  "editor.ai.snapshots.analysisLookbackHint": "Quantas análises anteriores são injetadas como contexto histórico. 0 = nenhuma.",
  "editor.ai.snapshots.columnsLoading": "Carregando colunas…",
  "editor.ai.snapshots.columnsError": "Não foi possível carregar as colunas do DuckDB; você ainda pode digitar um valor abaixo.",
  "editor.ai.snapshots.nonTemporalTag": "não temporal",
  "editor.ai.snapshots.grain.day": "Dia",
  "editor.ai.snapshots.grain.week": "Semana",
  "editor.ai.snapshots.grain.month": "Mês",
  "editor.ai.snapshots.grain.quarter": "Trimestre (calendário)",
  "editor.ai.snapshots.grain.fiscalQuarter": "Trimestre fiscal (HP)",
  "editor.ai.promptLabel": "Substituição do prompt de Análise de IA",
  "editor.ai.promptHint": "Deixe vazio para usar o prompt por relatório padrão em configs/domains/_global/ai_analysis.j2.",
  "editor.ai.promptPlaceholder": "{{ report_display_name }}\nAnalise os dados a seguir…",
  "editor.ai.promptTemplateLabel": "Template (Jinja2)",
  "editor.ai.promptOverrideInfo": "Por padrão, o botão ``+ Show AI Analysis`` do portal usa o prompt global ``ai_analysis`` (configurável em /admin/prompts). Esta substituição SUBSTITUI esse prompt somente para ESTE relatório. Deixe vazio para voltar ao global.",
  "editor.ai.promptClearOverride": "Limpar substituição (usar global)",
  "editor.ai.promptNoOverride": "Sem substituição: usando o prompt global ai_analysis.",
  "editor.ai.promptVarsLabel": "Variáveis Jinja2 disponíveis",
  "editor.ai.promptVarsHint": "O portal renderiza o template com estas variáveis de contexto. Referencie-as com a sintaxe ``{{ name }}``.",
  "editor.ai.docsLabel": "Documentos de treinamento ({count})",
  "editor.ai.addDocBtn": "Adicionar documento",
  "editor.ai.noDocsHint": "Ainda não há documentos. Adicione contexto em Markdown que fundamente as respostas da IA (glossário de KPIs, regras de negócio etc.).",
  "editor.ai.docNamePlaceholder": "document-name.md",
  "editor.ai.docContentPlaceholder": "Conteúdo em Markdown…",
  "editor.ai.examplesLabel": "Exemplos de perguntas e respostas ({count})",
  "editor.ai.addExampleBtn": "Adicionar exemplo",
  "editor.ai.noExamplesHint": "Exemplos few-shot que mostram ao modelo o padrão esperado de pergunta, ferramenta e resposta.",
  "editor.ai.exampleLabel": "Exemplo {idx}",
  "editor.ai.questionLabel": "Pergunta",
  "editor.ai.questionPlaceholder": "Qual é a receita total dos EUA?",
  "editor.ai.toolLabel": "Ferramenta (opcional)",
  "editor.ai.toolPlaceholder": "dashboard_explorer_kpis",
  "editor.ai.answerLabel": "Resposta esperada",
  "editor.ai.answerPlaceholder": "A receita total dos EUA é…",
  "editor.files.titleLabel": "Upload de arquivos",
  "editor.files.s3PathLabel": "Caminho raiz do S3",
  "editor.files.s3PathHint": "Onde os uploads são gravados, normalmente 'hp/{report_key}/files'.",
  "editor.files.s3PathPlaceholder": "hp/dashboard_explorer/files",
  "editor.files.typesLabel": "Tipos de arquivo permitidos",
  "editor.files.typesCountSingular": "tipo",
  "editor.files.typesCountPlural": "tipos",
  "editor.files.maxSizeLabel": "Tamanho máximo do arquivo (MB)",
  "editor.files.pageSectionLabel": "Aparência da página",
  "editor.files.pageTitleLabel": "Título da página",
  "editor.files.pageTitleHint": "Exibido no topo da página de Arquivos. Deixe em branco para usar o padrão genérico.",
  "editor.files.pageTitlePlaceholder": "ex.: Downloads regionais",
  "editor.files.pageSubtitleLabel": "Subtítulo da página",
  "editor.files.pageSubtitlePlaceholder": "ex.: Relatórios trimestrais e exportações",
  "editor.files.emptyMessageLabel": "Mensagem de vazio",
  "editor.files.emptyMessageHint": "Exibida quando a raiz do S3 não tem arquivos.",
  "editor.files.allowUploadLabel": "Permitir upload",
  "editor.files.allowUploadHint": "Exibe um botão de Upload para que os usuários adicionem arquivos ao caminho raiz.",
  "editor.master.titleLabel": "Arquivos mestre ({count})",
  "editor.master.addPrefixBtn": "Adicionar prefixo",
  "editor.master.noPrefixesHint": "Nenhum prefixo de arquivos mestre configurado. Adicione um para mapear um caminho do S3 que o loader deve carregar para este relatório.",
  "editor.master.prefixIndexLabel": "Prefixo {idx}",
  "editor.master.removeBtn": "Remover",
  "editor.master.nameLabel": "Nome",
  "editor.master.namePlaceholder": "US Catalogue",
  "editor.master.fileTypeLabel": "Tipo de arquivo",
  "editor.master.prefixLabel": "Prefixo do S3",
  "editor.master.prefixHint": "Relativo à raiz do bucket S3 do relatório.",
  "editor.master.prefixPlaceholder": "US/CATALOGUE",
  "editor.master.pageSectionLabel": "Aparência da página",
  "editor.master.pageTitleLabel": "Título da página",
  "editor.master.pageTitleHint": "Exibido no topo de Arquivos mestre. Deixe em branco para usar o padrão genérico.",
  "editor.master.pageTitlePlaceholder": "ex.: Catálogos HP",
  "editor.master.pageSubtitleLabel": "Subtítulo da página",
  "editor.master.pageSubtitlePlaceholder": "ex.: Dados de referência deste relatório",
  "editor.master.pageEmptyLabel": "Mensagem sem prefixos",
  "editor.master.pageEmptyHint": "Exibida na página de Arquivos mestre quando não há prefixos configurados.",
  "editor.master.prefixTitleLabel": "Título do card",
  "editor.master.prefixTitleHint": "Substitui o cabeçalho do card. Deixe em branco para usar o nome do prefixo.",
  "editor.master.prefixDescriptionLabel": "Descrição",
  "editor.master.prefixDescriptionHint": "Exibida abaixo do título do card.",
  "editor.master.prefixEmptyMessageLabel": "Mensagem de vazio",
  "editor.master.prefixEmptyMessageHint": "Exibida quando a listagem do S3 está vazia.",
  "editor.master.actionsLabel": "Ações permitidas",
  "editor.master.actionsHint": "Ativa ou desativa os botões por arquivo no hp-portal.",
  "editor.master.actionPreview": "Pré-visualizar",
  "editor.master.actionDownload": "Baixar",
  "editor.master.actionReplace": "Substituir",
  "editor.master.actionUpload": "Carregar",
  "editor.dialog.deleteSection": "Excluir a seção selecionada?",
  "editor.error.loadDraft": "Falha ao carregar o rascunho \"{key}\".",
  "publish.warnings": "Avisos:",
  "auth.logoutConfirm": "Sair do builder?",
  "auth.sessionCheckFailed": "Não foi possível verificar sua sessão. Você continua conectado; tente novamente em instantes.",
  "history.title": "Histórico",
  "history.empty": "Ainda não há edições. O primeiro snapshot será capturado quando você salvar.",
  "history.revert": "Reverter",
  "history.revertConfirm": "Reverter o rascunho para este snapshot? Uma nova linha de histórico registrará antes o estado atual.",
  "history.stat.sections": "Seç",
  "history.stat.kpis": "KPI",
  "history.stat.charts": "Gráf",
  "history.stat.filters": "Filt",
  "kpiCard.openAnalysis": "Abrir análise",
  "kpiCard.closeAnalysis": "Fechar análise",
  "kpiCard.ignoredFilters": "Ignora filtros: {filters}",
  "editor.data.title": "Fontes de dados",
  "editor.data.subtitle": "{n} fonte(s) materializada(s) no DuckDB deste relatório",
  "editor.data.addSource": "Adicionar fonte de dados",
  "editor.data.nav.aria": "Lista de fontes de dados",
  "editor.data.delete": "Excluir",
  "editor.data.deleteConfirm": "Excluir a fonte de dados {name}?",
  "editor.data.cantDeleteLast": "Um relatório deve ter pelo menos uma fonte de dados. Edite esta em vez de excluí-la.",
  "editor.data.noSourceTitle": "Nenhuma fonte de dados declarada ainda",
  "editor.data.noSourceHint": "Adicione uma fonte de dados para materializar uma tabela a partir dos dados brutos do projeto.",
  "editor.data.source.editorTitle": "Fonte de dados",
  "editor.data.source.name": "Nome",
  "editor.data.source.target": "Tabela de destino",
  "editor.data.source.targetHint": "Obrigatória: a tabela DuckDB onde esta view é gravada e que o relatório lê. Se você a deixar como está, ela usa o nome da fonte mais _data.",
  "editor.data.source.sql": "SQL da view",
  "editor.data.source.sqlHint": "Corpo do SELECT. O motor o envolve em CREATE OR REPLACE TABLE {target} AS <sql> quando você clica em Aplicar.",
  "editor.data.source.description": "Descrição (para a IA do chat)",
  "editor.data.source.descriptionHint": "Texto em Markdown apresentado à IA do chat como contexto de dados do relatório. Substitui o antigo slot de treinamento de DDL.",
  "editor.data.source.preview": "Colunas materializadas",
  "editor.data.source.notMaterialized": "A tabela \"{name}\" ainda não existe no DuckDB. Clique em \"Aplicar view ao DuckDB\" para materializá-la.",
  "editor.data.source.sample": "Linhas de amostra ({n})",
  "editor.data.source.schema": "Esquema ({n} colunas)",
  "editor.data.source.preview10": "Pré-visualização: primeiras {n} linhas",
  "editor.data.refresh": "Atualizar",
  "editor.data.refreshTitle": "Atualizar pré-visualização",
  "editor.data.save": "Salvar SQL da view",
  "editor.data.apply": "Aplicar view ao DuckDB",
  "editor.data.viewApplied": "Tabela {name} recriada no rascunho. O relatório publicado muda quando você publicar.",
  "editor.data.viewApplyError": "Falha ao recriar {name}: {err}",
  "editor.data.applyNeedsSave": "Alterações não salvas: clique em “Salvar SQL da view” e depois em Salvar (canto superior direito) antes de aplicar. Aplicar usa o SQL salvo, não o que está no editor.",
  "editor.data.loading": "Carregando…",
  "editor.data.noTableTitle": "Defina primeiro o nome de uma tabela DuckDB",
  "editor.data.noTableHint": "No Inspector, na seção Identidade, digite o nome em minúsculas e snake_case da tabela DuckDB deste relatório (ex.: 'metabase_data'). Depois volte aqui para carregar um parquet do S3.",
  "editor.data.loadTitle": "Carregar parquet do S3",
  "editor.data.loadHint": "Cole uma URL s3:// de um arquivo parquet. O builder o baixa para parquet_dir/{report_key}/ e materializa a tabela.",
  "editor.data.s3UrlPlaceholder": "s3://bucket/path/to/file.parquet",
  "editor.data.modeReplace": "Substituir",
  "editor.data.modeAppend": "Anexar",
  "editor.data.loadBtn": "Carregar",
  "editor.data.loadSuccess": "{rows} linhas carregadas em {ms}ms",
  "editor.data.dropBtn": "Excluir tabela",
  "editor.data.dropConfirm": "Excluir a tabela \"{table}\" e apagar seu parquet local? Isso não pode ser desfeito.",
  "editor.data.columnsTitle": "Colunas ({count})",
  "editor.data.sampleTitle": "Linhas de amostra (primeiras 10)",
  "editor.data.emptyTable": "A tabela \"{table}\" ainda não existe. Carregue um parquet acima para criá-la.",
  "editor.data.viewSqlTitle": "SQL da view",
  "editor.data.viewSqlHint": "Instrução SELECT sobre a tabela de fatos bruta do projeto. O motor a envolve em CREATE OR REPLACE VIEW {viewName} AS <sql> na próxima recarga do projeto.",
  "editor.data.viewSqlSaveBtn": "Salvar SQL da view",
  "editor.data.viewSqlClean": "Salvo",
  "editor.data.viewSqlDirty": "Alterações não salvas",
  "editor.data.viewSqlReloadHint": "Salvar grava o SQL na configuração do rascunho. Aplicar executa de novo CREATE OR REPLACE VIEW no DuckDB sobre a fonte existente do projeto, sem baixar de novo do S3. Use a Recarga completa do projeto somente quando a fonte original tiver mudado.",
  "editor.data.viewApplyBtn": "Aplicar view ao DuckDB",
  "editor.data.emptyView": "A view \"{view}\" ainda não existe no DuckDB. Salve o SQL e clique em Recarregar na aba Dados do projeto para criá-la.",
  "preview.noChartData": "Sem dados para o filtro atual.",
  "preview.noKpiData": "—",
  "preview.rowDrill.label": "Row drill",
  "preview.notFoundTitle": "Relatório não encontrado",
  "preview.notFoundHint": "A chave do relatório na URL não corresponde a nenhum rascunho.",
  "preview.loadErrorTitle": "Não foi possível carregar o relatório",
  "editor.ai.subtabs.ddl": "DDL",
  "editor.ai.subtabs.docs": "Documentação",
  "editor.ai.subtabs.examples": "Exemplos",
  "editor.ai.subtabs.prompt": "Prompt",
  "editor.ai.loading": "Carregando…",
  "editor.ai.saving": "Salvando…",
  "editor.ai.saveBtn": "Salvar",
  "editor.ai.savedHint": "Salvo.",
  "editor.ai.deleteConfirm": "Excluir esta linha? Isso não pode ser desfeito.",
  "editor.ai.noDDLHint": "Ainda não há DDL. Adicione a instrução CREATE TABLE para que a IA conheça o esquema.",
  "editor.ai.addDDLBtn": "Adicionar linha de DDL",
  "editor.ai.ddlContentPlaceholder": "CREATE TABLE …",
  "editor.ai.exampleNameLabel": "Rótulo",
  "editor.ai.exampleSqlLabel": "SQL",
  "editor.ai.exampleSqlPlaceholder": "SELECT … FROM …",
  "editor.ai.exampleExplanationLabel": "Explicação (opcional)",
  "editor.ai.exampleExplanationPlaceholder": "Por que esta consulta é a resposta certa.",
  "admin.common.loading": "Carregando…",
  "admin.common.saving": "Salvando…",
  "admin.common.save": "Salvar",
  "admin.common.cancel": "Cancelar",
  "admin.common.back": "Voltar",
  "admin.common.delete": "Excluir",
  "admin.common.select": "Selecionar",
  "admin.common.noResults": "Sem resultados",
  "nav.admin.prompts": "Prompts",
  "nav.admin.subscribers": "Assinantes",
  "admin.prompts.title": "Templates de prompt",
  "admin.prompts.subtitle": "Templates Jinja2 renderizados pelo agente de chat e pelo endpoint de Análise de IA.",
  "admin.prompts.scopeBannerTitle": "Padrões globais",
  "admin.prompts.scopeBannerBody": "Estes templates são os padrões globais usados quando um relatório não tem substituição. Os prompts de IA por relatório ficam em Relatórios → [relatório] → aba IA.",
  "admin.prompts.newBtn": "Novo prompt",
  "admin.prompts.empty": "Ainda não há prompts.",
  "admin.prompts.notFound": "Prompt não encontrado.",
  "admin.prompts.scope.all": "Todos",
  "admin.prompts.scope.global": "Global",
  "admin.prompts.scope.report": "Relatório",
  "admin.prompts.scope.client": "Cliente",
  "admin.prompts.col.name": "Nome",
  "admin.prompts.col.scope": "Escopo",
  "admin.prompts.col.key": "Destino",
  "admin.prompts.col.version": "Versão",
  "admin.prompts.col.active": "Ativo",
  "admin.prompts.col.updated": "Atualizado",
  "admin.prompts.activeLabel": "Ativo",
  "admin.prompts.savedHint": "Salvo (agora na v{version}).",
  "admin.prompts.shortcutHint": "Cmd/Ctrl+S para salvar.",
  "admin.prompts.deleteConfirm": "Excluir este template de prompt? Ele deixa de ser servido imediatamente.",
  "admin.prompts.create.title": "Novo template de prompt",
  "admin.prompts.create.nameLabel": "Nome",
  "admin.prompts.create.nameHint": "Chave de busca, por exemplo \"level1_system\". Deve ser única dentro do escopo e destino escolhidos.",
  "admin.prompts.create.scopeLabel": "Escopo",
  "admin.prompts.create.draftLabel": "Rascunho do relatório",
  "admin.prompts.create.clientLabel": "Chave do cliente",
  "admin.prompts.create.templateLabel": "Corpo inicial do template",
  "admin.prompts.create.submit": "Criar",
  "admin.subscribers.title": "Assinantes do portal",
  "admin.subscribers.subtitle": "Portais externos que consomem /api/v1/* com X-Builder-Token.",
  "admin.subscribers.newBtn": "Novo assinante",
  "admin.subscribers.empty": "Ainda não há assinantes. Crie um e copie seu token para conectar um portal.",
  "admin.subscribers.col.name": "Nome",
  "admin.subscribers.col.scope": "Escopo",
  "admin.subscribers.col.active": "Ativo",
  "admin.subscribers.col.lastSeen": "Último acesso",
  "admin.subscribers.col.actions": "Ações",
  "admin.subscribers.scopeAll": "Todos os relatórios e projetos",
  "admin.subscribers.active": "Ativo",
  "admin.subscribers.inactive": "Inativo",
  "admin.subscribers.revokeBtn": "Revogar",
  "admin.subscribers.revokeConfirm": "Revogar \"{name}\"? Seu token deixa de funcionar imediatamente.",
  "admin.subscribers.create.title": "Novo assinante do portal",
  "admin.subscribers.create.nameLabel": "Nome",
  "admin.subscribers.create.descriptionLabel": "Descrição (opcional)",
  "admin.subscribers.create.reportKeysLabel": "Chaves de relatório permitidas",
  "admin.subscribers.create.reportKeysHint": "Deixe vazio para permitir TODOS os relatórios.",
  "admin.subscribers.create.projectsLabel": "Projetos permitidos",
  "admin.subscribers.create.projectsHint": "Deixe vazio para permitir TODOS os projetos.",
  "admin.subscribers.create.submit": "Criar",
  "admin.subscribers.token.title": "Token de {name}",
  "admin.subscribers.token.warning": "Copie este token agora. Ele é exibido apenas uma vez e o servidor guarda somente seu hash bcrypt.",
  "admin.subscribers.token.tokenLabel": "Token de API",
  "admin.subscribers.token.copyBtn": "Copiar",
  "admin.subscribers.token.copied": "Copiado",
  "admin.subscribers.token.usageHint": "Use como: X-Builder-Token: <token> nas requisições /api/v1/* do portal.",
  "admin.subscribers.token.acknowledge": "Guardei este token com segurança.",
  "admin.subscribers.token.close": "Fechar",
  "editor.synonyms.title": "Sinônimos (opcional)",
  "editor.synonyms.hint": "Termos alternativos que o chat reconhecerá como esta coluna/KPI/gráfico/filtro. Digite um termo e pressione Enter (ou vírgula) para adicionar um chip; Backspace remove o último.",
  "editor.synonyms.inputPlaceholder": "+ adicionar sinônimo",
  "editor.synonyms.removeChip": "Remover",
  "editor.filter.labelLabel": "Rótulo de exibição (opcional)",
  "editor.filter.labelHint": "Rótulo bilíngue do chip exibido acima do filtro. Se ficar vazio, usa a chave.",
  "editor.filter.labelPlaceholder": "País",
  "canvas.readOnly.label": "Renderização somente leitura.",
  "canvas.readOnly.hint": "As alterações estruturais (adicionar/remover itens, mudar tipos etc.) passam pelo Claude com a skill report-builder. Clique em um item para inspecionar seus detalhes.",
  "canvas.expand": "Expandir para largura total",
  "canvas.collapse": "Restaurar layout 50/50",
  "inspector.itemTitle": "{element}",
  "inspector.itemHint": "A edição em linha se limita a rótulos bilíngues e sinônimos. Os demais campos são somente leitura.",
  "inspector.sectionFallback": "Seção",
  "inspector.sectionHint": "Título e subtítulo bilíngues continuam editáveis. Os campos estruturais são somente leitura.",
  "inspector.dashboardTitle": "Dashboard",
  "inspector.dashboardHint": "Identidade do relatório e rótulos dos filtros continuam editáveis. Os campos estruturais são somente leitura.",
  "inspector.kpi.editable": "Editáveis",
  "inspector.kpi.structural": "Configuração (somente leitura)",
  "inspector.kpi.sql": "SQL",
  "inspector.kpi.format": "Formato",
  "inspector.kpi.variant": "Variante",
  "inspector.kpi.unit": "Unidade",
  "inspector.kpi.ignoreFilters": "Filtros ignorados",
  "inspector.kpi.drillTarget": "Destino do drill",
  "inspector.chart.editable": "Editáveis",
  "inspector.chart.structural": "Configuração (somente leitura)",
  "inspector.chart.type": "Tipo",
  "inspector.chart.dimension": "Dimensão",
  "inspector.chart.metric": "Métrica",
  "inspector.chart.metrics": "Métricas",
  "inspector.chart.sort": "Ordem",
  "inspector.chart.limit": "Limite",
  "inspector.chart.axes": "Eixos",
  "inspector.chart.ignoreFilters": "Filtros ignorados",
  "inspector.table.editable": "Editáveis por coluna",
  "inspector.table.editableHint": "Cabeçalho bilíngue e sinônimos por coluna. Formato, renderização e campos estruturais continuam somente leitura.",
  "inspector.table.structural": "Configuração (somente leitura)",
  "inspector.table.pageSize": "Tamanho da página",
  "inspector.table.sort": "Ordem padrão",
  "inspector.table.ignoreFilters": "Filtros ignorados",
  "inspector.table.rowDrill": "Destino do drill por linha",
  "inspector.table.rowDrillMode": "Como o detalhe é exibido",
  "inspector.table.rowDrillMode.swap": "Substituir na célula (com deslizamento), padrão",
  "inspector.table.rowDrillMode.accordion": "Acordeão sob a linha",
  "inspector.table.rowDrillModeHint": "Substituir: o detalhe ocupa o lugar da tabela com um deslizamento; Voltar o restaura. Acordeão: a linha continua visível e o detalhe rola sob ela dentro da tabela. O cartão nunca cresce em nenhum dos dois.",
  "inspector.table.crossFilter": "Filtro cruzado →",
  "inspector.table.crossFilterNone": "(nenhum)",
  "inspector.table.noColumns": "Nenhuma coluna configurada.",
  "inspector.text.editable": "Conteúdo",
  "inspector.text.contentLabel": "Markdown / texto simples",
  "inspector.text.contentHint": "Conteúdo escrito pelo autor, exibido no dashboard. É renderizado literalmente, sem alternativa estrutural.",
  "inspector.text.contentPlaceholder": "Escreva Markdown ou texto simples…",
  "inspector.section.editable": "Rótulos da seção (editáveis)",
  "inspector.section.structural": "Configuração da seção (somente leitura)",
  "inspector.section.id": "ID",
  "inspector.section.kind": "Tipo",
  "inspector.section.drillId": "ID do drill",
  "inspector.section.items": "Itens ({count})",
  "inspector.section.filters": "Filtros da seção ({count})",
  "inspector.dashboard.identityEditable": "Identidade do relatório (editável)",
  "inspector.dashboard.identityStructural": "Identidade do relatório (somente leitura)",
  "inspector.dashboard.key": "Chave",
  "inspector.dashboard.duckdbTable": "Tabela DuckDB",
  "inspector.dashboard.promptLanguage": "Idioma do Prompt",
  "inspector.dashboard.globalFilters": "Filtros globais ({count})",
  "inspector.dashboard.noFilters": "Nenhum filtro global configurado.",
  "inspector.filter.column": "Coluna",
  "inspector.filter.default": "Valor padrão",
  "inspector.filter.locked": "Bloqueado",
  "inspector.filter.sliderStep": "Passo do controle deslizante",
  "inspector.filter.sliderStep.day": "Dia",
  "inspector.filter.sliderStep.week": "Semana (segundas-feiras)",
  "inspector.filter.sliderStep.month": "Mês (dia 1)",
  "inspector.filter.sliderStepHint": "Granularidade de ajuste dos controles do seletor de datas. O valor do filtro emitido é sempre um intervalo simples de data inicial e final.",
  "inspector.filter.rangeFormat": "Formato do valor",
  "inspector.filter.rangeFormat.number": "Número",
  "inspector.filter.rangeFormat.percent": "Porcentagem (a coluna é uma fração 0-1)",
  "inspector.filter.rangeFormat.currency": "Moeda (USD)",
  "inspector.filter.rangeDefaultMin": "Mínimo padrão",
  "inspector.filter.rangeDefaultMax": "Máximo padrão",
  "inspector.filter.rangeScale": "Escala do controle deslizante",
  "inspector.filter.rangeScale.linear": "Linear",
  "inspector.filter.rangeScale.log": "Logarítmica (valores assimétricos, como receita)",
  "inspector.filter.rangeHistogramTable": "Tabela do histograma (id)",
  "inspector.filter.rangeHint": "Digite os limites como o usuário os vê (30 para 30 %). Deixe um lado vazio para não limitá-lo. O controle deslizante cobre todo o intervalo da coluna.",
  "editor.report.displayNameLabel": "Nome de exibição (bilíngue)",
  "editor.report.descriptionLabel": "Descrição (bilíngue)",
  "access.tabs.label": "Seções de acesso",
  "access.tabs.scopes": "Escopos",
  "access.tabs.groups": "Grupos",
  "access.tabs.people": "Pessoas",
  "access.tabs.audit": "Auditoria",
  "access.common.errorTitle": "Algo falhou",
  "access.common.missingLabel": "Este valor ainda não tem rótulo, por isso é exibido como está.",
  "access.common.notComputed": "não calculado",
  "access.common.notComputedHint": "Ninguém calculou isso ainda. Não é zero.",
  "access.common.badDate": "data ilegível",
  "access.common.refresh": "Atualizar",
  "access.common.prev": "Anterior",
  "access.common.next": "Próximo",
  "access.scopes.title": "Escopos",
  "access.scopes.subtitle": "Um escopo é o recorte dos dados que uma pessoa lê. As regras são combinadas com AND e materializadas como um arquivo por escopo e projeto.",
  "access.scopes.add": "Novo escopo",
  "access.scopes.all": "Tudo",
  "access.scopes.col.scope": "Escopo",
  "access.scopes.col.rules": "Regras",
  "access.scopes.col.projects": "Projetos",
  "access.scopes.col.usedBy": "Usado por",
  "access.scopes.col.state": "Estado",
  "access.scopes.col.updated": "Atualizado",
  "access.scopes.appliesTo": "{n} com acesso · {m} sem acesso",
  "access.scopes.appliesToNone": "nenhum projeto",
  "access.scopes.appliesToNoneHint": "Não se aplica a nenhum projeto, por isso não concede nada em lugar nenhum.",
  "access.scopes.usedBy": "{n} grupo(s) · {people} pessoa(s)",
  "access.scopes.usedByNone": "ninguém",
  "access.scopes.usedByNoneHint": "Nenhum grupo o utiliza e ninguém é resolvido por ele.",
  "access.scopes.empty.title": "Nenhum escopo ainda",
  "access.scopes.empty.desc": "Crie um, associe-o a um grupo, e os membros desse grupo leem apenas a sua parte.",
  "access.scopes.actions.detail": "Abrir",
  "access.scopes.actions.rebuild": "Reconstruir",
  "access.scopes.actions.delete": "Excluir",
  "access.scopes.state.built": "construído",
  "access.scopes.state.noMapping": "vazio (sem correspondência)",
  "access.scopes.state.building": "construindo",
  "access.scopes.state.failed": "falhou",
  "access.scopes.state.notApplicable": "não se aplica",
  "access.scopes.state.neverBuilt": "nunca construído",
  "access.scopes.state.skippedConcurrent": "outra construção o assumiu",
  "access.scopes.rules.chip": "{key}: {n} valor(es)",
  "access.scopes.rules.all": "sem regras, tudo",
  "access.scopes.rules.allHint": "O escopo reservado. Não tem regras, nem arquivo, nem reconstrução.",
  "access.scopes.rules.none": "sem regras",
  "access.scopes.rules.noneHint": "Um escopo sem regras não recorta nada. Adicione pelo menos uma.",
  "access.scopes.rules.andHint": "Todas as regras devem corresponder: são combinadas com AND.",
  "access.scopes.rules.emptyTitle": "Nenhuma regra ainda",
  "access.scopes.rules.emptyDesc": "Um escopo sem regras não recorta nada e não pode ser salvo.",
  "access.scopes.rules.declaredIn": "declarada em {n} projeto(s)",
  "access.scopes.rules.removeRule": "Remover",
  "access.scopes.rules.reference": "Ler valores de",
  "access.scopes.rules.referenceHelp": "Um escopo vale para todo o cliente; os valores vêm do arquivo ativo de um projeto. Dois projetos podem ter valores diferentes para a mesma chave.",
  "access.scopes.rules.addLabel": "Adicionar uma regra",
  "access.scopes.rules.addHelp": "Só são oferecidas as chaves declaradas como utilizáveis para escopo.",
  "access.scopes.rules.addPlaceholder": "Escolha uma dimensão…",
  "access.scopes.rules.keyOption": "{key}: {n} projeto(s)",
  "access.scopes.rules.allKeysUsed": "Todas as dimensões disponíveis já são usadas por uma regra.",
  "access.scopes.rules.noKeysTitle": "Nenhuma dimensão pode ser usada como escopo ainda",
  "access.scopes.rules.noKeysDesc": "Primeiro, declare uma dimensão como utilizável para escopo na aba Dados de um projeto.",
  "access.scopes.rules.orphanTitle": "Esta dimensão não está mais disponível",
  "access.scopes.rules.orphanDesc": "Nenhum projeto declara «{key}» como utilizável para escopo. A regra é mantida como está; exclua-a ou restaure a dimensão.",
  "access.scopes.values.noneSelected": "nenhum valor escolhido ainda",
  "access.scopes.values.remove": "Remover este valor",
  "access.scopes.values.searchLabel": "Buscar valores",
  "access.scopes.values.searchPlaceholder": "Digite para filtrar…",
  "access.scopes.values.errorTitle": "Não foi possível ler os valores",
  "access.scopes.values.summary": "Exibindo {shown} de {total} valores distintos de {column} ({type}).",
  "access.scopes.values.nulls": "{n} linha(s) não têm valor. Não pertencem a nenhum escopo restrito.",
  "access.scopes.values.notScopableTitle": "Esta coluna não pode ser usada como escopo",
  "access.scopes.values.notScopable": "O tipo ({type}) é recusado quando o escopo é construído. Os valores servem para um filtro.",
  "access.scopes.values.emptyTitle": "Esta coluna não tem valores",
  "access.scopes.values.noMatchTitle": "Nada corresponde a «{search}»",
  "access.scopes.values.noMatchDesc": "Só é possível escolher valores que existem nos dados. Não há texto livre aqui, de propósito.",
  "access.scopes.values.rowCount": "{n} linha(s)",
  "access.scopes.values.range": "{from}-{to} de {total}",
  "access.scopes.form.createTitle": "Novo escopo",
  "access.scopes.form.grantsNothingTitle": "Criá-lo não concede nada a ninguém",
  "access.scopes.form.grantsNothing": "Um novo escopo não tem grupo, nem membro, nem arquivo até que algo o construa.",
  "access.scopes.form.id": "Identificador",
  "access.scopes.form.idHelp": "Minúsculas, dígitos, hífen e sublinhado. É o nome do arquivo, então «us-north» e «us_north» são dois escopos diferentes.",
  "access.scopes.form.idRequired": "Digite um identificador.",
  "access.scopes.form.idSpaces": "Não pode começar nem terminar com espaço.",
  "access.scopes.form.idShape": "Comece com uma letra minúscula; depois, letras minúsculas, dígitos, «-» ou «_». Entre 2 e 41 caracteres.",
  "access.scopes.form.name": "Nome",
  "access.scopes.form.description": "Descrição",
  "access.scopes.form.descriptionHelp": "O que é este recorte, nas palavras que a equipe usa.",
  "access.scopes.form.rulesTitle": "Regras",
  "access.scopes.delete.title": "Excluir «{name}»",
  "access.scopes.delete.confirm": "Excluir o escopo e seus arquivos",
  "access.scopes.delete.blockedTitle": "Não pode ser excluído",
  "access.scopes.delete.blocked": "{groups} grupo(s) o utilizam e {people} pessoa(s) são resolvidas por ele. Mova-os primeiro, não há opção de forçar.",
  "access.scopes.delete.filesTitle": "Os arquivos de dados também são excluídos",
  "access.scopes.delete.files": "Seus arquivos também são excluídos, removidos sob o bloqueio de escrita. Não há como desfazer: reconstruir depois começa do zero.",
  "access.scopes.detail.identity": "Identidade",
  "access.scopes.detail.identityDesc": "O identificador não pode mudar: é o nome do arquivo em que a parte de cada projeto é gravada.",
  "access.scopes.detail.kind": "Tipo",
  "access.scopes.detail.usedBy": "Usado por",
  "access.scopes.detail.rules": "Regras",
  "access.scopes.detail.rulesDesc": "Salvar APOSENTA os arquivos e ponteiros deste escopo em todos os projetos e exclui seus Snapshots de IA, na mesma requisição. Até que seja reconstruído, todos que leem por este escopo recebem um erro (503) em todos os relatórios, nunca o recorte anterior. Se uma recarga estiver com o bloqueio de escrita, o salvamento é recusado e nada muda.",
  "access.scopes.detail.notEditableTitle": "Este escopo não é editável",
  "access.scopes.detail.preview": "Ver o impacto",
  "access.scopes.detail.mustPreviewTitle": "Veja o impacto primeiro",
  "access.scopes.detail.mustPreview": "O salvamento precisa nomear os grupos que afeta, por isso o impacto é consultado antes de permiti-lo.",
  "access.scopes.detail.impactTitle": "O que esta edição mudaria",
  "access.scopes.detail.rulesInvalid": "Estas regras foram recusadas",
  "access.scopes.detail.impactWho": "{groups} grupo(s) e {people} pessoa(s) são resolvidos por este escopo.",
  "access.scopes.detail.impactRows": "{before} linhas agora, {after} depois",
  "access.scopes.detail.impactUnknown": "linhas desconhecidas ({reason})",
  "access.scopes.detail.noticeTitle": "O que aconteceu",
  "access.scopes.detail.retiredTitle": "Salvo, leitores bloqueados até a reconstrução",
  "access.scopes.detail.retired": "Os arquivos foram aposentados e os Snapshots de IA excluídos. Todos os vinculados a este escopo recebem um 503 em todos os relatórios até que você o reconstrua, projeto por projeto, abaixo.",
  "access.scopes.detail.projects": "Projetos",
  "access.scopes.detail.projectsDesc": "Se as regras conseguem recortar cada projeto e o que a última construção deixou lá.",
  "access.scopes.detail.col.project": "Projeto",
  "access.scopes.detail.col.state": "Estado",
  "access.scopes.detail.col.rows": "Linhas",
  "access.scopes.detail.col.version": "Versão dos dados",
  "access.scopes.detail.col.built": "Última construção",
  "access.scopes.detail.col.started": "Iniciada",
  "access.scopes.detail.col.rebuild": "Reconstruir",
  "access.scopes.detail.rebuild": "Reconstruir",
  "access.scopes.detail.rebuilding": "Construindo…",
  "access.scopes.detail.rowsOf": "{rows} de {total}",
  "access.scopes.detail.noRowsHint": "Ainda não há linha de construção para este projeto. Não significa zero linhas.",
  "access.scopes.detail.noVersionHint": "Nenhuma construção registrou qual arquivo de dados leu.",
  "access.scopes.detail.stuck": "TRAVADA",
  "access.scopes.detail.stuckTitle": "Esta construção está travada",
  "access.scopes.detail.builds": "Histórico de construções",
  "access.scopes.detail.buildsDesc": "{total} construção(ões), da mais recente para a mais antiga.",
  "access.scopes.detail.buildsCapped": "Exibindo {shown} de {total}. O histórico continua.",
  "access.groups.title": "Grupos",
  "access.groups.subtitle": "Um grupo carrega um escopo e uma matriz de conteúdo. O que uma pessoa pode ver é o OR dos seus grupos.",
  "access.groups.add": "Novo grupo",
  "access.groups.col.group": "Grupo",
  "access.groups.col.scope": "Escopo",
  "access.groups.col.members": "Membros",
  "access.groups.col.content": "Conteúdo",
  "access.groups.col.health": "Estado",
  "access.groups.col.updated": "Atualizado",
  "access.groups.contentCount": "{reports} relatório(s) · {projects} célula(s) de projeto",
  "access.groups.scopeAllHint": "Os membros deste grupo leem todo o conjunto de dados.",
  "access.groups.health.grantsNothing": "não abre nada",
  "access.groups.health.noMembers": "ninguém nele",
  "access.groups.health.ok": "em uso",
  "access.groups.empty.title": "Nenhum grupo ainda",
  "access.groups.empty.desc": "Uma pessoa sem grupo não vê nenhum relatório. Crie o primeiro e atribua um escopo a ele.",
  "access.groups.actions.detail": "Abrir",
  "access.groups.actions.delete": "Excluir",
  "access.groups.base.chip": "Base",
  "access.groups.base.chipTitle": "O grupo base: abre todos os relatórios publicados e todos os dados. Não é excluído e seu escopo não muda.",
  "access.groups.base.contentTitle": "Todos os relatórios publicados",
  "access.groups.base.contentBody": "Este grupo abre todos os relatórios publicados, inclusive os que forem publicados depois. Suas ações são fixas: ver o relatório, seus dados, o chat, a análise de IA, e ver e baixar mestres e arquivos. Não inclui enviar por e-mail nem programar envios. Para dar a alguém outro conjunto, coloque a pessoa em um subgrupo.",
  "access.groups.tab.groups": "Grupos",
  "access.groups.tab.defaults": "Padrões por função",
  "access.groups.tab.members": "Membros",
  "access.groups.tab.scope": "Escopo",
  "access.groups.tab.content": "Conteúdo",
  "access.groups.form.createTitle": "Novo grupo",
  "access.groups.form.emptyTitle": "Começa vazio e não concede nada",
  "access.groups.form.empty": "Adicione pessoas e abra relatórios depois. Os dois estados aparecem na lista com uma palavra.",
  "access.groups.form.name": "Nome",
  "access.groups.form.nameHelp": "Precisa ser único, e é o que a trilha de auditoria exibe.",
  "access.groups.form.description": "Descrição",
  "access.groups.form.scope": "Escopo",
  "access.groups.form.scopeHelp": "Não tem padrão, de propósito: um grupo existe para carregar uma restrição.",
  "access.groups.form.scopePlaceholder": "Escolha um escopo…",
  "access.groups.form.scopeAllOption": "Tudo (sem restrição)",
  "access.groups.form.scopeAllTitle": "Este grupo não restringe nada",
  "access.groups.form.scopeAllWarn": "Seus membros leem todo o conjunto de dados de todos os projetos que podem abrir, e o mesmo vale para quem for incluído depois, seja qual for a restrição dos outros grupos: a união com «Tudo» é «Tudo».",
  "access.groups.delete.title": "Excluir «{name}»",
  "access.groups.delete.confirm": "Excluir o grupo",
  "access.groups.delete.body": "{members} pessoa(s) perdem os {reports} relatório(s) que este grupo abre.",
  "access.groups.delete.scopeNote": "O escopo em si não é excluído, apenas este grupo e suas células.",
  "access.groups.members.add": "Adicionar pessoas",
  "access.groups.members.addTitle": "Adicionar pessoas ao grupo",
  "access.groups.members.addCount": "Adicionar {count}",
  "access.groups.members.addNote": "Adicionar alguém pode mudar o escopo ao qual a pessoa é resolvida, e o novo arquivo pode ainda não existir. Não muda NADA para uma pessoa com a função de administrador: ela lê tudo, independentemente dos seus grupos, então uma restrição escrita aqui não se aplicaria a ela, sem aviso.",
  "access.groups.members.searchLabel": "Buscar por nome ou e-mail",
  "access.groups.members.noneOfferable": "Ninguém mais para adicionar",
  "access.groups.members.noneOfferableDesc": "Todos da lista já são membros.",
  "access.groups.members.col.person": "Pessoa",
  "access.groups.members.col.role": "Função",
  "access.groups.members.col.status": "Status",
  "access.groups.members.col.effective": "Resolvida para",
  "access.groups.members.col.added": "Adicionada",
  "access.groups.members.union": "união de {n} escopos",
  "access.groups.members.scope.unrestricted": "lê tudo",
  "access.groups.members.scope.unrestrictedHint": "A união dela é resolvida para «Tudo», então o recorte deste grupo não decide nada para ela. Um grupo sem restrição basta: a união com «Tudo» é «Tudo». Para que esta restrição tenha efeito, retire a pessoa do grupo que carrega o escopo sem restrição.",
  "access.groups.members.scope.elsewhere": "decidido em outro lugar",
  "access.groups.members.scope.elsewhereHint": "A união dela é resolvida para um escopo que não é o deste grupo, então o que ela lê é decidido por outro de seus grupos. Abra a pessoa para ver de quais grupos veio.",
  "access.groups.members.scope.holds": "recorte deste grupo",
  "access.groups.members.scope.holdsHint": "A união dela é resolvida exatamente para o escopo deste grupo, então o recorte desta página é aquele pelo qual ela lê.",
  "access.groups.members.remove": "Remover do grupo",
  "access.groups.members.footnote": "Todos os membros são listados, nunca uma página parcial: uma decisão de acesso baseada em uma lista truncada seria a pior coisa que esta tela poderia fazer.",
  "access.groups.members.noticeTitle": "O que esta mudança faz",
  "access.groups.scope.title": "Escopo deste grupo",
  "access.groups.scope.desc": "Alterá-lo muda o que cada membro lê, a partir da próxima requisição, até onde o grupo mais amplo dele permitir. O escopo de uma pessoa é a união dos escopos dos seus grupos, e a união com «Tudo» é «Tudo».",
  "access.groups.scope.openScope": "Abrir o escopo",
  "access.groups.scope.projectsDesc": "Onde este escopo tem arquivo e onde não tem.",
  "access.groups.scope.warningTitle": "Isto custa acesso a alguém",
  "access.groups.content.desc": "As células sem linha passam para os outros grupos da pessoa e depois para os padrões por função, exceto «Ver», que não tem padrão: um relatório que nenhum grupo dela abre não é aberto.",
  "access.groups.content.hint": "Clique em uma célula para alternar: padrão → concedido → negado → padrão.",
  "access.groups.content.save": "Salvar ({count})",
  "access.groups.content.entitled": "Este grupo abre {n} relatório(s). Um relatório sem célula «Ver» não é aberto de forma alguma.",
  "access.groups.content.projectLevel": "Nível de projeto",
  "access.groups.content.projectLevelBadge": "arquivos mestre e arquivos",
  "access.groups.content.projectSectionsHint": "Estas duas seções são concedidas para o projeto inteiro, não por relatório.",
  "access.groups.content.noProject": "Sem projeto",
  "access.groups.content.granted": "concedido",
  "access.groups.content.denied": "negado",
  "access.groups.content.defaultTitle": "Sem linha aqui. O padrão da função decide, e diz: {value}. «Ver» é a exceção: não tem padrão, então sem linha o relatório não é aberto.",
  "access.groups.content.grantedTitle": "Concedido aqui. Também prevalece sobre uma negação em outro grupo.",
  "access.groups.content.entitlementTitle": "Esta é a célula que ABRE o relatório. Sem ela, as outras células não concedem nada.",
  "access.groups.content.denyIsWeak": "Negado aqui, mas uma concessão em OUTRO grupo da mesma pessoa prevalece. Para revogar, remova a concessão em todos os lugares.",
  "access.groups.content.unknownDefault": "Não existe linha de padrão por função para {section}.{action}, então ninguém sabe o que uma célula vazia significa aqui.",
  "access.defaults.subtitle": "O que significa uma célula vazia da matriz de conteúdo de um grupo. Somente a função «user» é editável.",
  "access.defaults.save": "Salvar ({count})",
  "access.defaults.readonly": "somente leitura",
  "access.defaults.adminNote": "A função admin ignora todas as verificações, então estas células não decidem nada.",
  "access.defaults.missingTitle": "Alguns padrões não têm linha",
  "access.defaults.missing": "Ninguém sabe o que uma célula vazia significa para: {cells}. Defina-os para que a matriz do grupo possa dizer.",
  "access.defaults.grantedTitle": "Concedido por padrão",
  "access.defaults.deniedTitle": "Negado por padrão",
  "access.defaults.unknownCell": "Não há linha para {section}.{action}. Isso é desconhecido, não negado.",
  "access.people.title": "Pessoas",
  "access.people.subtitle": "Quem entra, a quais grupos pertence e o escopo para o qual esses grupos são resolvidos.",
  "access.people.add": "Nova pessoa",
  "access.people.count": "{count} pessoa(s)",
  "access.people.allRoles": "Todas as funções",
  "access.people.col.person": "Pessoa",
  "access.people.col.role": "Função",
  "access.people.col.groups": "Grupos",
  "access.people.col.effective": "Escopo",
  "access.people.col.builder": "Builder",
  "access.people.col.lastLogin": "Último acesso",
  "access.people.lastLogin.window": "{n} nos últimos 30 dias",
  "access.people.lastLogin.noneSince": "Sem acessos desde {date}",
  "access.people.lastLogin.noneYet": "Ainda não há acessos registrados",
  "access.people.col.status": "Status",
  "access.people.active": "ativa",
  "access.people.inactive": "inativa",
  "access.people.builderNone": "sem acesso",
  "access.people.builderFull": "total",
  "access.people.builderPartial": "parcial",
  "access.people.groupCount": "{n} grupo(s)",
  "access.people.noGroups": "sem grupo",
  "access.people.noGroupsHint": "Uma pessoa sem grupo não recebe nenhum relatório de nenhum grupo.",
  "access.people.partialTitle": "Esta lista está incompleta",
  "access.people.partial": "Não foi possível ler os membros destes grupos: {groups}. As contagens de grupos abaixo são um mínimo.",
  "access.people.empty.title": "Ninguém aqui",
  "access.people.empty.desc": "Crie a primeira pessoa e coloque-a em um grupo.",
  "access.people.actions.detail": "Abrir",
  "access.people.actions.reset": "Redefinir a senha",
  "access.people.actions.resendInvite": "Reenviar o convite",
  "access.people.actions.resetLink": "Enviar link para trocar a senha",
  "access.people.form.inviteTitle": "A pessoa escolhe sua senha",
  "access.people.form.inviteHint": "Enviamos um convite de noreply@omnitok.com com um link que funciona por 7 dias. Ninguém mais vê a senha.",
  "access.people.mail.okTitle": "E-mail enviado",
  "access.people.mail.failTitle": "O e-mail não saiu",
  "access.people.mail.inviteSent": "Enviamos o convite para {email}.",
  "access.people.mail.resetSent": "Enviamos para {email} um link para escolher uma nova senha. Ele funciona por 60 minutos; a senha atual continua funcionando até que seja usado.",
  "access.people.mail.inviteFailed": "A pessoa {email} foi criada, mas o convite não saiu: {error}. Use «Reenviar o convite» na linha dela.",
  "access.people.mail.actionFailed": "Nada foi enviado para {email}: {error}",
  "access.people.actions.delete": "Excluir",
  "access.people.legacyCounts": "Linhas legadas ainda nesta pessoa: {subs} assinatura(s) e {overrides} exceção(ões). Elas são lidas pelo sistema de permissões antigo e estão sendo aposentadas.",
  "access.people.identity": "Identidade",
  "access.people.identityDesc": "O e-mail é a identidade e não muda aqui.",
  "access.people.form.name": "Nome",
  "access.people.form.email": "E-mail",
  "access.people.form.emailFixed": "Não pode ser alterado a partir deste console.",
  "access.people.form.role": "Função",
  "access.people.form.roleHelp": "Um admin ignora todas as verificações de permissão, então os grupos não decidem nada para ele.",
  "access.people.form.status": "Status",
  "access.people.form.password": "Senha",
  "access.people.form.passwordHelp": "Pelo menos 8 caracteres. É exibida uma única vez e não há e-mail para enviá-la.",
  "access.people.form.passwordWarning": "Copie antes de fechar: não poderá ser exibida novamente.",
  "access.people.form.generate": "Gerar",
  "access.people.form.createTitle": "Nova pessoa, etapa {step} de {total}",
  "access.people.form.next": "Próximo",
  "access.people.form.back": "Voltar",
  "access.people.form.fillRequired": "Preencha o nome, o e-mail e uma senha de pelo menos 8 caracteres.",
  "access.people.form.groupsTitle": "Grupos são a única coisa que você pode conceder",
  "access.people.form.groupsHint": "Não existem mais permissões por pessoa: o que alguém vê vem dos seus grupos.",
  "access.people.form.noGroupsTitle": "Ainda não há grupos",
  "access.people.form.noGroupsHint": "Crie um primeiro, ou esta pessoa entrará e não verá nada.",
  "access.people.form.noPickTitle": "Nenhum grupo escolhido",
  "access.people.form.noPick": "Ela poderá entrar e não verá nenhum relatório.",
  "access.people.groups.title": "Grupos",
  "access.people.groups.desc": "Tudo o que esta pessoa vê vem daqui.",
  "access.people.groups.col.group": "Grupo",
  "access.people.groups.col.scope": "Escopo",
  "access.people.groups.join": "Adicionar a grupos",
  "access.people.groups.joinTitle": "Adicionar esta pessoa a grupos",
  "access.people.groups.joinCount": "Adicionar a {count}",
  "access.people.groups.joinNote": "É assim que «mesmo acesso que outra pessoa» é expresso agora: participação compartilhada, que sobrevive à saída da outra pessoa.",
  "access.people.groups.leave": "Remover do grupo",
  "access.people.groups.noneOfferable": "Já está em todos os grupos",
  "access.people.groups.noneOfferableDesc": "Não há outro grupo ao qual adicioná-la.",
  "access.people.effective.title": "Escopo resultante",
  "access.people.effective.eyebrow": "Calculado a partir dos grupos",
  "access.people.effective.name": "união de {n} grupo(s)",
  "access.people.effective.derived": "Este identificador é derivado das regras dos grupos acima. É recalculado a cada mudança de participação.",
  "access.people.effective.allHint": "Sem restrição: esta pessoa lê todo o conjunto de dados. Há DUAS formas de chegar aqui e este chip não as distingue: um grupo sem restrição (a união com «Tudo» é «Tudo»), ou a função de administrador, que lê tudo independentemente dos seus grupos. Em ambos os casos, um grupo restrito do qual ela também faça parte não decide nada.",
  "access.people.effective.unknown": "desconhecido",
  "access.people.effective.unknownHint": "Nenhum grupo informa um escopo para esta pessoa, então este console não pode dizer a qual ela é resolvida.",
  "access.people.effective.noGroups": "Ela não está em nenhum grupo, então nenhum grupo lhe concede relatório algum.",
  "access.people.effective.orphanHint": "O vínculo dela nomeia um escopo que nenhum de seus grupos carrega. Algo o escreveu manualmente, ou o recálculo ainda não alcançou.",
  "access.people.effective.computed": "Isto é calculado a partir dos grupos da pessoa. Para mudá-lo, mude os grupos.",
  "access.people.effective.editGroups": "Editar os grupos",
  "access.people.builder.title": "Acesso ao Builder",
  "access.people.builder.desc": "Acesso da equipe Omnitok a este console. Não é uma configuração de grupo e nunca será.",
  "access.people.reset.title": "Redefinir a senha",
  "access.people.reset.prompt": "Uma nova senha é gerada para {name} e exibida uma única vez.",
  "access.people.reset.generate": "Gerar",
  "access.people.reset.newPassword": "Nova senha",
  "access.people.reset.warning": "Copie antes de fechar: não poderá ser exibida novamente, e não há e-mail para enviá-la.",
  "access.people.reset.done": "Concluir",
  "access.people.delete.title": "Excluir «{name}»",
  "access.people.delete.confirm": "Excluir a pessoa",
  "access.people.delete.body": "Ela está em {groups} grupo(s) e não poderá entrar.",
  "access.people.delete.soft": "É uma exclusão lógica: a linha e suas participações permanecem, então reativar restaura o que ela tinha.",
  "access.audit.title": "Auditoria",
  "access.audit.subtitle": "Cada mudança de acesso feita em Acessos, com quem a fez e como era antes.",
  "access.audit.startsHereTitle": "A trilha começa aqui",
  "access.audit.startsHere": "As mudanças feitas antes deste recurso não foram registradas. Um resultado vazio para uma data anterior significa «não registrado», nunca «nada aconteceu».",
  "access.audit.filter.action": "Ação",
  "access.audit.filter.actor": "Quem",
  "access.audit.filter.target": "Objeto",
  "access.audit.filter.limit": "Linhas",
  "access.audit.apply": "Aplicar",
  "access.audit.limitRange": "Linhas: um número inteiro entre 1 e {max}.",
  "access.audit.col.when": "Quando",
  "access.audit.col.who": "Quem",
  "access.audit.col.actorKind": "Console",
  "access.audit.col.action": "Ação",
  "access.audit.col.target": "Objeto",
  "access.audit.col.detail": "Detalhe",
  "access.audit.view": "Ver",
  "access.audit.atCap": "Exibindo {limit} de {total}. A trilha continua, peça mais linhas.",
  "access.audit.empty.title": "Nada registrado para este filtro",
  "access.audit.empty.desc": "Amplie o filtro ou peça mais linhas.",
  "access.audit.detailTitle": "O que mudou",
  "access.audit.actorId": "Identificador de quem agiu",
  "access.audit.actorGone": "a pessoa não existe mais; o e-mail permanece",
  "access.audit.before": "Antes",
  "access.audit.after": "Depois",
  "access.audit.noBefore": "Não existia antes.",
  "access.audit.noAfter": "Não existe mais.",
  "access.audit.actor.providerAdmin": "builder",
  "access.audit.actor.tenantAdmin": "console do cliente",
  "access.audit.actor.platform": "plataforma",
  "access.audit.actor.system": "automático",
  "access.audit.action.dimensionCreate": "dimensão criada",
  "access.audit.action.dimensionUpdate": "dimensão editada",
  "access.audit.action.dimensionDelete": "dimensão excluída",
  "access.audit.action.scopeCreate": "escopo criado",
  "access.audit.action.scopeUpdate": "escopo editado",
  "access.audit.action.scopeDelete": "escopo excluído",
  "access.audit.action.scopeRebuild": "escopo reconstruído",
  "access.audit.action.groupCreate": "grupo criado",
  "access.audit.action.groupUpdate": "grupo editado",
  "access.audit.action.groupDelete": "grupo excluído",
  "access.audit.action.groupPermissionSet": "conteúdo alterado",
  "access.audit.action.groupMemberAdd": "adicionada a um grupo",
  "access.audit.action.groupMemberRemove": "removida de um grupo",
  "access.audit.action.userEffectiveScopeChange": "escopo recalculado",
  "access.audit.action.roleDefaultUpdate": "padrões por função alterados",
  "access.audit.action.userCreate": "pessoa criada",
  "access.audit.action.userRoleChange": "função alterada",
  "access.audit.action.userDeactivate": "desativada",
  "access.audit.action.userReactivate": "reativada",
  "access.audit.action.userLoginAllowedChange": "login alterado",
  "access.audit.action.userDelete": "pessoa removida",
  "access.audit.action.userPasswordReset": "senha redefinida",
  "access.audit.action.userBuilderAccess": "acesso ao builder alterado",
  "access.audit.action.viewAsScopePreview": "escopo pré-visualizado",
  "access.groups.tab.ai": "IA",
  "access.groups.tab.experience": "Experiência",
  "access.ai.save": "Salvar as configurações de IA",
  "access.ai.saveEffect": "As duas configurações valem a partir da próxima requisição das pessoas deste grupo: a nota chega ao chat e aos e-mails delas, e a análise é gerada na próxima recarga.",
  "access.ai.insights.title": "Análise de IA para este grupo",
  "access.ai.insights.desc": "A análise é gerada por ESCOPO, não por grupo: dois grupos com o mesmo escopo leem os mesmos parágrafos. Ativar isto pede uma análise para o escopo deste grupo. É a alavanca de custo, e o custo aparece ao lado do interruptor.",
  "access.ai.insights.switch": "Gerar Análise de IA para o escopo deste grupo",
  "access.ai.insights.switchHelp": "Desativado até que alguém ative: cobrar de um cliente N vezes as gerações porque uma linha de grupo foi criada não é um padrão que alguém escolheu.",
  "access.ai.note.title": "Nota de contexto do grupo",
  "access.ai.note.desc": "Contexto que você escreve para as pessoas que leem por este grupo. Chega ao chat, à Análise de IA e aos e-mails de relatório, e orienta o modelo, mas não concede nada.",
  "access.ai.note.label": "Nota",
  "access.ai.note.help": "Prosa simples: «esta equipe só olha a Amazon US», «um pedido conta quando é enviado». O que uma pergunta pode ler é decidido pelo arquivo de dados, então uma nota que peça algo fora do escopo simplesmente não retorna nada.",
  "access.ai.note.tooLong": "{n} caracteres, e o limite é {max}. Nada é cortado por você: esta nota é adicionada inteira a cada Prompt que as pessoas deste grupo acionam, então meia frase iria junto. Encurte e salve.",
  "access.ai.note.sharedTitle": "Onde mais esta nota é lida",
  "access.ai.note.shared": "A Análise de IA é armazenada por ESCOPO, não por grupo, então dois grupos com o mesmo escopo leem um parágrafo escrito com as duas notas juntas. No chat e no e-mail de uma pessoa, cada leitor recebe as notas dos seus próprios grupos.",
  "access.ai.reach.title": "Até onde o chat alcança",
  "access.ai.reach.desc": "Não é uma configuração. O chat lê o mesmo arquivo que o escopo de quem pergunta abre, então o alcance é o escopo e nada nesta página pode ampliá-lo.",
  "access.ai.reach.projectWide": "Perguntas sobre um projeto inteiro",
  "access.ai.reach.projectWideBody": "Oferecidas automaticamente em projetos com dois ou mais relatórios publicados, para todo o cliente. Hoje não há interruptor por grupo para isso, por isso esta aba não mostra um.",
  "access.ai.examples.title": "Exemplos de treinamento retidos para este escopo",
  "access.ai.examples.desc": "Um exemplo é retido de um escopo restrito, a menos que seu autor o tenha marcado como seguro. O corpus que já existe começa retido, de propósito: um exemplo que cita números reais do México os ensinaria a um grupo que só vê os Estados Unidos.",
  "access.ai.examples.unknown": "contagem desconhecida",
  "access.ai.examples.unknownHint": "Nenhum endpoint de leitura retorna a marca de seguro para escopos restritos, então ninguém pode contá-los daqui. Um zero diria que nada está sendo retido, o oposto do padrão.",
  "access.ai.examples.body": "O número é gravado no log do chat a cada resposta restrita. A marca que deixa um exemplo passar é report_training.scope_safe, e o builder é quem vai gravá-la: nenhum editor a expõe ainda.",
  "access.ai.verbosity.title": "Qual o tamanho das respostas",
  "access.ai.verbosity.desc": "Não há configuração de tamanho por grupo.",
  "access.ai.verbosity.body": "O único controle de tamanho do produto (curto, médio ou longo) pertence ao envio automático que uma pessoa configura para si no portal, e cabe a ela escolher. Um controle por grupo aqui gravaria uma configuração que nada lê.",
  "access.ai.cost.title": "Custo da Análise de IA por escopo",
  "access.ai.cost.tenantDesc": "Todos os projetos deste cliente, na cadência de recarga que você informar. Os valores por mês são aritmética sobre um mês que não aconteceu; a coluna medida é uma contagem simples das análises realmente gravadas nos últimos 30 dias.",
  "access.ai.cost.beforeTitle": "O que custa ativá-la",
  "access.ai.cost.beforeBody": "Mais um escopo nos projetos em que o escopo deste grupo tem arquivo. O valor é o mesmo nas duas direções: desativada, é o que você adicionaria; ativada, é o que você economizaria.",
  "access.ai.cost.unrestricted": "Este grupo carrega o escopo sem restrição, então o interruptor não acrescenta nada: a análise sem restrição já é gerada para todos os projetos, e é a que seus membros leem.",
  "access.ai.cost.runs": "Recargas por mês",
  "access.ai.cost.runsHelp": "Quantas vezes por mês estes projetos recarregam seus dados: 4 para uma carga semanal, cerca de 30 para uma noturna. Não tem padrão porque a análise é regenerada quando os dados mudam, não por calendário, e só você conhece essa programação.",
  "access.ai.cost.runsRange": "Um número inteiro entre {min} e {max}. Nada é presumido por você.",
  "access.ai.cost.compute": "Estimar",
  "access.ai.cost.notYet": "Preencha as recargas por mês para ver o valor. Até então não há nenhum: uma cadência inventada transformaria um palpite em número na tela.",
  "access.ai.cost.adds": "Ativá-la acrescenta cerca de {n} gerações de Análise de IA por mês.",
  "access.ai.cost.saves": "Desativá-la economiza cerca de {n} gerações de Análise de IA por mês.",
  "access.ai.cost.tenantTotal": "Cerca de {n} gerações de Análise de IA por mês em todos os projetos.",
  "access.ai.cost.partial": "Parcial: {n} projeto(s) não puderam ser estimados e não entram no total.",
  "access.ai.cost.alreadyGenerating": "Este escopo já recebe uma análise em: {projects}. Ali a parte dele no custo já está sendo gasta, por este grupo ou por outro que carrega o mesmo escopo.",
  "access.ai.cost.basis.estimate": "estimativa",
  "access.ai.cost.col.project": "Projeto",
  "access.ai.cost.col.reports": "Relatórios com análise",
  "access.ai.cost.col.scopes": "Escopos que recebem uma",
  "access.ai.cost.col.perMonth": "Por mês",
  "access.ai.cost.col.measured": "Gravadas em 30 dias",
  "access.ai.cost.unavailable": "não estimado",
  "access.ai.cost.unavailableHint": "A estimativa deste projeto não voltou. O motivo está abaixo da tabela, completo. Um zero aqui seria uma resposta real e diferente.",
  "access.ai.cost.failedTitle": "Não foi possível estimar «{project}»",
  "access.ai.cost.projectsFailedTitle": "Não foi possível ler a lista de projetos",
  "access.ai.cost.noProjects": "O escopo deste grupo não tem arquivo em nenhum projeto, então não há nada para narrar sob ele.",
  "access.ai.cost.noProjectsTenant": "Este cliente não tem projetos.",
  "access.experience.grantsNothingTitle": "Nada nesta aba concede algo",
  "access.experience.grantsNothing": "Um cartão entregue a um membro continua sendo resolvido contra as permissões e o escopo dele a cada leitura, e volta negado quando ele não pode abri-lo. Esta aba define com o que uma pessoa COMEÇA, nunca o que ela pode ver.",
  "access.experience.save": "Salvar o perfil",
  "access.experience.clear": "Limpar o perfil",
  "access.experience.board.title": "Modelo do board de Início",
  "access.experience.board.desc": "Como o Início de um membro aparece na primeira vez que ele o abre. Quando o modelo muda, o board dele é ressincronizado, e um cartão que ele mesmo adicionou nunca é tocado.",
  "access.experience.board.resync": "Ressincronizar os boards dos membros",
  "access.experience.board.resyncHelp": "Ativado: os cartões do grupo são substituídos a cada leitura do board e tudo o que a pessoa adicionou permanece. Desativado: o modelo é aplicado uma vez, quando a pessoa ainda não tem board, e nunca mais.",
  "access.experience.board.document": "Cartões, em JSON",
  "access.experience.board.documentHelp": "Um array de objetos de widget, no mesmo formato de um board de Início salvo. No máximo {max}, cada um com seu próprio id, e sem cartões de imagem: uma imagem pertence aos arquivos carregados por uma pessoa e ficaria quebrada para todos os outros. O builder não tem canvas de board, então o modelo é editado como o documento que é; a pré-visualização abaixo é o posicionamento real.",
  "access.experience.board.count": "{n} de {max} cartões.",
  "access.experience.board.overCapTitle": "Cartões demais",
  "access.experience.board.overCap": "O portal recusa um board com mais de {max} cartões, então nada aqui é cortado para caber: retire alguns e salve novamente.",
  "access.experience.board.badJson": "Isto não é um JSON válido: {detail}",
  "access.experience.board.notAnArray": "O documento precisa ser um array de cartões, mesmo quando tem apenas um.",
  "access.experience.board.notAnObject": "O item {position} não é um objeto. Todo cartão é um objeto de widget.",
  "access.experience.board.layoutError": "Este layout não pode ser posicionado",
  "access.experience.board.preview": "Pré-visualização",
  "access.experience.board.previewHelp": "Doze colunas, na ordem do array, o mesmo posicionamento que o board do membro usa, incluindo o estiramento vertical.",
  "access.experience.board.previewEmpty": "Nenhum cartão ainda.",
  "access.experience.board.noTiles": "Nenhum cartão no modelo. Um membro sem modelo recebe um Início vazio e monta o seu próprio.",
  "access.experience.board.col.position": "#",
  "access.experience.board.positionHint": "O índice que as recusas do servidor nomeiam: «cartão 2 do modelo de board».",
  "access.experience.board.col.kind": "Tipo",
  "access.experience.board.col.title": "Título",
  "access.experience.board.col.source": "Relatório ou projeto",
  "access.experience.board.col.size": "Tamanho",
  "access.experience.board.col.id": "Id",
  "access.experience.board.noTitle": "sem título",
  "access.experience.board.noKind": "sem tipo",
  "access.experience.board.noKindHint": "Um cartão sem tipo não pode ser lido pelo esquema de widgets do portal, e o modelo inteiro do grupo será recusado.",
  "access.experience.board.noId": "sem id",
  "access.experience.board.noIdHint": "O id é o que diz ao board de um membro quais cartões vieram do grupo e quais ele mesmo adicionou. Sem ele, o cartão não pode ser ressincronizado nem separado dos dele.",
  "access.experience.board.badSize": "tamanho inválido",
  "access.experience.board.badSizeHint": "Largura e altura precisam ser números: 1 a 12 colunas, 1 a 40 linhas.",
  "access.experience.mail.title": "E-mail padrão",
  "access.experience.mail.desc": "O plano dá a um grupo um relatório agendado que todo membro recebe. Não é configurado aqui, porque nada o envia ainda.",
  "access.experience.mail.body": "A coluna pode guardar um modelo de e-mail e o servidor ainda valida um, mas nenhum código grava a linha de agendamento de um membro a partir dele, o que exige uma coluna de origem na tabela de agendamentos, junto à API de agendamentos do portal. Por isso não há formulário aqui. Um formulário permitiria definir um cron, ler um sucesso e acreditar que algo foi agendado, e um aviso acima dele não desfaz isso. Enquanto o gravador não existir, o que as pessoas recebem é o agendamento que elas mesmas configuram no portal. Uma coisa o esquema já define: um modelo de grupo não tem lista de destinatários e não pode ter, porque um padrão de grupo é renderizado uma vez por membro, sob o escopo desse membro, e endereçado a ele, então não há como expressar «enviar o relatório deste grupo para outra pessoa».",
  "access.experience.mail.storedTitle": "Este grupo tem um modelo de e-mail armazenado",
  "access.experience.mail.stored": "Alguém escreveu um na coluna manualmente. Ele é mantido exatamente como está quando você salva esta aba, e continua sem ser entregue a ninguém. «Limpar o perfil» o remove junto com o modelo de board.",
  "access.experience.threshold.title": "Alertas de limite",
  "access.experience.threshold.desc": "Não é uma configuração de grupo, e não pode ser.",
  "access.experience.threshold.body": "Um alerta de limite carrega estado por linha (a última versão que viu, se já disparou), e isso só faz sentido em um agendamento que uma pessoa escreveu e pode editar, por isso vive no agendamento dessa pessoa e não aqui. O que o Plano J acrescentou é que, quando um deles dispara, lê o arquivo de escopo do dono, então o número que compara é um que o dono tem direito de ver.",
  // Tarefas: a bandeira da tabela compartilhada (só no portal).
  "tasks.mark.flag": "Reportar",
  "tasks.mark.reported": "Reportado",
  "tasks.mark.resolved": "Resolvido",
  "tasks.mark.column": "Relato",
  "tasks.mark.wholeChart": "O gráfico inteiro",
  "tasks.mark.pickPoint": "Escolher um ponto",
  "tasks.mark.pickHint": "Clique no ponto que você quer relatar",
  "tasks.mark.pickCancel": "Cancelar (Esc)",
};
